'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var dateFns = require('date-fns');
var lodash = require('lodash');
var Cookies = require('universal-cookie');
var Sentry = require('@sentry/react');
var tracing = require('@sentry/tracing');
var constate = require('constate');
var react = require('react');
var reactRouterDom = require('react-router-dom');
var arLocale = require('date-fns/locale/ar-SA');
var enUsLocale = require('date-fns/locale/en-US');
var esLocale = require('date-fns/locale/es');
var faIrLocale = require('date-fns/locale/fa-IR');
var frLocale = require('date-fns/locale/fr');
var hiLocale = require('date-fns/locale/hi');
var htLocale = require('date-fns/locale/ht');
var huLocale = require('date-fns/locale/hu');
var koLocale = require('date-fns/locale/ko');
var nlLocale = require('date-fns/locale/nl');
var plLocale = require('date-fns/locale/pl');
var ptLocale = require('date-fns/locale/pt');
var ruLocale = require('date-fns/locale/ru');
var ukLocale = require('date-fns/locale/uk');
var viLocale = require('date-fns/locale/vi');
var zhCnLocale = require('date-fns/locale/zh-CN');
var zhTwLocale = require('date-fns/locale/zh-TW');
var buildFormatLongFn = require('date-fns/locale/_lib/buildFormatLongFn');
var buildLocalizeFn = require('date-fns/locale/_lib/buildLocalizeFn');
var buildLocalizeFn$1 = require('date-fns/locale/_lib/buildLocalizeFn/index');
var queryString = require('query-string');
var jsxRuntime = require('react/jsx-runtime');
var reactQuery = require('react-query');
var context = require('launchdarkly-react-client-sdk/lib/context');
var launchdarklyReactClientSdk = require('launchdarkly-react-client-sdk');
var dateFnsTz = require('date-fns-tz');
var polyfill = require('@js-temporal/polyfill');
var pluralize = require('pluralize');
var Yup = require('yup');
var reactTextMask = require('react-text-mask');
var asyncRetry = require('async-retry');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var Cookies__default = /*#__PURE__*/_interopDefaultLegacy(Cookies);
var Sentry__namespace = /*#__PURE__*/_interopNamespace(Sentry);
var constate__default = /*#__PURE__*/_interopDefaultLegacy(constate);
var arLocale__default = /*#__PURE__*/_interopDefaultLegacy(arLocale);
var enUsLocale__default = /*#__PURE__*/_interopDefaultLegacy(enUsLocale);
var esLocale__default = /*#__PURE__*/_interopDefaultLegacy(esLocale);
var faIrLocale__default = /*#__PURE__*/_interopDefaultLegacy(faIrLocale);
var frLocale__default = /*#__PURE__*/_interopDefaultLegacy(frLocale);
var hiLocale__default = /*#__PURE__*/_interopDefaultLegacy(hiLocale);
var htLocale__default = /*#__PURE__*/_interopDefaultLegacy(htLocale);
var huLocale__default = /*#__PURE__*/_interopDefaultLegacy(huLocale);
var koLocale__default = /*#__PURE__*/_interopDefaultLegacy(koLocale);
var nlLocale__default = /*#__PURE__*/_interopDefaultLegacy(nlLocale);
var plLocale__default = /*#__PURE__*/_interopDefaultLegacy(plLocale);
var ptLocale__default = /*#__PURE__*/_interopDefaultLegacy(ptLocale);
var ruLocale__default = /*#__PURE__*/_interopDefaultLegacy(ruLocale);
var ukLocale__default = /*#__PURE__*/_interopDefaultLegacy(ukLocale);
var viLocale__default = /*#__PURE__*/_interopDefaultLegacy(viLocale);
var zhCnLocale__default = /*#__PURE__*/_interopDefaultLegacy(zhCnLocale);
var zhTwLocale__default = /*#__PURE__*/_interopDefaultLegacy(zhTwLocale);
var buildFormatLongFn__default = /*#__PURE__*/_interopDefaultLegacy(buildFormatLongFn);
var buildLocalizeFn__default = /*#__PURE__*/_interopDefaultLegacy(buildLocalizeFn);
var buildLocalizeFn__default$1 = /*#__PURE__*/_interopDefaultLegacy(buildLocalizeFn$1);
var queryString__default = /*#__PURE__*/_interopDefaultLegacy(queryString);
var pluralize__default = /*#__PURE__*/_interopDefaultLegacy(pluralize);
var Yup__namespace = /*#__PURE__*/_interopNamespace(Yup);
var asyncRetry__default = /*#__PURE__*/_interopDefaultLegacy(asyncRetry);

function AddressFactory(extraProps) {
    return {
        id: 1,
        full_name: 'Bilbo Baggins',
        line1: '123 Underhill Way',
        city: 'The Shire',
        state: 'MA',
        postal_code: '00100',
        country: 'US',
        phone_country: 'US',
        phone_number: '9876543210',
        ...extraProps,
    };
}

/**
 * Returns an object that matches the `IAddress` interface, even if
 * not all required properties are specified.
 *
 * FIXME: This matches the behavior of the Address model constructor the
 * `IAddress` interface is replacing. There may be merit in splitting the
 * interface into two for more type safety - one that requires full_name, and
 * one that makes it optional.
 *
 */
function createAddressFromPartialValues(partialValues) {
    return {
        full_name: '',
        line1: '',
        city: '',
        state: '',
        postal_code: '',
        // SUPPORT-19535 Non-empty country value required.
        country: 'US',
        ...partialValues,
    };
}

const ADULT_MINIMUM_AGE = 18;
const INDEPENDENT_MINOR_MINIMUM_AGE = 13;

function calculateAge(birthday) {
    return dateFns.differenceInYears(new Date(), birthday);
}
function hasMinimumAge(birthday, minimumAgeInYears) {
    return calculateAge(birthday) >= minimumAgeInYears;
}
function isAdult(birthday) {
    return hasMinimumAge(birthday, ADULT_MINIMUM_AGE);
}

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};

function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

// Note that these string values are used to categorize Sentry errors (see lib/util/monitoring)
// Do not change the string values!
exports.Environment = void 0;
(function (Environment) {
    Environment["LOCAL"] = "local";
    Environment["STAGING"] = "staging";
    Environment["TESTING"] = "testing";
    Environment["CYPRESS_TEST"] = "cypress_test";
    Environment["EPHEMERAL"] = "ephemeral";
    Environment["PRODUCTION"] = "production";
    Environment["UNKNOWN"] = "unknown";
})(exports.Environment || (exports.Environment = {}));

const LOCAL_HOSTNAMES = ['localhost', '127.0.0.1'];
const STAGING_HOSTNAMES = [
    'staging.color.com',
    'home.staging.color.com',
    'home.use1-a.eks.staging.color.com',
    'clinical.staging.color.com',
    'genomics-stb.joinallofus.org',
    'gp-staging.use1-a.eks.staging.color.com',
    'rhp-staging.use1-a.eks.staging.color.com',
    'aou-pdf.use1-a.eks.staging.color.com',
    'color-hub.use1-a.eks.staging.color.com',
    'hub.staging.color.com',
];
const TESTING_HOSTNAMES = ['gp-testing.use1-a.eks.staging.color.com'];
const PRODUCTION_HOSTNAMES = [
    'home.color.com',
    'home.use1-a.eks.color.com',
    'clinical.color.com',
    'genomics.joinallofus.org',
    'joinallofus.org',
    'rhp.aou.color.com',
    'aou-pdf.use1-a.eks.color.com',
    'hub.color.com',
];

function isEnvironmentLocal() {
    return LOCAL_HOSTNAMES.includes(window.location.hostname);
}
function isEnvironmentStaging() {
    return STAGING_HOSTNAMES.includes(window.location.hostname);
}
function isEnvironmentTesting() {
    return TESTING_HOSTNAMES.includes(window.location.hostname);
}
function isEnvironmentProduction() {
    return PRODUCTION_HOSTNAMES.includes(window.location.hostname);
}
function isEnvironmentEphemeral() {
    return (window.location.hostname.startsWith('ephemeral-') &&
        window.location.hostname.endsWith('.use1-a.eks.color.dev'));
}
function isEnvironmentLocalAndDevelopment() {
    // eslint-disable-next-line no-underscore-dangle
    return isEnvironmentLocal() && window.__ENV__ === 'development';
}
function isEnvironmentCypressTest() {
    return isEnvironmentLocal() && window.Cypress !== undefined;
}
/**
 * Returns the environment based on the hostname. Useful for enabling functionality (i.e. different log levels, tooling, etc),
 * targeting different API hosts, and initializing 3rd party libraries based on the environment. If hostname is unknown, will
 * return Environment.UNKNOWN.
 *
 * @returns {Environment} The current environment
 */
function getEnvironment() {
    if (isEnvironmentCypressTest()) {
        return exports.Environment.CYPRESS_TEST;
    }
    if (isEnvironmentLocal()) {
        return exports.Environment.LOCAL;
    }
    if (isEnvironmentStaging()) {
        return exports.Environment.STAGING;
    }
    if (isEnvironmentTesting()) {
        return exports.Environment.TESTING;
    }
    if (isEnvironmentProduction()) {
        return exports.Environment.PRODUCTION;
    }
    if (isEnvironmentEphemeral()) {
        return exports.Environment.EPHEMERAL;
    }
    return exports.Environment.UNKNOWN;
}
/**
 * Returns the environment based on the hostname. Useful for enabling functionality (i.e. different log levels, tooling, etc),
 * targeting different API hosts, and initializing 3rd party libraries based on the environment. If hostname is unknown, will
 * return `defaultEnv`.
 *
 * @returns {Environment} The current environment
 */
function getEnvironmentOrDefault(defaultEnv) {
    if (isEnvironmentLocal()) {
        return exports.Environment.LOCAL;
    }
    if (isEnvironmentStaging()) {
        return exports.Environment.STAGING;
    }
    if (isEnvironmentTesting()) {
        return exports.Environment.TESTING;
    }
    if (isEnvironmentProduction()) {
        return exports.Environment.PRODUCTION;
    }
    return defaultEnv;
}

function getTracesSampleRate(environment) {
    // Only report a fraction of production transaction traces to Sentry itself.
    //
    // Sentry has a quota of "performance units" for measuring FE performance. We
    // don't really use this feature at present, but it's nice to have the data.
    // When tracing at 20%, we use a bit more than 100k units a month (& get warned at 80k).
    // We don't frequently use Sentry for analyzing performance, but for the rare cases we
    // do, it's only necessary to collect a small sample of data.
    const prodTracesSampleRate = 0.1;
    const nonProdTracesSampleRate = 1.0;
    return environment === exports.Environment.PRODUCTION ? prodTracesSampleRate : nonProdTracesSampleRate;
}
const COLOR_ERROR_ID_CHARACTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
/**
 * Sentry does generate a unique id, but it is too long for users to relay back to us.
 * This generates a simple text string.
 * @returns a reasonably unique and human readable string.
 */
const getRandomErrorId = () => {
    let errorId = '';
    for (let i = 0; i < 6; i += 1) {
        if (i !== 0 && i % 2 === 0) {
            errorId += '-';
        }
        errorId +=
            COLOR_ERROR_ID_CHARACTERS[Math.floor(Math.random() * COLOR_ERROR_ID_CHARACTERS.length)];
    }
    return errorId;
};
let latestColorErrorId = '';
function getLatestSentryEventId() {
    return latestColorErrorId;
}
function initSentry(environment, config) {
    const { dsn } = config;
    if (!dsn) {
        // eslint-disable-next-line no-console
        console.warn('Unable to determine Sentry DSN');
        return;
    }
    const sentryOptions = {
        ...config,
        environment, // `local`, `staging`, `testing`, `production`, or `unknown`
        integrations: [new tracing.Integrations.BrowserTracing()],
        denyUrls: [/cdn\.cookielaw\.org/i], // Removed cookie consent dialog on the sites, but leaving this in case we add it back
        tracesSampleRate: getTracesSampleRate(environment),
        beforeSend: (event) => {
            const colorErrorId = getRandomErrorId();
            // Sentry seems to be providing an entirely different `eventId` to the ErrorBoundary Fallback than `event.event_id`
            // Unfortunately, there doesn't seem to be a reliable value that we can use.
            // Instead, capture the latest generated error id for use in the UI.
            latestColorErrorId = colorErrorId;
            return {
                ...event,
                tags: {
                    ...event.tags,
                    colorErrorId,
                },
            };
        },
    };
    Sentry__namespace.init(sentryOptions);
}
let monitoringIsInitialized = false;
function initMonitoring(monitoringConfig) {
    if (monitoringIsInitialized) {
        return;
    }
    monitoringIsInitialized = true;
    const { environment, sentryConfig } = monitoringConfig;
    initSentry(environment, sentryConfig);
}
function getInstrumentedApp(App, monitoringConfig) {
    initMonitoring(monitoringConfig);
    return Sentry__namespace.withProfiler(App);
}

class ApiError extends Error {
    constructor(errorPayload) {
        super(errorPayload.message);
        this.name = 'API Response Error';
        this.status = errorPayload.status;
        this.details = lodash.omit(errorPayload, ['message', 'status']);
    }
}

function captureException(error, otherProps) {
    Sentry__namespace.captureException(error, { level: 'error', ...otherProps });
}
function captureMessage(message, otherProps) {
    Sentry__namespace.captureMessage(message, { level: 'info', ...otherProps });
}

const loggerUtils = {
    logMessageToConsole(message, ...optionalParameters) {
        // eslint-disable-next-line no-console
        console.log(message, ...optionalParameters);
    },
    logToConsole(error, extra) {
        // eslint-disable-next-line no-console
        console.error(error, extra);
    },
    logException(error, otherProps) {
        // eslint-disable-next-line no-console
        console.error(error, otherProps);
        if (!(error instanceof ApiError)) {
            captureException(error, {
                ...otherProps,
            });
        }
    },
    logMessage(error, otherProps) {
        // eslint-disable-next-line no-console
        console.log(error, otherProps);
        captureMessage(error.message, {
            ...otherProps,
        });
    },
};

/**
 * Tracking event type
 */
var EventType;
(function (EventType) {
    EventType["IDENTIFY"] = "identify";
    EventType["PAGE"] = "page";
    EventType["RESET"] = "reset";
    EventType["TRACK"] = "track";
})(EventType || (EventType = {}));

// Override the user's current IP address for every API call
const ANONYMOUS_IP_ADDRESS = '0.0.0.0';
const cookies = new Cookies__default["default"]();
const internalState = {
    sessionStart: -1,
    sessionDeviceId: '',
};
const getDeviceId = () => {
    const getDeviceIdFromLocalStorage = (localStorage) => {
        const existingDeviceId = localStorage.getItem('amplitudeDeviceId');
        if (existingDeviceId) {
            return existingDeviceId;
        }
        const newDeviceId = String(v4());
        localStorage.setItem('amplitudeDeviceId', newDeviceId);
        return newDeviceId;
    };
    const getDeviceIdFromMemory = () => {
        if (!internalState.sessionDeviceId) {
            internalState.sessionDeviceId = String(v4());
        }
        return internalState.sessionDeviceId;
    };
    let localStorage;
    try {
        localStorage = window.localStorage;
    }
    catch {
        // If localStorage is not available, just create and/or use the device ID in memory
    }
    if (localStorage) {
        return getDeviceIdFromLocalStorage(localStorage);
    }
    return getDeviceIdFromMemory();
};
const getSegmentSessionId = () => {
    if (internalState.sessionStart < 0) {
        internalState.sessionStart = Math.round(Date.now());
    }
    return internalState.sessionStart;
};
const getMarketingCookies = () => {
    const data = lodash.pickBy({
        source: cookies.get('utm_source'),
        medium: cookies.get('utm_medium'),
        term: cookies.get('utm_term'),
        content: cookies.get('utm_content'),
        name: cookies.get('utm_campaign'),
    }, lodash.identity);
    return lodash.isEmpty(data) ? undefined : data;
};
/**
 * Wrapper for Segment's user().traits() method, which returns the Segment user's
 * persistent traits from localStorage.
 */
const getSegmentPersistentTraits = () => {
    if (typeof window.analytics === 'undefined') {
        return undefined;
    }
    // The following checks are here because, for some reason, window.analytics.user()
    // isn't available in Cypress tests.
    if (typeof window.analytics.user !== 'function') {
        return undefined;
    }
    const user = window.analytics.user();
    if (typeof user.traits !== 'function') {
        return undefined;
    }
    return user.traits();
};
/**
 * Gets the user's Braze ID. This is a unique identifier for the user that is added to
 * email links by Braze as the bid query parameter. This function attempts to find the
 * ID either in the bid query parameter or in the Segment user's persistent traits.
 */
const getBrazeId = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const brazeId = urlParams.get('bid');
    if (brazeId) {
        return brazeId;
    }
    const traits = getSegmentPersistentTraits();
    if (!traits) {
        return undefined;
    }
    return traits.braze_id;
};
const getTraitsForContext = () => {
    const brazeId = getBrazeId();
    if (brazeId) {
        return {
            braze_id: brazeId,
        };
    }
    return undefined;
};
const getSegmentContext = () => {
    return lodash.pickBy({
        campaign: getMarketingCookies(),
        ip: ANONYMOUS_IP_ADDRESS,
        device: {
            id: getDeviceId(),
        },
        traits: getTraitsForContext(),
    }, lodash.identity);
};
/**
 * Makes a request to Segment, if available.
 *
 * TODO: Define a TS type over the Segment API.
 * @see https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/
 */
// tslint:disable-next-line no-any
const sendCommand = (command, ...args) => {
    if (isEnvironmentLocalAndDevelopment()) {
        loggerUtils.logMessageToConsole('segment:', command, ...args);
    }
    if (typeof window.analytics !== 'undefined') {
        window.analytics[command](...args);
    }
};
/**
 * Returns the properties that should be sent to Segment.
 *
 * <p>Augments the given properties so Segment has enough information.
 * @param properties Properties that callers want to send to Segment
 */
const getSegmentProperties = (properties) => {
    return {
        ...(properties || {}),
        color_session_id: getSegmentSessionId(),
    };
};
/**
 * Identifies the user based on their patient ID.
 *
 * <p>The user is identified by their patient ID because it's not considered PHI and can be used to
 * correlate tracking events back to the user in the internal data warehouse.
 * @param props Patient properties, including information to set Segment traits.
 * @see https://getcolor.atlassian.net/browse/DATAPLAT-347
 * @see https://docs.google.com/document/d/1v1r8ImmFupQX0sj0DC2oRq-qr859CUw01AvT0a-kveU
 * @see https://segment.com/docs/connections/spec/identify/
 */
const identifySegmentUser = (props) => {
    const { isColorEmployee = false, patientId, properties } = props;
    const brazeId = getBrazeId();
    const segmentProperties = {
        ...getSegmentProperties(properties),
        ...(brazeId ? { braze_id: brazeId } : {}),
    };
    sendCommand(
    /* command */ EventType.IDENTIFY, 
    /* userId */ patientId, 
    /* traits */ {
        is_color_employee: isColorEmployee,
        ...segmentProperties,
    }, 
    /* options */ { context: getSegmentContext() });
};
/**
 * Resets the id, including anonymousId, and clears traits for the currently identified user and
 * group.
 */
const resetSegmentUser = () => {
    sendCommand(EventType.RESET, {});
    internalState.sessionStart = -1;
    internalState.sessionDeviceId = '';
};
/**
 * Logs a page view to Segment.
 * @param name An optional name for the page
 * @param properties An optional set of properties to include with this event
 */
const logSegmentPageView = (name, properties) => {
    sendCommand(
    /* command */ EventType.PAGE, 
    /* category */ undefined, 
    /* name */ name, 
    /* properties */ getSegmentProperties(properties), 
    /* options */ {
        context: getSegmentContext(),
    });
};
/**
 * Logs an event to Segment.
 * @param event The event name
 * @param properties An optional set of properties to include with this event,
 *   describing perhaps the user who performed the event, or the event itself
 */
const trackSegmentEvent = (event, properties = {}) => {
    sendCommand(
    /* command */ EventType.TRACK, 
    /* event */ event, 
    /* properties */ getSegmentProperties(properties), 
    /* options */ {
        context: getSegmentContext(),
    });
};

/**
 * Tracks an event with all web analytics tools we use.
 * Wraps call in a 0-length timeout to force event logging
 * to occur after all rendering/loading has completed.
 * @param event The name of the event
 * @param properties Supporting event parameters (can be anything)
 */
const trackAnalyticsEvent = (event, properties = {}) => {
    setTimeout(() => {
        trackSegmentEvent(event, properties);
    }, 0);
};
/**
 * Identifies a previously unknown (logged-out) user for analytics purposes.
 * Wraps call in a 0-length timeout to force event logging
 * to occur after all rendering/loading has completed.
 * @param patientId The patient ID of the user to identify
 * @param isColorEmployee Define if the user is Color employee or not. This information is used to
 * set Segment traits.
 */
const identifyAnalyticsUser = (props) => {
    // Segment uses the patient ID as the user identifier, see the method documentation for more info
    setTimeout(() => {
        identifySegmentUser(props);
    }, 0);
};
/**
 * Clear user data for analytics purposes.
 * Wraps call in a 0-length timeout to force event logging
 * to occur after all rendering/loading has completed.
 */
const resetAnalyticsUser = () => {
    setTimeout(() => {
        resetSegmentUser();
    }, 0);
};
/**
 * Registers with analytics providers that the user has seen a page.
 * Wraps call in a 0-length timeout to force event logging
 * to occur after all rendering/loading has completed.
 * @param name Optional name for the page
 * @param properties Extra properties to attach to the log
 */
const logAnalyticsPageView = (name, properties) => {
    setTimeout(() => {
        logSegmentPageView(name, properties);
    }, 0);
};

/**
 * Context hook to keep track of the previous visited page and use it as the referrer.
 *
 * <p>This is used to know how the users are navigating between the SPA pages. The first referrer
 * is actually taken from {@code document.referrer}, but subsequent ones are the internal paths used
 * in the app.
 */
function useReferrer() {
    const { pathname, search } = reactRouterDom.useLocation();
    const path = `${pathname}${search}`;
    // We start the "current" path as the external referrer as it will be pushed to "previous" right
    // after rendering because of `useLayoutEffect`. This is to ensure `useEffect` hooks relying on
    // this value always see correct values (i.e., this hook runs before them).
    const currentPathRef = react.useRef(document.referrer);
    const previousPathRef = react.useRef('');
    /*
     * Reviewed by UX Programs (Jaz) as a valid `useEffect` or `useLayoutEffect` usage.
     * See https://getcolor.atlassian.net/browse/UXTASK-1406
     */
    // nosemgrep:semgrep-rules.ui-useEffect
    react.useLayoutEffect(() => {
        previousPathRef.current = currentPathRef.current;
        currentPathRef.current = path;
    }, [path]);
    return previousPathRef;
}
const [ReferrerProvider, useReferrerContext] = constate__default["default"](useReferrer);

// @ts-expect-error: implicitly has an 'any' type
const dateFormats$4 = {
    full: 'EEEE ፣d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y',
};
const timeFormats$3 = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm',
};
const dateTimeFormats$5 = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}',
};
const formatLong$5 = {
    date: buildFormatLongFn__default["default"]({
        formats: dateFormats$4,
        defaultWidth: 'full',
    }),
    time: buildFormatLongFn__default["default"]({
        formats: timeFormats$3,
        defaultWidth: 'full',
    }),
    dateTime: buildFormatLongFn__default["default"]({
        formats: dateTimeFormats$5,
        defaultWidth: 'full',
    }),
};

// @ts-expect-error: implicitly has an 'any' type
const defaultMonthValues$4 = [
    'ጃንዩወሪ',
    'ፌብሩወሪ',
    'ማርች',
    'ኤፕሪል',
    'ሜይ',
    'ጁን',
    'ጁላይ',
    'ኦገስት',
    'ሴፕቴምበር',
    'ኦክቶበር',
    'ኖቬምበር',
    'ዲሴምበር',
];
const abbreviatedMonthValues$1 = [
    'ጃንዩ',
    'ፌብሩ',
    'ማርች',
    'ኤፕሪ',
    'ሜይ',
    'ጁን',
    'ጁላይ',
    'ኦገስ',
    'ሴፕቴ',
    'ኦክቶ',
    'ኖቬም',
    'ዲሴም',
];
const monthValues$5 = {
    narrow: abbreviatedMonthValues$1,
    abbreviated: abbreviatedMonthValues$1,
    wide: defaultMonthValues$4,
};
const defaultDayValues$4 = ['እሑድ', 'ሰኞ', 'ማክሰኞ', 'ረቡዕ', 'ሐሙስ', 'ዓርብ', 'ቅዳሜ'];
const abbreviatedDayValues$1 = ['እሑድ', 'ሰኞ', 'ማክሰኞ', 'ረቡዕ', 'ሐሙስ', 'ዓርብ', 'ቅዳሜ'];
const dayValues$5 = {
    narrow: abbreviatedDayValues$1,
    short: abbreviatedDayValues$1,
    abbreviated: abbreviatedDayValues$1,
    wide: defaultDayValues$4,
};
const defaultDayPeriodValues$5 = {
    am: 'ጥዋት',
    pm: 'ከሰዓት',
    midnight: 'እኩለ ሌሊት',
    noon: 'ቀትር',
    morning: 'ጥዋት1',
    afternoon: 'ከሰዓት በኋላ',
    evening: 'ማታ',
    night: 'ሌሊት',
};
const abbreviatedDayPeriodValues$1 = {
    ...defaultDayPeriodValues$5,
    am: 'ጥዋት',
    pm: 'ከሰዓት',
};
const dayPeriodValues$5 = {
    narrow: abbreviatedDayPeriodValues$1,
    abbreviated: abbreviatedDayPeriodValues$1,
    wide: defaultDayPeriodValues$5,
};
const defaultFormattingDayPeriodValues$4 = {
    am: 'ጥዋት',
    pm: 'ከሰዓት',
    midnight: 'እኩለ ሌሊት',
    noon: 'ቀትር',
    morning: 'ጥዋት1',
    afternoon: 'ከሰዓት በኋላ',
    evening: 'ማታ',
    night: 'ሌሊት',
};
const abbreviatedFormattingDayPeriodValues$1 = {
    ...defaultFormattingDayPeriodValues$4,
    am: 'ጥዋት',
    pm: 'ከሰዓት',
};
const formattingDayPeriodValues$4 = {
    narrow: abbreviatedFormattingDayPeriodValues$1,
    abbreviated: abbreviatedFormattingDayPeriodValues$1,
    wide: defaultFormattingDayPeriodValues$4,
};
const localize$5 = {
    ordinalNumber: enUsLocale__default["default"].localize.ordinalNumber,
    era: enUsLocale__default["default"].localize.era,
    quarter: enUsLocale__default["default"].localize.quarter,
    month: buildLocalizeFn__default["default"]({
        values: monthValues$5,
        defaultWidth: 'wide',
    }),
    day: buildLocalizeFn__default["default"]({
        values: dayValues$5,
        defaultWidth: 'wide',
    }),
    dayPeriod: buildLocalizeFn__default["default"]({
        values: dayPeriodValues$5,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues$4,
        defaultFormattingWidth: 'wide',
    }),
};

/**
 * @type {Locale}
 * @category Locales
 * @summary Amharic locale.
 * @language Amharic
 */
const amLocale = {
    code: 'am',
    formatDistance: enUsLocale__default["default"].formatDistance,
    formatLong: formatLong$5,
    formatRelative: enUsLocale__default["default"].formatRelative,
    localize: localize$5,
    match: enUsLocale__default["default"].match,
    options: {
        weekStartsOn: 1 /* Monday */,
        firstWeekContainsDate: 1,
    },
};

// @ts-expect-error: implicitly has an 'any' type
const dateTimeFormats$4 = {
    full: "{{date}} 'sa' {{time}}",
    long: "{{date}} 'sa' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}',
};
const formatLong$4 = {
    date: enUsLocale__default["default"].formatLong.date,
    time: enUsLocale__default["default"].formatLong.time,
    dateTime: buildFormatLongFn__default["default"]({
        formats: dateTimeFormats$4,
        defaultWidth: 'full',
    }),
};

const formatRelativeLocale$1 = {
    lastWeek: "'noong nakaraang' eeee 'ng' p",
    yesterday: "'kahapon ng' p",
    today: "'ngayong ng' p",
    tomorrow: "'bukas ng' p",
    nextWeek: "'susunod na' eeee 'ng' p",
    other: 'P',
};
function formatRelative$1(token) {
    return formatRelativeLocale$1[token];
}

// @ts-expect-error: implicitly has an 'any' type
const monthValues$4 = {
    narrow: ['E', 'P', 'M', 'A', 'M', 'H', 'H', 'A', 'S', 'O', 'N', 'D'],
    abbreviated: ['Ene', 'Peb', 'Mar', 'Abr', 'May', 'Hun', 'Hul', 'Ago', 'Set', 'Okt', 'Nob', 'Dis'],
    wide: [
        'Enero',
        'Pebrero',
        'Marso',
        'Abril',
        'Mayo',
        'Hunyo',
        'Hulyo',
        'Agosto',
        'Setyembre',
        'Oktubre',
        'Nobyembre',
        'Disyembre',
    ],
};
const shortDayValues = ['Lin', 'Lun', 'Mar', 'Miy', 'Huw', 'Biy', 'Sab'];
const dayValues$4 = {
    narrow: ['Li', 'Lu', 'Ma', 'Mi', 'Hu', 'Bi', 'Sa'],
    short: shortDayValues,
    abbreviated: shortDayValues,
    wide: ['Linggo', 'Lunes', 'Martes', 'Miyerkules', 'Huwebes', 'Biyernes', 'Sabado'],
};
const defaultFormattingDayPeriodValues$3 = {
    am: 'AM',
    pm: 'PM',
    midnight: 'ng hatinggabi',
    noon: 'ng tanghali',
    morning: 'ng umaga',
    afternoon: 'ng hapon',
    evening: 'ng gabi',
    night: 'ng gabi',
};
const formattingDayPeriodValues$3 = {
    narrow: {
        ...defaultFormattingDayPeriodValues$3,
        am: 'A',
        pm: 'P',
    },
    abbreviated: defaultFormattingDayPeriodValues$3,
    wide: defaultFormattingDayPeriodValues$3,
};
const defaultDayPeriodValues$4 = {
    am: 'AM',
    pm: 'PM',
    midnight: 'hatinggabi',
    noon: 'tanghali',
    morning: 'umaga',
    afternoon: 'hapon',
    evening: 'gabi',
    night: 'gabi',
};
const dayPeriodValues$4 = {
    narrow: {
        ...defaultDayPeriodValues$4,
        am: 'A',
        pm: 'P',
    },
    abbreviated: defaultDayPeriodValues$4,
    wide: defaultDayPeriodValues$4,
};
function ordinalNumber(dirtyNumber) {
    const number = Number(dirtyNumber);
    return `ika-${number}`;
}
const localize$4 = {
    ordinalNumber,
    era: enUsLocale__default["default"].localize.era,
    quarter: enUsLocale__default["default"].localize.quarter,
    month: buildLocalizeFn__default$1["default"]({
        values: monthValues$4,
        defaultWidth: 'wide',
    }),
    day: buildLocalizeFn__default$1["default"]({
        values: dayValues$4,
        defaultWidth: 'wide',
    }),
    dayPeriod: buildLocalizeFn__default$1["default"]({
        values: dayPeriodValues$4,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues$3,
        defaultFormattingWidth: 'wide',
    }),
};

/**
 * Filipino locale adapted from date-fns v2.28.0. This locale is not supported
 * in v2.29.3
 * See https://github.com/date-fns/date-fns/tree/v2.28.0/src/locale/fil
 * @type {Locale}
 * @category Locales
 * @summary Filipino locale.
 * @language Filipino
 * @iso-639-2 fil
 * @author Ian De La Cruz [@RIanDeLaCruz]{@link https://github.com/RIanDeLaCruz}
 */
const filLocale = {
    code: 'fil',
    formatDistance: enUsLocale__default["default"].formatDistance,
    formatLong: formatLong$4,
    formatRelative: formatRelative$1,
    localize: localize$4,
    match: enUsLocale__default["default"].match,
    options: {
        weekStartsOn: 0 /* Sunday */,
        firstWeekContainsDate: 1,
    },
};

// @ts-expect-error: implicitly has an 'any' type
const dateFormats$3 = {
    full: "EEEE, d 'di' MMMM 'di' yyyy",
    long: "d 'di' MMMM 'di' yyyy",
    medium: "d 'di' MMM 'di' yyyy",
    short: 'd/MM/yyyy',
};
const timeFormats$2 = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm',
};
const dateTimeFormats$3 = {
    full: "{{date}} 'na' {{time}}",
    long: "{{date}} 'na' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}',
};
const formatLong$3 = {
    date: buildFormatLongFn__default["default"]({
        formats: dateFormats$3,
        defaultWidth: 'full',
    }),
    time: buildFormatLongFn__default["default"]({
        formats: timeFormats$2,
        defaultWidth: 'full',
    }),
    dateTime: buildFormatLongFn__default["default"]({
        formats: dateTimeFormats$3,
        defaultWidth: 'full',
    }),
};

// @ts-expect-error: implicitly has an 'any' type
const defaultMonthValues$3 = [
    'Janeru',
    'Fevereru',
    'Marsu',
    'Abril',
    'Maiu',
    'Junhu',
    'Julhu',
    'Agostu',
    'Sitenbru',
    'Otubru',
    'Novenbru',
    'Dizenbru',
];
const abbreviatedMonthValues = [
    'Jan.',
    'Fev.',
    'Marsu',
    'Abril',
    'Maiu',
    'Junhu',
    'Julhu',
    'Ago.',
    'Sit.',
    'Otu.',
    'Nov.',
    'Diz.',
];
const monthValues$3 = {
    narrow: abbreviatedMonthValues,
    abbreviated: abbreviatedMonthValues,
    wide: defaultMonthValues$3,
};
const defaultDayValues$3 = [
    'Dumingu',
    'Sigunda-fera',
    'Tersa-fera',
    'Kuarta-fera',
    'Kinta-fera',
    'Sesta-fera',
    'Sabadu',
];
const abbreviatedDayValues = ['Dum', 'Sig', 'Ter', 'Kua', 'Kin', 'Ses', 'Sab'];
const dayValues$3 = {
    narrow: abbreviatedDayValues,
    short: abbreviatedDayValues,
    abbreviated: abbreviatedDayValues,
    wide: defaultDayValues$3,
};
const defaultDayPeriodValues$3 = {
    am: 'di sedu',
    pm: 'di tardi',
    midnight: 'meia noti',
    noon: 'meiu dia',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night',
};
const abbreviatedDayPeriodValues = {
    ...defaultDayPeriodValues$3,
    am: 'SEDU',
    pm: 'TARDI',
};
const dayPeriodValues$3 = {
    narrow: abbreviatedDayPeriodValues,
    abbreviated: abbreviatedDayPeriodValues,
    wide: defaultDayPeriodValues$3,
};
const defaultFormattingDayPeriodValues$2 = {
    am: 'di sedu',
    pm: 'di tardi',
    midnight: 'meia noti',
    noon: 'meiu dia',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night',
};
const abbreviatedFormattingDayPeriodValues = {
    ...defaultFormattingDayPeriodValues$2,
    am: 'SEDU',
    pm: 'TARDI',
};
const formattingDayPeriodValues$2 = {
    narrow: abbreviatedFormattingDayPeriodValues,
    abbreviated: abbreviatedFormattingDayPeriodValues,
    wide: defaultFormattingDayPeriodValues$2,
};
const localize$3 = {
    ordinalNumber: enUsLocale__default["default"].localize.ordinalNumber,
    era: enUsLocale__default["default"].localize.era,
    quarter: enUsLocale__default["default"].localize.quarter,
    month: buildLocalizeFn__default["default"]({
        values: monthValues$3,
        defaultWidth: 'wide',
    }),
    day: buildLocalizeFn__default["default"]({
        values: dayValues$3,
        defaultWidth: 'wide',
    }),
    dayPeriod: buildLocalizeFn__default["default"]({
        values: dayPeriodValues$3,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues$2,
        defaultFormattingWidth: 'wide',
    }),
};

/**
 * @type {Locale}
 * @category Locales
 * @summary Cape Verdean Creole locale.
 * @language Cape Verdean Creole
 */
const keaLocale = {
    code: 'kea',
    formatDistance: enUsLocale__default["default"].formatDistance,
    formatLong: formatLong$3,
    formatRelative: enUsLocale__default["default"].formatRelative,
    localize: localize$3,
    match: enUsLocale__default["default"].match,
    options: {
        weekStartsOn: 1 /* Monday */,
        firstWeekContainsDate: 1,
    },
};

// @ts-expect-error: implicitly has an 'any' type
const dateFormats$2 = {
    full: "EEEE, d MMMM 'ឆ្នាំ' yyyy",
    long: "d MMMM 'ឆ្នាំ' yyyy",
    medium: "d MMM 'ឆ្នាំ' yyyy",
    short: 'd/MM/yyyy',
};
const timeFormats$1 = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm',
};
const dateTimeFormats$2 = {
    full: "{{date}} 'ម៉ោង' {{time}}",
    long: "{{date}} 'ម៉ោង' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}',
};
const formatLong$2 = {
    date: buildFormatLongFn__default["default"]({
        formats: dateFormats$2,
        defaultWidth: 'full',
    }),
    time: buildFormatLongFn__default["default"]({
        formats: timeFormats$1,
        defaultWidth: 'full',
    }),
    dateTime: buildFormatLongFn__default["default"]({
        formats: dateTimeFormats$2,
        defaultWidth: 'full',
    }),
};

// @ts-expect-error: implicitly has an 'any' type
const defaultMonthValues$2 = [
    'មករា',
    'កុម្ភៈ',
    'មីនា',
    'មេសា',
    'ឧសភា',
    'មិថុនា',
    'កក្កដា',
    'សីហា',
    'កញ្',
    'តុលា',
    'វិច្ឆិកា',
    'ធ្',
];
const monthValues$2 = {
    narrow: defaultMonthValues$2,
    abbreviated: defaultMonthValues$2,
    wide: defaultMonthValues$2,
};
const defaultDayValues$2 = ['អាទិត្យ', 'ច័ន្', 'អង្គារ', 'ពុធ', 'ព្រហស្បតិ៍', 'សុក្', 'សៅរ៍'];
const dayValues$2 = {
    narrow: defaultDayValues$2,
    short: defaultDayValues$2,
    abbreviated: defaultDayValues$2,
    wide: defaultDayValues$2,
};
const defaultDayPeriodValues$2 = {
    am: 'ព្រឹក',
    pm: 'រសៀល',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night',
};
const dayPeriodValues$2 = {
    narrow: defaultDayPeriodValues$2,
    abbreviated: defaultDayPeriodValues$2,
    wide: defaultDayPeriodValues$2,
};
const defaultFormattingDayPeriodValues$1 = {
    am: 'ព្រឹក',
    pm: 'រសៀល',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night',
};
const formattingDayPeriodValues$1 = {
    narrow: defaultFormattingDayPeriodValues$1,
    abbreviated: defaultFormattingDayPeriodValues$1,
    wide: defaultFormattingDayPeriodValues$1,
};
const localize$2 = {
    ordinalNumber: enUsLocale__default["default"].localize.ordinalNumber,
    era: enUsLocale__default["default"].localize.era,
    quarter: enUsLocale__default["default"].localize.quarter,
    month: buildLocalizeFn__default["default"]({
        values: monthValues$2,
        defaultWidth: 'wide',
    }),
    day: buildLocalizeFn__default["default"]({
        values: dayValues$2,
        defaultWidth: 'wide',
    }),
    dayPeriod: buildLocalizeFn__default["default"]({
        values: dayPeriodValues$2,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues$1,
        defaultFormattingWidth: 'wide',
    }),
};

/**
 * @type {Locale}
 * @category Locales
 * @summary Khmer locale.
 * @language Khmer
 * @iso-639-2 khm
 */
/**
 * TODO @azizkamoun: replace enUsLocale implementations with custom, local km implementations necessary for vaccine
 * participant flows
 */
const kmLocale = {
    code: 'km',
    formatDistance: enUsLocale__default["default"].formatDistance,
    formatLong: formatLong$2,
    formatRelative: enUsLocale__default["default"].formatRelative,
    localize: localize$2,
    match: enUsLocale__default["default"].match,
    options: {
        weekStartsOn: 1 /* Monday */,
        firstWeekContainsDate: 1,
    },
};

// @ts-expect-error: implicitly has an 'any' type
const dateFormats$1 = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'd/MM/yyyy',
};
const timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm',
};
const dateTimeFormats$1 = {
    full: "{{date}} 'markay saacadu tahay:' {{time}}",
    long: "{{date}} 'markay saacadu tahay:' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}',
};
const formatLong$1 = {
    date: buildFormatLongFn__default["default"]({
        formats: dateFormats$1,
        defaultWidth: 'full',
    }),
    time: buildFormatLongFn__default["default"]({
        formats: timeFormats,
        defaultWidth: 'full',
    }),
    dateTime: buildFormatLongFn__default["default"]({
        formats: dateTimeFormats$1,
        defaultWidth: 'full',
    }),
};

// @ts-expect-error: implicitly has an 'any' type
const defaultMonthValues$1 = [
    'Janaayo',
    'Febaraayo',
    'Maarso',
    'Abriil',
    'Maayo',
    'Juun',
    'Luuliyo',
    'Agoosto',
    'Sibteembar',
    'Oktoobar',
    'Nufeembar',
    'Diseembar',
];
const monthValues$1 = {
    narrow: defaultMonthValues$1,
    abbreviated: defaultMonthValues$1,
    wide: defaultMonthValues$1,
};
const defaultDayValues$1 = ['Axad', 'Isniin', 'Talaado', 'Arbaco', 'Khamiis', 'Jimce', 'Sabti']; // Sunday first
const dayValues$1 = {
    narrow: defaultDayValues$1,
    short: defaultDayValues$1,
    abbreviated: defaultDayValues$1,
    wide: defaultDayValues$1,
};
const defaultDayPeriodValues$1 = {
    am: 'galinka hore',
    pm: 'galinka danbe',
    midnight: 'saqdhexe',
    noon: 'duhurkii',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night',
};
const dayPeriodValues$1 = {
    narrow: defaultDayPeriodValues$1,
    abbreviated: defaultDayPeriodValues$1,
    wide: defaultDayPeriodValues$1,
};
const defaultFormattingDayPeriodValues = {
    am: 'galinka hore',
    pm: 'galinka danbe',
    midnight: 'saqdhexe',
    noon: 'duhurkii',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night',
};
const formattingDayPeriodValues = {
    narrow: defaultFormattingDayPeriodValues,
    abbreviated: defaultFormattingDayPeriodValues,
    wide: defaultFormattingDayPeriodValues,
};
const localize$1 = {
    ordinalNumber: enUsLocale__default["default"].localize.ordinalNumber,
    era: enUsLocale__default["default"].localize.era,
    quarter: enUsLocale__default["default"].localize.quarter,
    month: buildLocalizeFn__default["default"]({
        values: monthValues$1,
        defaultWidth: 'wide',
    }),
    day: buildLocalizeFn__default["default"]({
        values: dayValues$1,
        defaultWidth: 'wide',
    }),
    dayPeriod: buildLocalizeFn__default["default"]({
        values: dayPeriodValues$1,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide',
    }),
};

/**
 * @type {Locale}
 * @category Locales
 * @summary Somali locale.
 * @language Somali
 * @iso-639-2 som
 */
const soLocale = {
    code: 'som',
    formatDistance: enUsLocale__default["default"].formatDistance,
    formatLong: formatLong$1,
    formatRelative: enUsLocale__default["default"].formatRelative,
    localize: localize$1,
    match: enUsLocale__default["default"].match,
    options: {
        weekStartsOn: 6 /* Saturday */,
        firstWeekContainsDate: 1,
    },
};

// @ts-expect-error: implicitly has an 'any' type
// From https://www.localeplanet.com/icu/ur/index.html
// and https://www.unicode.org/cldr/cldr-aux/charts/28/verify/dates/ur.html
const dateFormats = {
    full: 'EEEE، MMMM d، y',
    long: 'MMMM d، y',
    medium: 'MMM d، y',
    short: 'd/M/yy',
};
const dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}',
};
const formatLong = {
    date: buildFormatLongFn__default["default"]({
        formats: dateFormats,
        defaultWidth: 'full',
    }),
    time: enUsLocale__default["default"].formatLong.time,
    dateTime: buildFormatLongFn__default["default"]({
        formats: dateTimeFormats,
        defaultWidth: 'full',
    }),
};

// From https://www.unicode.org/cldr/cldr-aux/charts/28/verify/dates/ur.html
const formatRelativeLocale = {
    lastWeek: "'گزشتہ' eeee p 'بعد دوپہر'",
    yesterday: "'گزشتہ کل' p 'بعد دوپہر'",
    today: "'آج' p 'بعد دوپہر'",
    tomorrow: "'آئندہ کل' p 'بعد دوپہر'",
    nextWeek: "'اگلے' eeee p 'بعد دوپہر'",
    other: 'P',
};
const formatRelative = (token) => formatRelativeLocale[token];

// @ts-expect-error: implicitly has an 'any' type
// From https://www.localeplanet.com/icu/ur/index.html
// and https://www.unicode.org/cldr/cldr-aux/charts/28/verify/dates/ur.html
const defaultEraValues = ['قبل مسیح', 'عیسوی'];
const eraValues = {
    narrow: defaultEraValues,
    abbreviated: defaultEraValues,
    wide: defaultEraValues,
};
const defaultMonthValues = [
    'جنوری',
    'فروری',
    'مارچ',
    'اپریل',
    'مئی',
    'جون',
    'جولائی',
    'اگست',
    'ستمبر',
    'اکتوبر',
    'نومبر',
    'دسمبر',
];
const narrowMonthValues = ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'];
const monthValues = {
    narrow: narrowMonthValues,
    abbreviated: defaultMonthValues,
    wide: defaultMonthValues,
};
const defaultDayValues = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
const dayValues = {
    narrow: defaultDayValues,
    short: defaultDayValues,
    abbreviated: defaultDayValues,
    wide: defaultDayValues,
};
const defaultDayPeriodValues = {
    am: 'AM',
    pm: 'PM',
    midnight: 'آدھی رات',
    morning: 'صبح',
    afternoon: 'دوپہر',
    evening: 'ማታ',
    night: 'رات',
};
const dayPeriodValues = {
    narrow: defaultDayPeriodValues,
    abbreviated: defaultDayPeriodValues,
    wide: defaultDayPeriodValues,
};
const defaultQuarterValues = ['پہلی سہ ماہی', 'دوسری سہ ماہی', 'تیسری سہ ماہی', 'چوتهی سہ ماہی'];
const narrowQuarterValues = ['1', '2', '3', '4'];
const quarterValues = {
    narrow: narrowQuarterValues,
    abbreviated: defaultQuarterValues,
    wide: defaultQuarterValues,
};
const localize = {
    ordinalNumber: enUsLocale__default["default"].localize.ordinalNumber,
    era: buildLocalizeFn__default["default"]({
        values: eraValues,
        defaultWidth: 'wide',
    }),
    quarter: buildLocalizeFn__default["default"]({
        values: quarterValues,
        formattingValues: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: (quarter) => Number(quarter) - 1,
    }),
    month: buildLocalizeFn__default["default"]({
        values: monthValues,
        defaultWidth: 'wide',
    }),
    day: buildLocalizeFn__default["default"]({
        values: dayValues,
        defaultWidth: 'wide',
    }),
    dayPeriod: buildLocalizeFn__default["default"]({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: dayPeriodValues,
        defaultFormattingWidth: 'wide',
    }),
};

/**
 * @type {Locale}
 * @category Locales
 * @summary Urdu locale.
 * @language Urdu
 */
const urLocale = {
    code: 'ur',
    formatDistance: enUsLocale__default["default"].formatDistance,
    formatLong,
    formatRelative,
    localize,
    match: enUsLocale__default["default"].match,
    options: {
        weekStartsOn: 1 /* Monday */,
        firstWeekContainsDate: 1,
    },
};

// FIXME: Locale code set in locale cookie. Must match to supported Django language codes.
// monoweb/django_apps/core/translations.py
exports.Locale = void 0;
(function (Locale) {
    Locale["ENGLISH"] = "en-US";
    Locale["SPANISH"] = "es-US";
    Locale["CHINESE_SIMPLIFIED"] = "zh-CN";
    Locale["CHINESE_TRADITIONAL"] = "zh-hant";
    Locale["PORTUGUESE"] = "pt-PT";
    Locale["HAITIAN_CREOLE"] = "ht";
    Locale["KOREAN"] = "ko";
    Locale["RUSSIAN"] = "ru-RU";
    Locale["VIETNAMESE"] = "vi";
    Locale["ARABIC"] = "ar-SA";
    Locale["FILIPINO"] = "fil";
    Locale["SAMOAN"] = "sm";
    Locale["KHMER"] = "km";
    Locale["POLISH"] = "pl";
    Locale["UKRAINIAN"] = "uk";
    Locale["URDU"] = "ur";
    Locale["FRENCH"] = "fr";
    Locale["SOMALI"] = "so";
    Locale["FARSI"] = "fa";
    Locale["CAPE_VERDEAN_CREOLE"] = "kea";
    Locale["AMHARIC"] = "am";
    Locale["MARSHALLESE"] = "mh";
    Locale["HMONG"] = "hmn";
    Locale["HINDI"] = "hi";
    Locale["HUNGARIAN"] = "hu";
    Locale["DUTCH"] = "nl";
})(exports.Locale || (exports.Locale = {}));
const ALL_LOCALES = Object.values(exports.Locale);
const RIGHT_TO_LEFT_LOCALES = new Set();
RIGHT_TO_LEFT_LOCALES.add(exports.Locale.ARABIC);
RIGHT_TO_LEFT_LOCALES.add(exports.Locale.URDU);
RIGHT_TO_LEFT_LOCALES.add(exports.Locale.FARSI);
const DEFAULT_LOCALE = exports.Locale.ENGLISH;
// Locales that we want to work with in some way, but that are not supported in
// Django or JS libraries or our localization system.
// Using codes from ISO 639-3.
exports.ExtraLocale = void 0;
(function (ExtraLocale) {
    ExtraLocale["AMERICAN_SIGN_LANGUAGE"] = "ase";
})(exports.ExtraLocale || (exports.ExtraLocale = {}));
// https://github.com/moment/moment/tree/2.24.0/locale
const MOMENT_LOCALE_NAMES = {
    [exports.Locale.ENGLISH]: 'en',
    [exports.Locale.SPANISH]: 'es',
    [exports.Locale.CHINESE_SIMPLIFIED]: 'zh-cn',
    [exports.Locale.PORTUGUESE]: 'pt',
    [exports.Locale.HAITIAN_CREOLE]: 'ht',
    [exports.Locale.KOREAN]: 'ko',
    [exports.Locale.RUSSIAN]: 'ru',
    [exports.Locale.VIETNAMESE]: 'vi',
    [exports.Locale.ARABIC]: 'ar',
    [exports.Locale.FILIPINO]: 'tl-ph',
    [exports.Locale.CHINESE_TRADITIONAL]: 'zh-tw',
    [exports.Locale.KHMER]: 'km',
    [exports.Locale.POLISH]: 'pl',
    [exports.Locale.UKRAINIAN]: 'uk',
    [exports.Locale.URDU]: 'ur',
    [exports.Locale.FRENCH]: 'fr',
    [exports.Locale.FARSI]: 'fa',
    [exports.Locale.HINDI]: 'hi',
    [exports.Locale.HUNGARIAN]: 'hu',
    [exports.Locale.DUTCH]: 'nl',
    // locales not supported in moment
    [exports.Locale.SAMOAN]: 'en',
    [exports.Locale.SOMALI]: 'en',
    [exports.Locale.CAPE_VERDEAN_CREOLE]: 'en',
    [exports.Locale.AMHARIC]: 'en',
    [exports.Locale.MARSHALLESE]: 'en',
    [exports.Locale.HMONG]: 'en',
};
// https://github.com/date-fns/date-fns/tree/v2.27.0/src/locale
const DATE_FNS_LOCALES = {
    [exports.Locale.ENGLISH]: enUsLocale__default["default"],
    [exports.Locale.SPANISH]: esLocale__default["default"],
    [exports.Locale.CHINESE_SIMPLIFIED]: zhCnLocale__default["default"],
    [exports.Locale.PORTUGUESE]: ptLocale__default["default"],
    [exports.Locale.HAITIAN_CREOLE]: htLocale__default["default"],
    [exports.Locale.KOREAN]: koLocale__default["default"],
    [exports.Locale.RUSSIAN]: ruLocale__default["default"],
    [exports.Locale.VIETNAMESE]: viLocale__default["default"],
    [exports.Locale.ARABIC]: arLocale__default["default"],
    [exports.Locale.CHINESE_TRADITIONAL]: zhTwLocale__default["default"],
    [exports.Locale.POLISH]: plLocale__default["default"],
    [exports.Locale.UKRAINIAN]: ukLocale__default["default"],
    [exports.Locale.FRENCH]: frLocale__default["default"],
    [exports.Locale.FARSI]: faIrLocale__default["default"],
    [exports.Locale.HINDI]: hiLocale__default["default"],
    [exports.Locale.HUNGARIAN]: huLocale__default["default"],
    [exports.Locale.DUTCH]: nlLocale__default["default"],
    // locales not yet supported in date-fns
    [exports.Locale.SAMOAN]: enUsLocale__default["default"],
    [exports.Locale.MARSHALLESE]: enUsLocale__default["default"],
    [exports.Locale.HMONG]: enUsLocale__default["default"],
    // locales not yet supported in date-fns with custom overrides
    [exports.Locale.FILIPINO]: filLocale,
    [exports.Locale.KHMER]: kmLocale,
    [exports.Locale.CAPE_VERDEAN_CREOLE]: keaLocale,
    [exports.Locale.SOMALI]: soLocale,
    [exports.Locale.AMHARIC]: amLocale,
    [exports.Locale.URDU]: urLocale,
};
const LOCALE_DISPLAY_NAMES = {
    [exports.Locale.ENGLISH]: 'English',
    [exports.Locale.SPANISH]: 'Español',
    [exports.Locale.CHINESE_SIMPLIFIED]: '简体中文',
    [exports.Locale.PORTUGUESE]: 'Português',
    [exports.Locale.HAITIAN_CREOLE]: 'Kreyòl Ayisyen',
    [exports.Locale.KOREAN]: '한국어',
    [exports.Locale.RUSSIAN]: 'русский',
    [exports.Locale.VIETNAMESE]: 'Tiếng Việt',
    [exports.Locale.ARABIC]: 'العربية',
    [exports.Locale.FILIPINO]: 'Filipino',
    [exports.Locale.CHINESE_TRADITIONAL]: '繁體中文',
    [exports.Locale.SAMOAN]: "Gagana fa'a Samoa",
    [exports.Locale.KHMER]: 'ខ្មែរ',
    [exports.Locale.POLISH]: 'Polski',
    [exports.Locale.UKRAINIAN]: 'українська',
    [exports.Locale.URDU]: 'اُردُو',
    [exports.Locale.FRENCH]: 'Français',
    [exports.Locale.FARSI]: 'فارسی',
    [exports.Locale.SOMALI]: 'Soomaali',
    [exports.Locale.CAPE_VERDEAN_CREOLE]: 'Kriolu',
    [exports.Locale.AMHARIC]: 'አማርኛ',
    [exports.Locale.MARSHALLESE]: 'kajin Majöl',
    [exports.Locale.HINDI]: 'हिन्दी',
    [exports.Locale.HMONG]: 'Hmoob',
    [exports.ExtraLocale.AMERICAN_SIGN_LANGUAGE]: 'American Sign Language (ASL)',
    [exports.Locale.HUNGARIAN]: 'Magyar',
    [exports.Locale.DUTCH]: 'Nederlands',
};
const SHORT_LOCALE_DISPLAY_NAMES = {
    [exports.Locale.ENGLISH]: 'EN',
    [exports.Locale.SPANISH]: 'ES',
    [exports.Locale.CHINESE_SIMPLIFIED]: '简体中文',
    [exports.Locale.PORTUGUESE]: 'PT',
    [exports.Locale.HAITIAN_CREOLE]: 'HT',
    [exports.Locale.KOREAN]: '한국어',
    [exports.Locale.RUSSIAN]: 'RU',
    [exports.Locale.VIETNAMESE]: 'VI',
    [exports.Locale.ARABIC]: 'AR',
    [exports.Locale.FILIPINO]: 'KWF',
    [exports.Locale.CHINESE_TRADITIONAL]: '繁體中文',
    [exports.Locale.SAMOAN]: 'SM',
    [exports.Locale.KHMER]: 'KM',
    [exports.Locale.POLISH]: 'PL',
    [exports.Locale.UKRAINIAN]: 'UK',
    [exports.Locale.URDU]: 'UR',
    [exports.Locale.FRENCH]: 'FR',
    [exports.Locale.FARSI]: 'FA',
    [exports.Locale.SOMALI]: 'SO',
    [exports.Locale.CAPE_VERDEAN_CREOLE]: 'KEA',
    [exports.Locale.AMHARIC]: 'AM',
    [exports.Locale.MARSHALLESE]: 'MH',
    [exports.Locale.HMONG]: 'HMN',
    [exports.Locale.HINDI]: 'HI',
    [exports.Locale.HUNGARIAN]: 'HU',
    [exports.Locale.DUTCH]: 'NL',
};
const LOCALE_ENGLISH_NAMES = {
    [exports.Locale.ENGLISH]: 'English',
    [exports.Locale.SPANISH]: 'Spanish',
    [exports.Locale.CHINESE_SIMPLIFIED]: 'Simplified Chinese',
    [exports.Locale.PORTUGUESE]: 'Portuguese',
    [exports.Locale.HAITIAN_CREOLE]: 'Haitian Creole',
    [exports.Locale.KOREAN]: 'Korean',
    [exports.Locale.RUSSIAN]: 'Russian',
    [exports.Locale.VIETNAMESE]: 'Vietnamese',
    [exports.Locale.ARABIC]: 'Arabic',
    [exports.Locale.FILIPINO]: 'Filipino',
    [exports.Locale.CHINESE_TRADITIONAL]: 'Traditional Chinese',
    [exports.Locale.SAMOAN]: 'Samoan',
    [exports.Locale.KHMER]: 'Khmer',
    [exports.Locale.POLISH]: 'Polish',
    [exports.Locale.UKRAINIAN]: 'Ukrainian',
    [exports.Locale.URDU]: 'Urdu',
    [exports.Locale.FRENCH]: 'French',
    [exports.Locale.FARSI]: 'Farsi',
    [exports.Locale.SOMALI]: 'Somali',
    [exports.Locale.CAPE_VERDEAN_CREOLE]: 'Cape Verdean Creole',
    [exports.Locale.AMHARIC]: 'Amharic',
    [exports.Locale.MARSHALLESE]: 'Marshallese',
    [exports.Locale.HMONG]: 'Hmong',
    [exports.Locale.HINDI]: 'Hindi',
    [exports.Locale.HUNGARIAN]: 'Hungarian',
    [exports.Locale.DUTCH]: 'Dutch',
};
const FRONTEND_TO_DJANGO_LOCALES = {
    [exports.Locale.ENGLISH]: 'en',
    [exports.Locale.SPANISH]: 'es',
    [exports.Locale.CHINESE_SIMPLIFIED]: 'zh-hans',
    [exports.Locale.PORTUGUESE]: 'pt',
    [exports.Locale.HAITIAN_CREOLE]: 'ht',
    [exports.Locale.KOREAN]: 'ko',
    [exports.Locale.RUSSIAN]: 'ru',
    [exports.Locale.VIETNAMESE]: 'vi',
    [exports.Locale.ARABIC]: 'ar',
    [exports.Locale.FILIPINO]: 'fil',
    [exports.Locale.CHINESE_TRADITIONAL]: 'zh-hant',
    [exports.Locale.SAMOAN]: 'sm',
    [exports.Locale.KHMER]: 'km',
    [exports.Locale.POLISH]: 'po',
    [exports.Locale.UKRAINIAN]: 'uk',
    [exports.Locale.URDU]: 'ur',
    [exports.Locale.FRENCH]: 'fr',
    [exports.Locale.FARSI]: 'fa',
    [exports.Locale.SOMALI]: 'so',
    [exports.Locale.CAPE_VERDEAN_CREOLE]: 'kea',
    [exports.Locale.AMHARIC]: 'am',
    [exports.Locale.MARSHALLESE]: 'mh',
    [exports.Locale.HMONG]: 'hmn',
    [exports.Locale.HINDI]: 'hi',
    [exports.Locale.HUNGARIAN]: 'hu',
    [exports.Locale.DUTCH]: 'nl',
};
const DJANGO_TO_FRONTEND_LOCALES = Object.fromEntries(Object.entries(FRONTEND_TO_DJANGO_LOCALES).map(([frontendLocale, djangoLocale]) => [djangoLocale, frontendLocale]));
/**
 * Define these values locally instead of using the browsers Intl
 * object, which requires some heavy polyfills.
 */
exports.ColorIso639Code = void 0;
(function (ColorIso639Code) {
    ColorIso639Code["ENGLISH"] = "en";
    ColorIso639Code["SPANISH"] = "es";
    ColorIso639Code["CHINESE_SIMPLIFIED"] = "zh_Hans";
    ColorIso639Code["CHINESE_TRADITIONAL"] = "zh_Hant";
    ColorIso639Code["PORTUGUESE"] = "pt";
    ColorIso639Code["HAITIAN_CREOLE"] = "ht";
    ColorIso639Code["KOREAN"] = "ko";
    ColorIso639Code["RUSSIAN"] = "ru";
    ColorIso639Code["VIETNAMESE"] = "vi";
    ColorIso639Code["ARABIC"] = "ar";
    ColorIso639Code["FILIPINO"] = "fil";
    ColorIso639Code["SAMOAN"] = "sm";
    ColorIso639Code["KHMER"] = "km";
    ColorIso639Code["POLISH"] = "pl";
    ColorIso639Code["UKRAINIAN"] = "uk";
    ColorIso639Code["URDU"] = "ur";
    ColorIso639Code["FRENCH"] = "fr";
    ColorIso639Code["SOMALI"] = "so";
    ColorIso639Code["FARSI"] = "fa";
    ColorIso639Code["CAPE_VERDEAN_CREOLE"] = "kea";
    ColorIso639Code["AMHARIC"] = "am";
    ColorIso639Code["MARSHALLESE"] = "mh";
    ColorIso639Code["HMONG"] = "hmn";
    ColorIso639Code["HINDI"] = "hi";
    ColorIso639Code["HUNGARIAN"] = "hu";
    ColorIso639Code["DUTCH"] = "nl";
})(exports.ColorIso639Code || (exports.ColorIso639Code = {}));
/**
 * Translation message files are named with the language code, without country code.
 * This historical naming convention is based on our use of Django i18n features,
 * specifically that the Django PO file names are generated based on Django settings:
 * > from django.conf.global_settings import LANGUAGES
 *
 * FIXME: Reconcile with Locale, migrate file names in code and on Lokalise.
 * Our Locales should have both language and country code and these files should reflect that.
 */
const COLOR_ISO_639_CODE_BY_LOCALE = {
    [exports.Locale.ENGLISH]: exports.ColorIso639Code.ENGLISH,
    [exports.Locale.SPANISH]: exports.ColorIso639Code.SPANISH,
    [exports.Locale.CHINESE_SIMPLIFIED]: exports.ColorIso639Code.CHINESE_SIMPLIFIED,
    [exports.Locale.CHINESE_TRADITIONAL]: exports.ColorIso639Code.CHINESE_TRADITIONAL,
    [exports.Locale.PORTUGUESE]: exports.ColorIso639Code.PORTUGUESE,
    [exports.Locale.HAITIAN_CREOLE]: exports.ColorIso639Code.HAITIAN_CREOLE,
    [exports.Locale.KOREAN]: exports.ColorIso639Code.KOREAN,
    [exports.Locale.RUSSIAN]: exports.ColorIso639Code.RUSSIAN,
    [exports.Locale.VIETNAMESE]: exports.ColorIso639Code.VIETNAMESE,
    [exports.Locale.ARABIC]: exports.ColorIso639Code.ARABIC,
    [exports.Locale.FILIPINO]: exports.ColorIso639Code.FILIPINO,
    [exports.Locale.SAMOAN]: exports.ColorIso639Code.SAMOAN,
    [exports.Locale.KHMER]: exports.ColorIso639Code.KHMER,
    [exports.Locale.POLISH]: exports.ColorIso639Code.POLISH,
    [exports.Locale.UKRAINIAN]: exports.ColorIso639Code.UKRAINIAN,
    [exports.Locale.URDU]: exports.ColorIso639Code.URDU,
    [exports.Locale.FRENCH]: exports.ColorIso639Code.FRENCH,
    [exports.Locale.SOMALI]: exports.ColorIso639Code.SOMALI,
    [exports.Locale.FARSI]: exports.ColorIso639Code.FARSI,
    [exports.Locale.CAPE_VERDEAN_CREOLE]: exports.ColorIso639Code.CAPE_VERDEAN_CREOLE,
    [exports.Locale.AMHARIC]: exports.ColorIso639Code.AMHARIC,
    [exports.Locale.MARSHALLESE]: exports.ColorIso639Code.MARSHALLESE,
    [exports.Locale.HMONG]: exports.ColorIso639Code.HMONG,
    [exports.Locale.HINDI]: exports.ColorIso639Code.HINDI,
    [exports.Locale.HUNGARIAN]: exports.ColorIso639Code.HUNGARIAN,
    [exports.Locale.DUTCH]: exports.ColorIso639Code.DUTCH,
};

const globalCookies = new Cookies__default["default"]();
const setGlobalCookie = globalCookies.set.bind(globalCookies);
const removeGlobalCookie = globalCookies.remove.bind(globalCookies);
function useCookies() {
    const [cookies, setCookies] = react.useState(globalCookies.getAll());
    // IMPORTANT: `useLayoutEffect` executes before `useEffect`, which increases the chances
    // that cookie updates are reflected in local state.
    // See https://getcolor.atlassian.net/browse/UITASK-144
    /*
     * Reviewed by UX Programs (Jaz) as a valid `useEffect` usage.
     * See https://getcolor.atlassian.net/browse/UXTASK-1406
     */
    // nosemgrep:semgrep-rules.ui-useEffect
    react.useLayoutEffect(() => {
        function onChange() {
            const newCookies = globalCookies.getAll();
            setCookies(newCookies);
        }
        globalCookies.addChangeListener(onChange);
        return () => {
            globalCookies.removeChangeListener(onChange);
        };
    }, []);
    return {
        setCookie: setGlobalCookie,
        removeCookie: removeGlobalCookie,
        cookies,
    };
}
const [CookiesProvider, useCookiesContext] = constate__default["default"](useCookies);

const PREFERRED_LOCALE_COOKIE_NAME = 'preferredLocale';
function getValidLocale(locale) {
    if (locale.startsWith('en')) {
        return exports.Locale.ENGLISH;
    }
    if (locale.startsWith('es')) {
        return exports.Locale.SPANISH;
    }
    if (locale.startsWith('zh-CN')) {
        return exports.Locale.CHINESE_SIMPLIFIED;
    }
    if (locale.startsWith('pt')) {
        return exports.Locale.PORTUGUESE;
    }
    if (locale.startsWith('ht')) {
        return exports.Locale.HAITIAN_CREOLE;
    }
    if (locale.startsWith('ko')) {
        return exports.Locale.KOREAN;
    }
    if (locale.startsWith('ru')) {
        return exports.Locale.RUSSIAN;
    }
    if (locale.startsWith('vi')) {
        return exports.Locale.VIETNAMESE;
    }
    if (locale.startsWith('ar')) {
        return exports.Locale.ARABIC;
    }
    if (locale.startsWith('fil')) {
        return exports.Locale.FILIPINO;
    }
    if (locale.startsWith('zh-hant')) {
        return exports.Locale.CHINESE_TRADITIONAL;
    }
    if (locale.startsWith('sm')) {
        return exports.Locale.SAMOAN;
    }
    if (locale.startsWith('km')) {
        return exports.Locale.KHMER;
    }
    if (locale.startsWith('pl')) {
        return exports.Locale.POLISH;
    }
    if (locale.startsWith('uk')) {
        return exports.Locale.UKRAINIAN;
    }
    if (locale.startsWith('ur')) {
        return exports.Locale.URDU;
    }
    if (locale.startsWith('kea')) {
        return exports.Locale.CAPE_VERDEAN_CREOLE;
    }
    if (locale.startsWith('fa')) {
        return exports.Locale.FARSI;
    }
    if (locale.startsWith('fr')) {
        return exports.Locale.FRENCH;
    }
    if (locale.startsWith('so')) {
        return exports.Locale.SOMALI;
    }
    if (locale.startsWith('am')) {
        return exports.Locale.AMHARIC;
    }
    if (locale.startsWith('mh')) {
        return exports.Locale.MARSHALLESE;
    }
    if (locale.startsWith('hmn')) {
        return exports.Locale.HMONG;
    }
    if (locale.startsWith('hi')) {
        return exports.Locale.HINDI;
    }
    if (locale.startsWith('hu')) {
        return exports.Locale.HUNGARIAN;
    }
    if (locale.startsWith('nl')) {
        return exports.Locale.DUTCH;
    }
    return null;
}
function setDocumentLangAttribute(validLocale) {
    document.documentElement.setAttribute('lang', validLocale);
}
function getCurrentLocaleFromCookies(cookies) {
    const cookieValue = cookies[PREFERRED_LOCALE_COOKIE_NAME];
    return getValidLocale(cookieValue || navigator.language) || DEFAULT_LOCALE;
}
function usePreferredLocale() {
    const { cookies, setCookie } = useCookiesContext();
    const locale = getCurrentLocaleFromCookies(cookies);
    /**
     * `useEffect` is often dangerous and unnecessary. This usage needs review by #ux-programs team.
     * See https://getcolor.atlassian.net/browse/UXTASK-1406
     */
    // nosemgrep:semgrep-rules.ui-useEffect
    react.useEffect(() => {
        setDocumentLangAttribute(locale);
    }, [locale]);
    const setLocale = react.useCallback((newLocale) => {
        setCookie(PREFERRED_LOCALE_COOKIE_NAME, newLocale, { path: '/' });
    }, [setCookie]);
    const localeIsRightToLeft = react.useMemo(() => RIGHT_TO_LEFT_LOCALES.has(locale), [locale]);
    return {
        locale,
        setLocale,
        localeIsRightToLeft,
    };
}

function useDateFnsLocale() {
    const { locale } = usePreferredLocale();
    return DATE_FNS_LOCALES[locale];
}

// getQueryParam, mergeQueryParam, stripQueryParam
/**
 * Appends query params to the given url.
 *
 * @param url - The base url.
 * @param params - The params to append.
 * @return - The url, with query params attached.
 */
function appendQueryParams(url, params) {
    if (!params || lodash.isEmpty(params)) {
        return url;
    }
    const query = queryString__default["default"].stringify(params);
    return query ? `${url}?${query}` : url;
}
/**
 * Get decoded query param from url search string, like `?foo=1`
 *
 * @param search - The query search string (location.search).
 * @param propName - The propName within search.
 * @param index - Optional index for the query prop, if an array. Default 0
 * @return - The matching param, if found.
 */
function getQueryParam(search, propName, options = {}) {
    const { index = 0 } = options;
    const params = queryString__default["default"].parse(search);
    const props = params[propName];
    if (props == null) {
        return undefined;
    }
    return lodash.isArray(props) ? props[index] : props;
}
/**
 * Get decoded query params array from url search string, like `?foo=1&foo=2`
 *
 * @param search - The query search string (location.search).
 * @param propName - The propName within search.
 * @return - The matching params array, if found, else empty array
 */
function getQueryParams(search, propName) {
    const params = queryString__default["default"].parse(search);
    const props = params[propName];
    if (props == null) {
        return [];
    }
    return lodash.isArray(props) ? props : [props];
}
// FIXME: Evaluate whether we should switch to an allow list, to reduce scope and have clearly defined allowances.
// https://cheatsheetseries.owasp.org/cheatsheets/Unvalidated_Redirects_and_Forwards_Cheat_Sheet.html
const UNSAFE_REDIRECT_LIST = [
    // Anything looking like a URL, like `http://evil.org` or even ``//evil.org`
    /\/\//,
    // Catchall for http
    /^http/,
    // Scripts
    /javascript/,
    /data:/,
    /<.*script:/,
    /[\r\n]/,
    // See https://getcolor.atlassian.net/browse/VUL-47
    // Case: http://localhost:8888/sign-in?next=\/evil.org  `\evil.org` (with the leading backslash)
    /\\/,
];
/**
 * Return safe URL, while allowing URLs that are color.com
 */
function getSafeUrl(nextUrl) {
    // Check allowed redirect links.
    if (/^http.?:\/\/(home|www|providers)?\.?color.com/.test(nextUrl)) {
        return nextUrl;
    }
    // Deny anything that is unsafe, such as urls containing `//`, javascript, etc.
    if (UNSAFE_REDIRECT_LIST.some((regex) => regex.test(nextUrl))) {
        return undefined;
    }
    return nextUrl;
}
/**
 * Return safe URL from query param matching `next=` search query, while allowing URLs that are color.com
 */
function getSafeNextQueryParam(search) {
    const nextUrl = getQueryParam(search, 'next');
    if (!nextUrl) {
        return undefined;
    }
    // We do this to make sure to correctly encode the params in the next url if it exists and
    // this should be safe to do so as we don't usually have any other params when next is specified
    const additionalParams = queryString__default["default"].parse(search.split(nextUrl)[1]);
    return getSafeUrl(appendQueryParams(nextUrl, additionalParams));
}
/**
 * Return safe URL from query param matching `verifyEmailNextUrl=` search query, while allowing URLs that are color.com
 */
function getSafeVerifyEmailNextUrlQueryParam(search) {
    const verifyEmailNextUrl = getQueryParam(search, 'verifyEmailNextUrl');
    if (!verifyEmailNextUrl) {
        return undefined;
    }
    // We do this to make sure to correctly encode the params in the next url if it exists and
    // this should be safe to do so as we don't usually have any other params when next is specified
    const additionalParams = queryString__default["default"].parse(search.split(verifyEmailNextUrl)[1]);
    return getSafeUrl(appendQueryParams(verifyEmailNextUrl, additionalParams));
}
/**
 * Simple wrapper to generate a query string from key value pairs.
 *
 * @param params - key-value pairs. e.g.: { param: 'value' }
 * @return - The query search string (with `?` prefix)
 */
function toQueryString(params) {
    return `?${queryString__default["default"].stringify(params)}`;
}
/**
 * Delete query param from url search string. For example, given `?foo=1&bar=2&x=3`, delete `bar`
 * returns `?foo=1&x=3`
 *
 * @param search - The query search string (location.search).
 * @param propName - The propName within search to delete.
 * @return - The updated query search string (with `?` prefix)
 */
function stripQueryParam(search, propName) {
    const params = queryString__default["default"].parse(search);
    delete params[propName];
    return toQueryString(params);
}
/**
 * Merge multiple query params into a URL search string. Values in `paramsToMerge` overwrite values
 * in `search`.
 *
 * @param search - The query search string (location.search).
 * @param updatedParams - Object mapping param names to values.
 * @returns - The updated query search string (with `?` prefix)
 */
function mergeQueryParams(search, updatedParams) {
    return toQueryString({
        ...queryString__default["default"].parse(search),
        ...updatedParams,
    });
}
/**
 * merge query param into url search string. Examples:
 * given `?foo=1&bar=2&x=3`, merge prop `bar` with value 5
 * returns `?bar=5&foo=1&x=3`,
 * given `?foo=1&x=3`, merge prop `bar` with value 5
 * returns `?bar=5&foo=1&x=3`,
 *
 * @param search - The query search string (location.search).
 * @param propName - The propName to add or update.
 * @param propValue - The propValue.
 * @return - The updated query search string (with `?` prefix)
 */
function mergeQueryParam(search, propName, propValue) {
    return mergeQueryParams(search, { [propName]: propValue });
}
/**
 * Return current pathname plus search.
 * Example: /covid/sign-up/start?partner=sfdph
 */
function getCurrentPath() {
    const { pathname, search } = window.location;
    return `${pathname}${search}`;
}
/**
 * Return search string with an escaped path to `nextUrl` as the `next` query param.
 * `nextUrl` defaults to the current path.
 *
 * For example:
 *   getNextSearchString() when on /covid/sign-up/start?partner=sfdph
 *   getNextSearchString('/covid/sign-up/start?partner=sfdph') when on any URL
 * both return `?next=%2Fcovid%2Fsign-up%2Fstart%3Fpartner%3Dsfdph`
 */
function getNextSearchString(nextUrl) {
    return mergeQueryParam('', 'next', nextUrl ?? getCurrentPath());
}
/**
 * Return pathname without a trailing slash, if it has one. `path` should be
 * free of any search params.
 */
function trimTrailingSlash(path) {
    return path.replace(/\/$/, '');
}

function useUrlQueryParam(paramKey, defaultValue = '') {
    const { search } = reactRouterDom.useLocation();
    const history = reactRouterDom.useHistory();
    const rawQueryParam = getQueryParam(search, paramKey);
    const setQueryParam = react.useCallback((value) => {
        const newSearch = mergeQueryParam(search, paramKey, value);
        history.replace({ search: newSearch });
    }, [search, paramKey, history]);
    const removeQueryParam = react.useCallback(() => {
        const newSearch = stripQueryParam(search, paramKey);
        history.replace({ search: newSearch });
    }, [search, paramKey, history]);
    const queryParam = rawQueryParam || defaultValue;
    return { queryParam, setQueryParam, removeQueryParam };
}

function useUrlQueryParams(defaultValues) {
    const { search } = reactRouterDom.useLocation();
    const history = reactRouterDom.useHistory();
    const setQueryParams = react.useCallback((paramValues) => {
        const newParams = lodash.pickBy(paramValues, lodash.identity);
        const newSearch = toQueryString(newParams);
        history.replace({ search: newSearch });
    }, [history]);
    const queryParams = react.useMemo(() => {
        const params = {};
        Object.keys(defaultValues).forEach((key) => {
            const urlQueryValue = getQueryParam(search, key);
            params[key] = urlQueryValue ?? defaultValues[key];
        });
        return params;
    }, [defaultValues, search]);
    return { queryParams, setQueryParams };
}

function useQueryParamLocale() {
    const { locale, setLocale } = usePreferredLocale();
    const { queryParam, removeQueryParam } = useUrlQueryParam('locale');
    /**
     * `useEffect` is often dangerous and unnecessary. This usage needs review by #ux-programs team.
     * See https://getcolor.atlassian.net/browse/UXTASK-1406
     */
    // nosemgrep:semgrep-rules.ui-useEffect
    react.useEffect(() => {
        if (queryParam) {
            // Important! clear the query param so that the user can choose a different locale.
            removeQueryParam();
            const validLocale = getValidLocale(queryParam);
            if (validLocale && locale !== validLocale) {
                setLocale(validLocale);
            }
        }
    }, [locale, queryParam, removeQueryParam, setLocale]);
}

const sortLocales = (locales) => {
    // sort locales alphabetically according to their ISO 639-1 locale code
    return locales.sort((locale1, locale2) => {
        const shortLocaleName1 = MOMENT_LOCALE_NAMES[locale1];
        const shortLocaleName2 = MOMENT_LOCALE_NAMES[locale2];
        return shortLocaleName1.localeCompare(shortLocaleName2);
    });
};

function setMockPreferredLocale(locale = DEFAULT_LOCALE) {
    Object.defineProperty(window.document, 'cookie', {
        writable: true,
        value: `${PREFERRED_LOCALE_COOKIE_NAME}=${locale}`,
    });
}

function isDefined(arg) {
    // != null is the same as !== null && !== undefined
    return arg != null;
}

/**
 * @param path on the marketing site, like `privacy-policy`
 * @returns a link to the marketing host + path.
 */
function getMarketingUrl(path = '') {
    const pathWithPrefix = path.startsWith('/') ? path : `/${path}`;
    if (isEnvironmentLocal()) {
        return `https://test-color-genomics.pantheonsite.io${pathWithPrefix}`;
    }
    if (isEnvironmentStaging()) {
        return `https://test-color-genomics.pantheonsite.io${pathWithPrefix}`;
    }
    if (isEnvironmentProduction()) {
        return `https://www.color.com${pathWithPrefix}`;
    }
    return `https://test-color-genomics.pantheonsite.io${pathWithPrefix}`;
}

/**
 * Returns a modified version of the component with its props preset to the
 * given default values.
 *
 * This is primarily useful for customizing wrappers for testing-library render()
 * calls, since initialProps are not supplied to wrappers in testing-library v16.
 *
 * @param Component
 * @param defaultProps
 * @returns A new component with the default props applied
 */
function withDefaultProps(Component, defaultProps) {
    return (props) => jsxRuntime.jsx(Component, { ...defaultProps, ...props });
}

/**
 * ******************************************************************
 * NOTE: This file is a duplicate of another file located at:
 * projects/home/frontend/src/ui/common/hooks/useAnalytics/useAnalytics.ts
 * Any changes made to this file should also be made to the original
 * file to maintain consistency and avoid code duplication issues.
 *
 * This duplication was done instead of a complete move to avoid breaking tests.
 * To resolve this, we would need to create higher-level mocks (at the @color/lib level)
 * and refactor many tests, which requires a significant amount of time. For more details
 * and future resolution, see the Jira ticket: https://getcolor.atlassian.net/browse/FG-63
 * ******************************************************************
 */
/**
 * Hook to provide event tracking analytics to various providers.
 */
const useAnalytics = () => {
    const referrerRef = useReferrerContext();
    const { locale } = usePreferredLocale();
    // This hook can be called to attach extra information about a page view, generic URL changes are
    // expected to call `logPageLoadAnalytics` instead. This method filters out null and undefined
    // values.
    const dangerouslyLogPageViewAnalytics = react.useCallback((name, properties) => {
        const referrer = referrerRef.current;
        logAnalyticsPageView(name, {
            preferred_locale: locale,
            ...lodash.pickBy(properties, (value) => isDefined(value)),
            referrer,
        });
    }, [referrerRef, locale]);
    return {
        dangerouslyLogPageViewAnalytics,
    };
};
/**
 * Logs a page view for analytics using the uniquePageId passed.
 *
 * Prerequisites for logging:
 *   `uniquePageId`, `pageName` are truthy
 *   `loggingIsEnabled` is true.
 *
 * This hook caches the uniquePageId and, once the prerequisites are met, logs
 * one time, until the uniquePageId changes.
 */
function useLogPageViewUsingUniqueId(props) {
    const { pathname } = reactRouterDom.useLocation();
    const { loggingIsEnabled = true, uniquePageId = pathname, pageName, properties } = props;
    const { dangerouslyLogPageViewAnalytics } = useAnalytics();
    const lastLoggedUniquePageIdRef = react.useRef('');
    /**
     * `useEffect` is often dangerous and unnecessary. This usage needs review by #ux-programs team.
     * See https://getcolor.atlassian.net/browse/UXTASK-1406
     */
    // nosemgrep:semgrep-rules.ui-useEffect
    react.useEffect(() => {
        if (loggingIsEnabled &&
            uniquePageId &&
            pageName &&
            lastLoggedUniquePageIdRef.current !== uniquePageId) {
            lastLoggedUniquePageIdRef.current = uniquePageId;
            // nosemgrep:semgrep-rules.ui-dangerouslyLogPageViewAnalytics
            dangerouslyLogPageViewAnalytics(pageName, properties);
        }
    }, [loggingIsEnabled, dangerouslyLogPageViewAnalytics, pageName, properties, uniquePageId]);
}
function useIdentifyAnalyticsUser(userProps) {
    /*
     * Reviewed by UX Programs as a valid `useEffect` usage. See UXTASK-1406
     */
    // nosemgrep:semgrep-rules.ui-useEffect
    react.useEffect(() => {
        if (userProps) {
            identifyAnalyticsUser(userProps);
        }
    }, [userProps]);
}

function addErrorMessage(error) {
    const { status, message, ...otherProps } = error;
    const uniqueValues = new Set(Object.values(otherProps).flat(Infinity));
    const displayMessage = message ?? Array.from(uniqueValues).join(', ');
    return {
        status,
        message: displayMessage,
        ...otherProps,
    };
}
function getError(error) {
    if (error instanceof Error) {
        return error;
    }
    if (error instanceof Object) {
        return new Error(JSON.stringify(error));
    }
    return new Error(String(error));
}
/**
 * Recursively converts all object keys given a converter function
 * Adapted from https://stackoverflow.com/a/50620653
 */
function convertObjectKeys(object, convertKey) {
    if (lodash.isPlainObject(object)) {
        return Object.keys(object).reduce((result, key) => {
            // eslint-disable-next-line no-param-reassign
            result[convertKey(key)] = convertObjectKeys(object[key], convertKey);
            return result;
        }, {});
    }
    if (lodash.isArray(object)) {
        return object.map((value) => convertObjectKeys(value, convertKey));
    }
    return object;
}
/**
 * Converts all object keys to camelCase from snake_case. This is useful for converting from Python and Javascript object syntax.
 */
function convertObjectKeysToCamelCase(object) {
    return convertObjectKeys(object, lodash.camelCase);
}
/**
 * Converts all object keys to camelCase from snake_case. This is useful for converting from Javascript to Python object syntax.
 */
function convertObjectKeysToSnakeCase(object) {
    return convertObjectKeys(object, lodash.snakeCase);
}
// Return the CSRF Cookie name based on current environment. These names are configured in Django settings.
function getCsrfCookieName() {
    if (isEnvironmentProduction()) {
        return 'csrftoken_prod';
    }
    if (isEnvironmentStaging()) {
        return 'csrftoken_staging';
    }
    if (isEnvironmentEphemeral()) {
        return 'csrftoken_ephemeral';
    }
    return 'csrftoken';
}

const COOKIES = new Cookies__default["default"]();
const ENABLE_SLOW_API = isEnvironmentLocal() && false;
if (ENABLE_SLOW_API && !isEnvironmentLocal()) {
    throw new Error('You are enabling slow api in non-dev environment!');
}
// // Debug code to bypass fetch response for a given endpoint.
// // @ts-ignore
// const oldFetch = global.fetch;
// // @ts-ignore
// global.fetch = async (url, ...args) => {
//   if (!url.includes('covid_benefits/eligibility')) { return oldFetch(url, ...args);}
//   console.error('blowing up')
//   return Promise.resolve({ok: false, status: 403, headers: {
//     get: () => '',
//   }});
// }
const NON_LOGGABLE_HTTP_ERROR_STATUSES = new Set([401]);
const X_CSRF_TOKEN_HEADER_KEY = 'X-CSRFToken';
const X_SEGMENT_SESSION_ID_HEADER_KEY = 'X-Segment-Session-Id';
/**
 * Add default request options.
 *
 * @param fetchOptions - The initial fetch options.
 */
function addDefaultFetchOptions(fetchOptions, url) {
    const headers = { ...fetchOptions.headers };
    const csrfCookieName = getCsrfCookieName();
    if (!('X-CSRFToken' in headers) && COOKIES.get(csrfCookieName)) {
        headers[X_CSRF_TOKEN_HEADER_KEY] = COOKIES.get(csrfCookieName);
    }
    if (!('X-Segment-Session-Id' in headers)) {
        headers[X_SEGMENT_SESSION_ID_HEADER_KEY] = getSegmentSessionId();
    }
    // Include credentials (session cookies) for local development
    let includeCredentials = isEnvironmentLocalAndDevelopment();
    const { origin } = window.location;
    let destination = '';
    try {
        destination = new URL(url).origin;
    }
    catch (_) {
        // relative paths will throw since they're not valid URLs
    }
    if (origin.match(/.*hub.*\.color\.(com|dev)$/) && destination.match(/.*[./]color\.(com|dev)$/)) {
        // Include credentials (session cookies) when making requests from
        // ColorHub to the Clinical backend.
        includeCredentials = true;
    }
    return {
        ...fetchOptions,
        headers,
        credentials: includeCredentials ? 'include' : 'same-origin',
    };
}
// FIXME: Convert this to a plain object. This doesn't need to be a class...
class APIClient {
    constructor() {
        /**
         * A fetch wrapper, with an API similar to `requests` in Python.
         *
         * Helper methods which include the method are provided below.
         *
         * @param method - The HTTP request method.
         * @param url - The url to make a request to.
         * @param options - Additional information about this request.
         */
        this.request = (method, url, options = {}) => {
            let fetchHeaders = options.headers;
            const { params = {}, json = {} } = options;
            const urlWithQueryParams = appendQueryParams(url, params);
            let body;
            const methodIsGet = method === 'GET';
            if (!lodash.isEmpty(json)) {
                if (!methodIsGet) {
                    body = json;
                }
                fetchHeaders = {
                    // FIXME - `Content-Type` doesn't make sense for `GET` requests.
                    'Content-Type': 'application/json',
                    // FIXME - `Accept` is unrelated to whether we are sending a JSON object.
                    // Most likely all our API's should specify this, since our endpoints can
                    // only really handle JSON (not HTML)
                    Accept: 'application/json',
                    ...fetchHeaders,
                };
            }
            const fetchOptions = {
                method,
                body,
                headers: fetchHeaders,
            };
            return this.colorFetch(urlWithQueryParams, fetchOptions);
        };
        this.get = (url, options = {}) => {
            return this.request('GET', url, options);
        };
        this.post = (url, options = {}) => {
            return this.request('POST', url, options);
        };
        this.put = (url, options = {}) => {
            return this.request('PUT', url, options);
        };
        this.delete = (url, options = {}) => {
            return this.request('DELETE', url, options);
        };
        this.patch = (url, options = {}) => {
            return this.request('PATCH', url, options);
        };
        this.uploadFile = (url, options) => {
            const { params = {}, headers, method = 'POST', file } = options;
            const urlWithQueryParams = appendQueryParams(url, params);
            const fetchOptions = {
                method,
                body: file,
                headers: {
                    // This is necessary to receive a response in json format
                    // Otherwise you will get this error: 'renderer returned unicode, and did not specify'
                    Accept: 'application/json',
                    ...headers,
                },
            };
            return this.doFetch(urlWithQueryParams, addDefaultFetchOptions(fetchOptions, url));
        };
        /**
         * A fetch wrapper.
         *
         * @param url - The url to make a request against
         * @param options - The fetch options
         */
        this.colorFetch = (url, options) => {
            let fetchBody = options.body;
            if (typeof fetchBody === 'object') {
                fetchBody = JSON.stringify(fetchBody);
            }
            return this.doFetch(url, addDefaultFetchOptions({
                ...options,
                body: fetchBody,
            }, url));
        };
        // To fix this we'd have to make this all methods in this class static.
        // eslint-disable-next-line class-methods-use-this
        this.doFetch = async (url, options) => {
            const UNSPECIFIED_SERVER_ERROR = {
                message: 'Failed to process request.',
                status: 500,
            };
            let response;
            try {
                if (ENABLE_SLOW_API) {
                    // Enable this to observe slow API responses in development.
                    await new Promise((resolve) => setTimeout(resolve, 1000));
                }
                response = await fetch(url, options);
            }
            catch (error) {
                // Do not log to sentry.
                loggerUtils.logToConsole(getError(error));
                // This only occurs for the following scenarios:
                // 1. Network failures like bad wifi
                // 2. Invalid hosts or domains, such as CORS requests
                // This will not catch for invalid endpoints like /random/endpoint since
                // (404 not found is a fetch success but not `responseIsOk`)
                return Promise.reject(new ApiError(UNSPECIFIED_SERVER_ERROR));
            }
            try {
                const contentType = response.headers.get('Content-Type') || response.headers.get('content-type') || '';
                const isJsonContentType = contentType.includes('application/json');
                const { ok: responseIsOk, status } = response;
                // Reject responses that aren't a 200-299
                if (!responseIsOk) {
                    let responseContent = UNSPECIFIED_SERVER_ERROR;
                    if (isJsonContentType) {
                        const errorResponse = await response.json();
                        if (typeof errorResponse === 'object') {
                            responseContent = addErrorMessage(errorResponse);
                        }
                        else if (typeof errorResponse === 'string') {
                            // JSON is a primitive string (in quotes)
                            responseContent.message = errorResponse;
                        }
                    }
                    else if (contentType.includes('application/text')) {
                        // Plain text in body, with appropriate header.
                        responseContent.message = await response.text();
                    }
                    responseContent.status = status;
                    loggerUtils.logToConsole(new Error(`Server responded with ${status} for URL: ${url}`), responseContent);
                    const apiError = new ApiError(responseContent);
                    if (status >= 400 && !NON_LOGGABLE_HTTP_ERROR_STATUSES.has(status)) {
                        loggerUtils.logException(apiError);
                    }
                    return Promise.reject(apiError);
                }
                // Only return JSON (a little bizarre - FIXME)
                if (isJsonContentType) {
                    return response.json();
                }
                return null;
            }
            catch (error) {
                // This will occur when `response.json()` or `response.text()` throws.
                // Examples:
                // * response.json() attempts to parse non JSON (worth logging)
                // * response stream is interrupted during processing. (e.g. intermittent network) (probably not worth logging, but is likely low occurrence)
                loggerUtils.logException(getError(error));
                return Promise.reject(new ApiError(UNSPECIFIED_SERVER_ERROR));
            }
        };
    }
}
// Export a singleton for convenience.
const ApiClient = new APIClient();

function isInstanceOfIErrorPayload(object) {
    return 'status' in object && 'message' in object;
}

const defaultOptions = {
    queries: {
        queryFn({ queryKey }) {
            const [endpoint, options] = queryKey;
            // `useDjangoPaginatedQuery` embeds the `searchParams` as part of `options`
            // If defined, use `searchParams` otherwise use `options`.
            const { searchParams } = (options ?? {});
            return ApiClient.get(endpoint, {
                params: (searchParams ?? options),
            });
        },
        retry(failureCount, error) {
            return isInstanceOfIErrorPayload(error) && error.status === 500 && failureCount < 3;
        },
        refetchOnWindowFocus: false,
    },
};
const reactQueryClient = new reactQuery.QueryClient({
    defaultOptions,
});

/**
 *
 * Fake QueryClient that can be configured to return a response of any type
 * for specific endpoints and optional additionalQueryKey.
 * Example usage:
 * ```
 * const reactQueryClient = createFakeReactQueryClient([
 *   {
 *     endpoint: '/api/v1/sessions',
 *     response: Promise.reject(new ApiError({status: 401, message: 'Not authorized}))},
 *   {
 *     endpoint: '/api/v1/vaccination_appointments/12345678?claim_token=abc123',
 *     response: ['an-array', 'of-items'] },
 *   {
 *     endpoint: `/api/v1/feed/covid`,
 *     additionalQueryKey: { locale: DEFAULT_LOCALE, participant: '37' },
 *     response: {title: 'object title, content: 'object content'},
 *    },
 *   {
 *     endpoint: `/api/v1/expected-error`,
 *     response: new Error('Test this error'),
 *    },
 * ]);
 * ```
 */
const createFakeReactQueryClient = (responseConfigs) => {
    return new reactQuery.QueryClient({
        defaultOptions: {
            queries: {
                queryFn(query) {
                    const { queryKey } = query;
                    const endpoint = queryKey[0];
                    const additionalQueryKey = queryKey[1];
                    const matchedConfig = responseConfigs.find((config) => config.endpoint === endpoint && lodash.isEqual(config.additionalQueryKey, additionalQueryKey));
                    if (matchedConfig) {
                        const { response } = matchedConfig;
                        const responseObject = response instanceof Function ? response() : response;
                        if (responseObject instanceof Error) {
                            throw responseObject;
                        }
                        return responseObject;
                    }
                    throw new Error(`Unknown query ${JSON.stringify(queryKey)}`);
                },
                retry() {
                    return false;
                },
            },
        },
    });
};

exports.PopulationRelationship = void 0;
(function (PopulationRelationship) {
    PopulationRelationship["EMPLOYEE"] = "employee";
    PopulationRelationship["HEALTH_INSURANCE_BENEFICIARY"] = "health_insurance_beneficiary";
    PopulationRelationship["NON_HEALTH_INSURANCE_BENEFICIARY"] = "non_health_insurance_beneficiary";
})(exports.PopulationRelationship || (exports.PopulationRelationship = {}));

exports.UserRole = void 0;
(function (UserRole) {
    UserRole["USER_WITH_ACCOUNT"] = "user_with_account";
    UserRole["NO_TEST"] = "no_test";
    UserRole["GENETICS"] = "genetics";
    UserRole["COVID_NON_DEPENDENT_PROXY"] = "covid_proxy";
    UserRole["COVID_FULL_USER_OR_DEPENDENT"] = "covid_full_user_or_dependent";
    UserRole["CARE_FULL_USER_OR_DEPENDENT"] = "care_full_user_or_dependent";
    UserRole["ESSENTIAL_CARE_USER"] = "essential_care_user";
    UserRole["STI_TEST_USER"] = "sti_test_user";
    UserRole["COLLECTION_SITE_ADMIN"] = "collection_site_admin";
    UserRole["COVID_SITE_MANAGER"] = "covid_site_manager";
    UserRole["PROVIDER"] = "provider";
    UserRole["SUPPORT_STAFF"] = "support_staff";
    UserRole["COLOR_EMPLOYEE"] = "color_employee";
    UserRole["DASHBOARD_VIEWER"] = "dashboard_viewer";
    UserRole["ACCESS_MANAGER"] = "access_manager";
    UserRole["SUPPORT_ADMIN"] = "support_admin";
    UserRole["ELIGIBILITY_DATA_MANAGER"] = "eligibility_data_manager";
    UserRole["SAMPLE_REVIEWER"] = "sample_reviewer";
    UserRole["ORDERING_PHYSICIAN"] = "ordering_physician";
    UserRole["GENETIC_COUNSELOR"] = "genetic_counselor";
    UserRole["EXTERNAL_CLASSIFICATION_REVIEWER"] = "external_classification_reviewer";
    UserRole["VARIANT_REVIEWER"] = "variant_reviewer";
    UserRole["VARIANT_REVIEWER_MANAGER"] = "variant_reviewer_manager";
    UserRole["GENETICS_BOARD_MEMBER"] = "genetics_board_member";
    UserRole["PATHOLOGIST"] = "pathologist";
    UserRole["FULFILLMENT_STAFF"] = "fulfillment_staff";
    UserRole["CONTACT_MANAGER"] = "contact_manager";
    UserRole["VACCINATION_PLATFORM_SITE_MANAGER"] = "vaccination_platform_site_manager";
    UserRole["VACCINATION_PLATFORM_STAFF_MANAGER"] = "vaccination_platform_staff_manager";
    UserRole["VACCINATION_PLATFORM_SUPER_ADMIN"] = "vaccination_platform_super_admin";
    UserRole["VACCINATION_PLATFORM_SITE_INVENTORY_MANAGER"] = "vaccination_platform_site_inventory_manager";
    UserRole["VACCINATION_PLATFORM_BULK_INVENTORY_MANAGER"] = "vaccination_platform_bulk_inventory_manager";
    UserRole["VACCINATION_PLATFORM_SITE_STAFF"] = "vaccination_platform_site_staff";
    UserRole["VACCINATION_PLATFORM_SCRIBE"] = "vaccination_platform_scribe";
    UserRole["VACCINATION_PLATFORM_VACCINATING_CLINICIAN"] = "vaccination_platform_vaccinating_clinician";
})(exports.UserRole || (exports.UserRole = {}));
const ALL_USER_ROLES = [
    exports.UserRole.NO_TEST,
    exports.UserRole.GENETICS,
    exports.UserRole.COVID_NON_DEPENDENT_PROXY,
    exports.UserRole.CARE_FULL_USER_OR_DEPENDENT,
    exports.UserRole.COVID_FULL_USER_OR_DEPENDENT,
    exports.UserRole.ESSENTIAL_CARE_USER,
    exports.UserRole.STI_TEST_USER,
    exports.UserRole.COVID_SITE_MANAGER,
    exports.UserRole.PROVIDER,
    exports.UserRole.SUPPORT_STAFF,
    exports.UserRole.COLOR_EMPLOYEE,
    exports.UserRole.DASHBOARD_VIEWER,
    exports.UserRole.ACCESS_MANAGER,
    exports.UserRole.ELIGIBILITY_DATA_MANAGER,
    exports.UserRole.COLLECTION_SITE_ADMIN,
    exports.UserRole.FULFILLMENT_STAFF,
    exports.UserRole.CONTACT_MANAGER,
    exports.UserRole.VACCINATION_PLATFORM_SITE_MANAGER,
    exports.UserRole.VACCINATION_PLATFORM_STAFF_MANAGER,
    exports.UserRole.VACCINATION_PLATFORM_SUPER_ADMIN,
];
// These represent users which should be regarded as being able to use genetics.
// In short, *all* users may use the Genetics platform by purchasing a test.
// See `role.ts` and `portals.ts` for the intricacies on how that affects app switching.
const GENETICS_USER_ROLES = [exports.UserRole.GENETICS, exports.UserRole.NO_TEST];
exports.CollectionSiteRole = void 0;
(function (CollectionSiteRole) {
    CollectionSiteRole["ONSITE_STAFF"] = "sample_collection_admin";
    CollectionSiteRole["BATCH_SHIPMENT_ADMIN"] = "batch_shipment_admin";
    CollectionSiteRole["SITE_SCHEDULER"] = "site_scheduler";
    CollectionSiteRole["SITE_MANAGER"] = "site_manager";
    CollectionSiteRole["STAFF_MANAGER"] = "staff_manager";
    CollectionSiteRole["VACCINE_INVENTORY_MANAGER"] = "vaccine_inventory_manager";
    CollectionSiteRole["VACCINE_CLINICIAN"] = "vaccine_clinician";
    CollectionSiteRole["SCRIBE"] = "scribe";
})(exports.CollectionSiteRole || (exports.CollectionSiteRole = {}));
exports.CollectionSiteRoleCategory = void 0;
(function (CollectionSiteRoleCategory) {
    CollectionSiteRoleCategory["GENERAL"] = "general";
    CollectionSiteRoleCategory["APPOINTMENT_MANAGEMENT"] = "appointment_management";
    CollectionSiteRoleCategory["INVENTORY_MANAGEMENT"] = "inventory_management";
    CollectionSiteRoleCategory["ONSITE_PATIENT_MANAGEMENT"] = "onsite_patient_management";
    CollectionSiteRoleCategory["BATCH_SHIPMENT"] = "batch_shipment";
})(exports.CollectionSiteRoleCategory || (exports.CollectionSiteRoleCategory = {}));
exports.UserPermission = void 0;
(function (UserPermission) {
    UserPermission["PUT_SAMPLES_ON_HOLD"] = "samples.put_sample_on_hold";
    UserPermission["VIEW_USERS"] = "users.view_users";
    UserPermission["VIEW_PHI"] = "users.view_phi";
    UserPermission["VIEW_APPOINTMENTS"] = "counseling.view_appointments";
    UserPermission["VIEW_HEALTH_HISTORY"] = "health_profiles.view_healthhistory";
    UserPermission["VIEW_COVID_REPORTS_QUEUE"] = "results.can_view_covid_reports_queue";
    UserPermission["ACCESS_PATIENT_DATA"] = "colorhub.access_patient_data";
    UserPermission["VIEW_PATIENTS_HUB"] = "colorhub.view_patients_hub";
    UserPermission["USE_GLOBAL_SEARCH"] = "colorhub.use_global_search";
    UserPermission["VIEW_PATIENT_RECORD"] = "colorhub.view_patient_record";
    UserPermission["EDIT_PATIENT_DEMOGRAPHICS"] = "colorhub.edit_patient_demographics";
    UserPermission["EDIT_PATIENT_CONTACT_INFO"] = "colorhub.edit_patient_contact_info";
    UserPermission["EDIT_PATIENT_INSURANCE"] = "colorhub.edit_patient_insurance";
    UserPermission["ADD_PATIENT_NOTES"] = "colorhub.add_patient_notes";
    UserPermission["EDIT_PATIENT_NOTES"] = "colorhub.edit_patient_notes";
    UserPermission["ARCHIVE_PATIENT_NOTES"] = "colorhub.archive_patient_notes";
    UserPermission["VIEW_PATIENT_TIMELINE"] = "colorhub.view_patient_timeline";
    UserPermission["VIEW_PATIENT_GOALS"] = "colorhub.view_patient_goals";
    UserPermission["EDIT_PATIENT_GOALS"] = "colorhub.edit_patient_goals";
    UserPermission["ADD_TASK"] = "colorhub.add_task";
    UserPermission["EDIT_TASK"] = "colorhub.edit_task";
    UserPermission["ADD_TASK_COMMENTS"] = "colorhub.add_task_comments";
    UserPermission["EDIT_TASK_COMMENTS"] = "colorhub.edit_task_comments";
    UserPermission["ARCHIVE_TASK_COMMENTS"] = "colorhub.archive_task_comments";
    UserPermission["ADD_RISK_ASSESSMENT"] = "colorhub.add_risk_assessment";
})(exports.UserPermission || (exports.UserPermission = {}));
exports.ScopedRoleType = void 0;
(function (ScopedRoleType) {
    ScopedRoleType["COVID_OVERVIEW_DASHBOARD_VIEWER"] = "view_covid_overview_dashboard";
    ScopedRoleType["COVID_PATIENTS_DASHBOARD_VIEWER"] = "view_covid_patients_dashboard";
    ScopedRoleType["VACCINE_OVERVIEW_DASHBOARD_VIEWER"] = "view_vx_overview_dashboard";
    ScopedRoleType["VACCINE_PATIENTS_DASHBOARD_VIEWER"] = "view_vx_patients_dashboard";
    ScopedRoleType["VACCINE_AUDIT_DASHBOARD_VIEWER"] = "view_vx_audit_dashboard";
    ScopedRoleType["CONTACT_MANAGER"] = "contact_manager";
    ScopedRoleType["USER_MANAGER"] = "manage_users";
    ScopedRoleType["API_KEY_MANAGER"] = "api_key_manager";
    ScopedRoleType["LAB_OVERVIEW_DASHBOARD_VIEWER"] = "lab_overview_dashboard_viewer";
    ScopedRoleType["LAB_PHI_DASHBOARD_VIEWER"] = "lab_phi_dashboard_viewer";
    ScopedRoleType["ELIGIBILITY_DATA_MANAGER"] = "eligibility_data_manager";
    ScopedRoleType["RESEARCH_OVERVIEW_DASHBOARD_VIEWER"] = "research_overview_dashboard_viewer";
    ScopedRoleType["RESEARCH_CRO_OVERVIEW_DASHBOARD_VIEWER"] = "research_cro_overview_dashboard_viewer";
    ScopedRoleType["RESEARCH_PATIENTS_DASHBOARD_VIEWER"] = "research_patients_dashboard_viewer";
    ScopedRoleType["ESSENTIAL_CARE_OVERVIEW_DASHBOARD_VIEWER"] = "essential_care_overview_dashboard_viewer";
    ScopedRoleType["ESSENTIAL_CARE_PATIENTS_DASHBOARD_VIEWER"] = "essential_care_patients_dashboard_viewer";
    ScopedRoleType["CONSULTATIONS_OVERVIEW_DASHBOARD_VIEWER"] = "consultations_overview_dashboard_viewer";
    ScopedRoleType["CONSULTATIONS_PATIENTS_DASHBOARD_VIEWER"] = "consultations_patients_dashboard_viewer";
    ScopedRoleType["STI_OVERVIEW_DASHBOARD_VIEWER"] = "sti_overview_dashboard_viewer";
    ScopedRoleType["STI_PATIENTS_DASHBOARD_VIEWER"] = "sti_patients_dashboard_viewer";
    ScopedRoleType["ONSITE_BATCH_SHIPMENT_ADMIN"] = "onsite_batch_shipment_admin";
    ScopedRoleType["VACCINATION_PLATFORM_SITE_MANAGER"] = "vaccination_platform_site_manager";
    ScopedRoleType["VACCINATION_PLATFORM_SITE_STAFF"] = "vaccination_platform_site_staff";
    ScopedRoleType["VACCINATION_PLATFORM_SCRIBE"] = "vaccination_platform_scribe";
    ScopedRoleType["VACCINATION_PLATFORM_VACCINATING_CLINICIAN"] = "vaccination_platform_vaccinating_clinician";
    ScopedRoleType["VACCINATION_PLATFORM_SITE_SCHEDULER"] = "vaccination_platform_site_scheduler";
    ScopedRoleType["VACCINATION_PLATFORM_SITE_INVENTORY_MANAGER"] = "vaccination_platform_site_inventory_manager";
    ScopedRoleType["VACCINATION_PLATFORM_BULK_INVENTORY_MANAGER"] = "vaccination_platform_bulk_inventory_manager";
    ScopedRoleType["VACCINATION_PLATFORM_STAFF_MANAGER"] = "vaccination_platform_staff_manager";
    ScopedRoleType["VACCINATION_PLATFORM_SUPER_ADMIN"] = "vaccination_platform_super_admin";
    ScopedRoleType["PROMISE_OVERVIEW_DASHBOARD_VIEWER"] = "promise_overview_dashboard_viewer";
    ScopedRoleType["PROMISE_PARTICIPANTS_DASHBOARD_VIEWER"] = "promise_participants_dashboard_viewer";
})(exports.ScopedRoleType || (exports.ScopedRoleType = {}));
exports.PermissionType = void 0;
(function (PermissionType) {
    PermissionType["UNKNOWN"] = "UNKNOWN";
    PermissionType["ALLOWED"] = "ALLOWED";
    PermissionType["NOT_ALLOWED"] = "NOT_ALLOWED";
})(exports.PermissionType || (exports.PermissionType = {}));

// Note that some browser extensions disable localStorage, sessionStorage and/or cookies.
// See: https://getcolor.atlassian.net/browse/UITASK-131
// On some browser, referencing browser storage throws SecurityError: The operation is insecure.
let nullableLocalStorage = null;
let nullableSessionStorage = null;
try {
    nullableLocalStorage = window.localStorage;
}
catch {
    // Intentionally ignore this error, since some users disable localStorage using browser extensions or configs.
}
try {
    nullableSessionStorage = window.sessionStorage;
}
catch {
    // Intentionally ignore this error, since some users disable sessionStorage using browser extensions or configs.
}
exports.BrowserStorageType = void 0;
(function (BrowserStorageType) {
    BrowserStorageType[BrowserStorageType["LOCAL_STORAGE"] = 0] = "LOCAL_STORAGE";
    BrowserStorageType[BrowserStorageType["SESSION_STORAGE"] = 1] = "SESSION_STORAGE";
})(exports.BrowserStorageType || (exports.BrowserStorageType = {}));
function getBrowserStorage(browserStorageType) {
    switch (browserStorageType) {
        case exports.BrowserStorageType.LOCAL_STORAGE:
            return nullableLocalStorage;
        case exports.BrowserStorageType.SESSION_STORAGE:
            return nullableSessionStorage;
        default:
            throw new Error(`Unknown Browser storage type: ${browserStorageType}`);
    }
}
function isPayloadValid(payloadWrapper, options) {
    const { validTimeInMilliseconds = Number.MAX_VALUE } = options;
    const { updatedAt } = payloadWrapper;
    return updatedAt && Date.now() - updatedAt <= validTimeInMilliseconds;
}
function getValidBrowserStoragePayload(browserStorageType, key, initialValue, options) {
    try {
        const item = getBrowserStorage(browserStorageType)?.getItem(key);
        const payloadWrapper = item && JSON.parse(item);
        if (payloadWrapper && isPayloadValid(payloadWrapper, options)) {
            return payloadWrapper.payload;
        }
        return initialValue;
    }
    catch (error) {
        return initialValue;
    }
}
function setBrowserStoragePayload(browserStorageType, key, payload) {
    try {
        const payloadWrapper = {
            updatedAt: Date.now(),
            payload,
        };
        getBrowserStorage(browserStorageType)?.setItem(key, JSON.stringify(payloadWrapper));
    }
    catch (error) {
        loggerUtils.logException(error);
    }
}
function clearBrowserStoragePayload(browserStorageType, key) {
    try {
        getBrowserStorage(browserStorageType)?.removeItem(key);
    }
    catch (error) {
        loggerUtils.logException(error);
    }
}
function clearBrowserStorage(browserStorageType) {
    try {
        getBrowserStorage(browserStorageType)?.clear();
    }
    catch (error) {
        loggerUtils.logException(error);
    }
}

// Based on https://usehooks.com/useLocalStorage/
function useBrowserStorageState(browserStorageType, key, initialValue, options = {}) {
    const [storedValue, setStoredValue] = react.useState(() => {
        return getValidBrowserStoragePayload(browserStorageType, key, initialValue, options);
    });
    const setValue = react.useCallback((param) => {
        if (typeof param === 'function') {
            setStoredValue((currentValue) => {
                const newValue = param(currentValue);
                setBrowserStoragePayload(browserStorageType, key, newValue);
                return newValue;
            });
        }
        else {
            setStoredValue(param);
            setBrowserStoragePayload(browserStorageType, key, param);
        }
    }, [key, browserStorageType]);
    const clearStorage = react.useCallback(() => {
        clearBrowserStoragePayload(browserStorageType, key);
    }, [key, browserStorageType]);
    return [storedValue, setValue, clearStorage];
}
const useLocalStorageState = lodash.partial(useBrowserStorageState, exports.BrowserStorageType.LOCAL_STORAGE);
const useSessionStorageState = lodash.partial(useBrowserStorageState, exports.BrowserStorageType.SESSION_STORAGE);

// Based on https://usehooks.com/useLocalStorage/
function useBrowserStorageReducer(browserStorageType, key, reducer, initialValue, options = {}) {
    const [state, dispatch] = react.useReducer(reducer, initialValue, () => {
        return getValidBrowserStoragePayload(browserStorageType, key, initialValue, options);
    });
    /**
     * `useEffect` is often dangerous and unnecessary. This usage needs review by #ux-programs team.
     * See https://getcolor.atlassian.net/browse/UXTASK-1406
     */
    // nosemgrep:semgrep-rules.ui-useEffect
    react.useEffect(() => {
        setBrowserStoragePayload(browserStorageType, key, state);
    }, [key, state, browserStorageType]);
    const clearStorage = react.useCallback(() => {
        clearBrowserStoragePayload(browserStorageType, key);
    }, [key, browserStorageType]);
    return { state, dispatch, clearStorage };
}
lodash.partial(useBrowserStorageReducer, exports.BrowserStorageType.LOCAL_STORAGE);
const useSessionStorageReducer = lodash.partial(useBrowserStorageReducer, exports.BrowserStorageType.SESSION_STORAGE);

function getLaunchDarklyClientId(env) {
    switch (env) {
        case exports.Environment.STAGING:
        case exports.Environment.TESTING:
        case exports.Environment.EPHEMERAL:
            // If you're here, you're debugging code running on a hostname matching
            // either STAGING, TESTING, or EPHEMERAL environment, but that somehow, we don't have
            // the REACT_APP_LAUNCHDARKLY_CLIENTID_STAGING env var set. That's either
            // a problem with the build process, or the hostname configuration of
            // getEnvironment.
            return (process.env.REACT_APP_LAUNCHDARKLY_CLIENTID_STAGING ||
                'missing-REACT_APP_LAUNCHDARKLY_CLIENTID_STAGING-see-code-comment');
        case exports.Environment.PRODUCTION:
            // If you're here, you're debugging code running on a hostname matching
            // the PRODUCTION Environment, but that somehow, we don't have the
            // REACT_APP_LAUNCHDARKLY_CLIENTID_PRODUCTION env var set. That's either a
            // problem with the build process, or the hostname configuration of
            // getEnvironment.
            return (process.env.REACT_APP_LAUNCHDARKLY_CLIENTID_PRODUCTION ||
                'missing-REACT_APP_LAUNCHDARKLY_CLIENTID_PRODUCTION-see-code-comment');
        case exports.Environment.LOCAL:
            // If this string turns up in your debugging, it's likely the code you're
            // debugging accidentally depended on our LaunchDarkly integration in a
            // test or development enviroment it wasn't expected to run in. Likely you
            // want to either: adjust getEnvironment's hostname configuration; or
            // adjust how ConfiguredFeatureFlagProvider interprets the Environment
            // enums.
            return 'fake-client-id-for-Environment.LOCAL-see-code-comment';
        case exports.Environment.UNKNOWN:
        default:
            // If this string turns up in your debugging, it's likely the code you're
            // debugging accidentally depended on our LaunchDarkly integration in a
            // test or development enviroment it wasn't expected to run in. Likely you
            // want to either: mock out the ConfiguredFeatureFlagProvider's LDClient
            // because you're writing unit tests for it; mock out
            // ConfiguredFeatureFlagProvider; or adjust getEnvironment's hostname
            // configuration.
            return 'fake-client-id-for-Environment.UNKNOWN-see-code-comment';
    }
}

/**
 * FakeLDClient is only for preventing networking connections from being made in
 * local development. For testing, use the {@link jest-launchdarkly-mock} package.
 */
class FakeLaunchDarklyClient {
    constructor(flags, ldUser) {
        this.flags = {};
        this.flags = flags;
        this.user = ldUser;
    }
    // eslint-disable-next-line class-methods-use-this
    waitUntilGoalsReady() {
        return Promise.resolve();
    }
    // eslint-disable-next-line class-methods-use-this
    waitUntilReady() {
        return Promise.resolve();
    }
    // eslint-disable-next-line class-methods-use-this
    waitForInitialization() {
        return Promise.resolve();
    }
    identify(user, _hash, onDone) {
        this.user = user;
        if (onDone) {
            // This branch is supposed to return undefined as it does in
            // LaunchDarkly's JS code, but the return type of `identify` they've
            // provided doesn't allow that.
            onDone(null, this.flags);
        }
        return Promise.resolve(this.flags);
    }
    getUser() {
        return this.user;
    }
    // eslint-disable-next-line class-methods-use-this
    flush(onDone) {
        onDone?.();
        return Promise.resolve();
    }
    variation(key, defaultValue) {
        return this.flags[key] || defaultValue;
    }
    variationDetail(key, defaultValue) {
        const reason = {
            kind: 'FALLTHROUGH',
        };
        const detail = {
            value: this.flags[key] || defaultValue,
            variationIndex: 0,
            reason,
        };
        return detail;
    }
    // eslint-disable-next-line class-methods-use-this
    setStreaming( /* value?: boolean | undefined */) { }
    // eslint-disable-next-line class-methods-use-this
    on( /* key: string, callback: (...args: any[]) => void, context?: any */) { }
    // eslint-disable-next-line class-methods-use-this
    off( /* key: string, callback: (...args: any[]) => void, context?: any */) { }
    // eslint-disable-next-line class-methods-use-this
    track( /* key: string, data?: any, metricValue?: number | undefined */) { }
    // eslint-disable-next-line class-methods-use-this
    alias( /* user: LDUser, previousUser: LDUser */) { }
    allFlags() {
        return this.flags;
    }
    // eslint-disable-next-line class-methods-use-this
    close(onDone) {
        onDone?.();
        return Promise.resolve();
    }
}

const FakeLaunchDarklyFlagContextProvider = (props) => {
    const { flags = {}, user = { key: 'fake-ld-flag-provider-user' }, children } = props;
    // We have to do all this because LaunchDarkly doesn't make it easy to get at
    // the LDContext and make what you want when you're camelCasing flags. There's
    // a ticket about this
    // https://github.com/launchdarkly/react-client-sdk/issues/30 and specifically
    // a comment asking for what we would prefer from their API
    // https://github.com/launchdarkly/react-client-sdk/issues/30#issuecomment-825042690
    const fakeLdContext = {
        flags,
        flagKeyMap: {},
        ldClient: new FakeLaunchDarklyClient(flags, user),
    };
    return jsxRuntime.jsx(context.Provider, { value: fakeLdContext, children: children });
};

const GLOBAL_COOKIES = new Cookies__default["default"]();
const SIGNED_IN_LD_USER_KEY_COOKIE_NAME = 'ld_user_key';
/**
 * getLaunchDarklyUserKeyCookieValue is here for the rest of the lib/flags package
 * and it's unlikely you want to use it.
 *
 * getLaunchDarklyUserKeyCookieValue returns the value of the cookie our backend
 * sets to identify the current user to LaunchDarkly.
 */
function getLaunchDarklyUserKeyCookieValue() {
    return GLOBAL_COOKIES.get(SIGNED_IN_LD_USER_KEY_COOKIE_NAME, { doNotParse: true });
}

async function FakeLaunchDarklyProviderHoc() {
    // This is only run in local development. In production, LaunchDarkly feeds us
    // what we want, but we don't want a remote dependency when hacking locally.
    // We also can't use useQuery here because this is during React bootstrap.
    const clientSideFlags = await fetch('/api/v1/testing/client_side_flags').then((response) => {
        if (!response.ok) {
            throw new Error(`Non-200 error code returned when fetching /api/v1/testing/client_side_flags for LaunchDarkly local dev set up. Was ${response.status}`);
        }
        const contentType = response.headers.get('content-type');
        const isJson = contentType?.includes('application/json');
        if (!isJson) {
            throw new Error(`Non-JSON response returned when fetching /api/v1/testing/client_side_flags for LaunchDarkly local dev set up. Has Content-Type '${contentType}'`);
        }
        return response.json();
    });
    const userKey = getLaunchDarklyUserKeyCookieValue();
    const user = userKey ? { key: userKey } : { key: 'missing-ld-user-key-but-maybe-okay-for-now' };
    const flags = clientSideFlags.flag_data;
    const FakeLdFlagContextProvider = ({ children }) => (jsxRuntime.jsx(FakeLaunchDarklyFlagContextProvider, { flags: flags, user: user, children: children }));
    return Promise.resolve(FakeLdFlagContextProvider);
}

const logToConsole = (message) => loggerUtils.logMessageToConsole(`[Launch Darkly] ${message}`);
const ldLogger = {
    // eslint-disable-next-line unused-imports/no-unused-vars
    debug: (_message) => null, // Don't log debug messages in staging/prod
    info: logToConsole,
    warn: logToConsole,
    error: (message) => {
        if (message && message.includes('network error')) {
            // These are not actionable and logging them as errors pollutes Sentry
            logToConsole(message);
        }
        else {
            // If there's a different LD problem, we want to know about it, so log it as an error which gets captured by Sentry
            loggerUtils.logException(new Error(`[Launch Darkly] ${message}`));
        }
    },
};
/**
 * RealLaunchDarklyProviderHoc is a higher order component, that asynchronously
 * sets up the LaunchDarkly client and retrieves the flags before. Once
 * resolved, this returns a Provider component.
 */
async function RealLaunchDarklyProviderHoc(clientId) {
    const userKey = getLaunchDarklyUserKeyCookieValue();
    const user = userKey ? { key: userKey } : { anonymous: true };
    const config = {
        user,
        clientSideID: clientId,
        reactOptions: {
            useCamelCaseFlagKeys: false,
        },
        options: {
            logger: ldLogger,
        },
    };
    return launchdarklyReactClientSdk.asyncWithLDProvider(config);
}

/**
 * FeatureFlagProviderHoc configures a LaunchDarkly provider with the correct
 * client ID and initial LDUser object from the cookie state of the first
 * request to handle both signed-in and anonymous users. To do so, it needs the
 * flag state from a remote service (LaunchDarkly's in production, our local
 * backend during development), and so returns a promise for the actual Provider
 * object.
 *
 * It provides the @{link
 * https://docs.launchdarkly.com/sdk/client-side/react/react-web#hooks |
 * `useFlags` hook} and that's likely to handle your use case.
 *
 * See the API docs of
 * {@link https://docs.launchdarkly.com/sdk/client-side/react/react-web | launchdarkly-react-client-sdk }
 * for details on other hooks available.
 *
 * Informing LaunchDarkly of users' transitions from anonymous to signed-in and
 * back are handled in newAuthState using {@link useLaunchDarklyUpdateUser}.
 *
 * In test and local development environments, it creates a fake LaunchDarkly
 * provider that doesn't connect to the LaunchDarkly service, but does use an
 * HTTP API on our backend to coordinate flag values with same said backend.
 */
async function FeatureFlagProviderHoc() {
    // We can't use the useCookies hook here because we need the cookie
    // state before the app is rendered.
    const env = getEnvironment();
    switch (env) {
        case exports.Environment.PRODUCTION:
        case exports.Environment.STAGING:
        case exports.Environment.EPHEMERAL:
        case exports.Environment.TESTING:
            // Always use a real LaunchDarkly client for these. TESTING is actually
            // All of Us's staging-ish environment.
            return RealLaunchDarklyProviderHoc(getLaunchDarklyClientId(env));
        case exports.Environment.LOCAL:
        case exports.Environment.UNKNOWN:
        default:
            if (process.env.REACT_APP_LAUNCHDARKLY_FORCE_LOCAL_REQUESTS_TO_CLIENT_ID != null) {
                // Frameworks and other folks sometimes need to see how LaunchDarkly
                // behaves during local development, and so they can use this env var to
                // specify the client ID of the LaunchDarkly env they want to use.
                return RealLaunchDarklyProviderHoc(process.env.REACT_APP_LAUNCHDARKLY_FORCE_LOCAL_REQUESTS_TO_CLIENT_ID);
            }
            return FakeLaunchDarklyProviderHoc();
    }
}

/**
 * useLaunchDarklyUpdater is likely not what you want to be using. It's meant to
 * be used within the guts of newAuthState.
 *
 * useLaunchDarklyUpdater handles tracking users as they move from anonymous to
 * signed-in and back in the the LaunchDarkly client. Calls to
 * {@link ILaunchDarklyUpdater.update} method on the returned object will check
 * for changes to the cookies returned by the server and adjust the local
 * identification of the user. No remote services are called for that.
 */
const useLaunchDarklyUpdater = () => {
    const ldClient = launchdarklyReactClientSdk.useLDClient();
    if (!ldClient) {
        throw new Error('useLaunchDarklyUpdateUser must be used within a ConfiguredFeatureFlagsProvider context');
    }
    const updateLaunchDarkly = async () => {
        const newLDUserKey = getLaunchDarklyUserKeyCookieValue();
        const currentLdUserKey = ldClient.getUser().key;
        if (newLDUserKey === currentLdUserKey) {
            return;
        }
        const user = newLDUserKey ? { key: newLDUserKey } : { anonymous: true };
        try {
            await ldClient.identify(user);
        }
        catch (error) {
            Sentry__namespace.withScope((scope) => {
                scope.setTag('subsystem', 'feature-flags');
                loggerUtils.logException(error);
            });
        }
    };
    return { updateLaunchDarkly };
};

const SESSIONS_ENDPOINT = '/api/v1/sessions';
const ACCOUNTS_ENDPOINT = '/api/v1/accounts';
function useAuthSession(queryOptions, baseUrl = '') {
    const endpoint = `${baseUrl}${SESSIONS_ENDPOINT}`;
    return reactQuery.useQuery(endpoint, {
        ...queryOptions,
    });
}
function useAuthenticatedUser(userIsAuthenticated, queryOptions, baseUrl = '') {
    const endpoint = `${baseUrl}${ACCOUNTS_ENDPOINT}`;
    return reactQuery.useQuery(endpoint, {
        ...queryOptions,
        enabled: queryOptions.enabled || userIsAuthenticated,
    });
}

const HTTP_UNATHENTICATED_STATUSES = new Set([401, 403]);
const AUTH_HEARTBEAT_INTERVAL_IN_MSEC = 60000;

function useIdentifySegmentUser() {
    const lastUserIdRef = react.useRef('');
    const updateSegmentUser = react.useCallback((user, properties = {}) => {
        const patientId = user?.patient_id;
        // Send a Segment identify() call only *once* for each user based on unique `patient_id`.
        if (patientId && patientId !== lastUserIdRef.current) {
            identifyAnalyticsUser({ patientId, isColorEmployee: user.is_color_employee, properties });
            lastUserIdRef.current = patientId;
        }
    }, []);
    return { updateSegmentUser };
}

/**
 * When a user signs out, or the app wants to reset auth state, we should also
 * clear out session storage to remove lingering data in the browser state.
 */
function clearSessionState() {
    clearBrowserStorage(exports.BrowserStorageType.SESSION_STORAGE);
}
function useAuthState(props = {}) {
    // Apply defaults if unset in props
    const { baseUrl = '', sessionRefetchIntervalMs = AUTH_HEARTBEAT_INTERVAL_IN_MSEC, sessionRefetchIntervalInBackground = false, authUserStaleTimeMs = 0, } = props;
    /*
     * FIXME: `isAuthenticated` is the same as `sessionResponse.isSuccess`. This state is redundant.
     * This state is currently also tied to `signIn` and `signOut` responses, which probably should be decoupled.
     */
    const [isAuthenticated, setIsAuthenticated] = react.useState(false);
    const { updateSegmentUser } = useIdentifySegmentUser();
    const { updateLaunchDarkly } = useLaunchDarklyUpdater();
    const resetState = react.useCallback(() => {
        clearSessionState();
        setIsAuthenticated(false);
    }, []);
    const sessionResponse = useAuthSession({
        retry: false,
        refetchInterval: sessionRefetchIntervalMs,
        refetchIntervalInBackground: sessionRefetchIntervalInBackground,
        onSuccess: () => {
            setIsAuthenticated(true);
        },
        onError: (error) => {
            // API logs error to console. Not logging here on purpose.
            if (HTTP_UNATHENTICATED_STATUSES.has(error?.status)) {
                // Only unauthenticate if:
                // 1. response status indicates. (Ie: not on redirects or 500s)
                // 2. This is the initial load (page load, or after resetState)
                setIsAuthenticated(false);
            }
        },
        onSettled: async () => {
            await updateLaunchDarkly();
        },
    }, baseUrl);
    const authenticatedUserResponse = useAuthenticatedUser(isAuthenticated, {
        refetchOnWindowFocus: isAuthenticated,
        staleTime: authUserStaleTimeMs,
        onSuccess: (user) => {
            updateSegmentUser(user);
            // This just sets some local state, so no need to memoize
            Sentry__namespace.setUser(user ? { id: user.id.toString() } : null);
        },
    }, baseUrl);
    const { data: currentUser, refetch: fetchUser, isFetched: userIsFetched, remove: clearAuthenticatedUser, } = authenticatedUserResponse;
    const { isFetched: hasInitializedSession, refetch: updateSession, error: sessionError, } = sessionResponse;
    const signIn = react.useCallback(async (email, password, nextUrl) => {
        try {
            const createSessionUrl = appendQueryParams(`${baseUrl}${SESSIONS_ENDPOINT}`, {
                next: nextUrl,
            });
            // FIXME - convert to `useMutation`
            const response = await ApiClient.post(createSessionUrl, {
                json: {
                    email,
                    password,
                },
            });
            // A successful response means password was correct, but it does not
            // mean the user was logged in, as other special circumstances may have
            // arisen
            const isMfaRequired = response?.is_mfa_required ?? false;
            if (isMfaRequired) {
                setIsAuthenticated(false);
                return {
                    isSuccessful: false,
                    mfaConfig: { factors: response?.factors ?? [] },
                };
            }
            const emailNeedsConfirmation = response?.email_needs_confirmation ?? false;
            if (emailNeedsConfirmation) {
                setIsAuthenticated(false);
                return {
                    isSuccessful: false,
                    emailNeedsConfirmation: true,
                };
            }
            trackAnalyticsEvent('Sign In - Succeeded', {
                is_mfa: 'no',
            });
            setIsAuthenticated(true);
            await updateLaunchDarkly();
            return { isSuccessful: true };
        }
        catch (error) {
            trackAnalyticsEvent('Sign In - Failed', {
                error: error instanceof Error ? error.message : (error?.toString?.() ?? ''),
                status: error instanceof ApiError ? error.status : '',
            });
            setIsAuthenticated(false);
            throw error;
        }
    }, [updateLaunchDarkly, baseUrl]);
    const signOut = react.useCallback(async () => {
        try {
            // FIXME - convert to `useMutation`
            await ApiClient.delete(`${baseUrl}${SESSIONS_ENDPOINT}`);
        }
        catch (error) {
            if (error.status !== 401) {
                // If the API responds with 401 (Unauthorized) then the session is already signed out,
                // and can ignore the error.
                // If the API failure is for any other reason, we should still treat this as an error.
                throw error;
            }
        }
        clearAuthenticatedUser();
        clearSessionState();
        resetAnalyticsUser();
        Sentry__namespace.setUser(null);
        setIsAuthenticated(false);
        try {
            // This indirectly calls updateLaunchDarkly()
            await updateSession();
        }
        catch (e) {
            // This is expected to fail, and it's only called to ensure the
            // session data is updated accordingly
        }
    }, [clearAuthenticatedUser, updateSession, baseUrl]);
    /**
     * The session response could fail for a number of reasons, including intermittent network connections.
     * The error is considered as unauthenticated if the API status code is one of `HTTP_UNATHENTICATED_STATUSES`
     */
    const sessionErrorIsUnauthenticatedStatus = hasInitializedSession &&
        sessionError != null &&
        HTTP_UNATHENTICATED_STATUSES.has(sessionError.status);
    const resetStateAndUpdateSession = react.useCallback(async () => {
        resetState();
        const updateSessionResponse = await updateSession();
        let attemptCount = 1;
        let hasSucceeded = updateSessionResponse.isSuccess;
        if (!hasSucceeded) {
            // Apparently, `react-query` can run into a race condition triggered by manually running a query that is
            // scheduled to run at regular intervals, causing a request to not have all expected cookies.
            // In this case, it might happen we try to update the session without a session cookie, even though we expect
            // the user to be logged in already, and so we need to retry once to circumvent it.
            const retriedUpdateSessionResponse = await updateSession();
            attemptCount += 1;
            hasSucceeded = retriedUpdateSessionResponse.isSuccess;
        }
        trackAnalyticsEvent('Session Refresh', {
            status: hasSucceeded ? 'succeeded' : 'failed',
            attempt_count: attemptCount,
        });
    }, [resetState, updateSession]);
    return {
        currentUser,
        hasInitializedUser: userIsFetched || sessionErrorIsUnauthenticatedStatus,
        hasInitializedSession,
        isAuthenticated,
        resetStateAndUpdateSession,
        signIn,
        signOut,
        fetchUser,
    };
}
const [AuthProvider, useAuthContext] = constate__default["default"](useAuthState);

exports.KitOrderTestType = void 0;
(function (KitOrderTestType) {
    KitOrderTestType["HEREDITARY_30"] = "hereditary 30";
    KitOrderTestType["HEREDITARY_25"] = "hereditary 25";
    KitOrderTestType["HEREDITARY_41"] = "hereditary 41";
    KitOrderTestType["BREAST_OVARIAN_19"] = "breast ovarian 19";
    KitOrderTestType["WISDOM_9"] = "wisdom 9";
    KitOrderTestType["FH_5"] = "fh 5";
    KitOrderTestType["FH_3"] = "fh 3";
    KitOrderTestType["CARDIO_30"] = "cardio 30";
    KitOrderTestType["WES"] = "whole exome";
    KitOrderTestType["WGS"] = "whole genome";
    KitOrderTestType["LCWGS"] = "low coverage whole genome";
    KitOrderTestType["BRCA_1_2"] = "brca 1 2";
    KitOrderTestType["HEREDITARY_7"] = "hereditary 7";
    KitOrderTestType["PGX_V1"] = "pgx v1";
    KitOrderTestType["PGX_V3"] = "pgx v3";
    KitOrderTestType["PMS_2"] = "pms2";
    KitOrderTestType["ACMG_59"] = "acmg 59";
    KitOrderTestType["HDR_59"] = "hdr 59";
    KitOrderTestType["METABOLISM_4"] = "metabolism 4";
    KitOrderTestType["COVID_19"] = "covid-19";
    KitOrderTestType["COVID_19_ANTIGEN"] = "covid-19 antigen";
    KitOrderTestType["ESSENTIAL_CARE_KIT"] = "preventive health kit";
    KitOrderTestType["AOU_HDR_V1"] = "aou acmg 59";
    KitOrderTestType["AOU_PGX_V1"] = "aou pgx v1";
    KitOrderTestType["CHLAMYDIA_ANAL"] = "chlamydia trachomatis - anal";
    KitOrderTestType["CHLAMYDIA_ORAL"] = "chlamydia trachomatis - oral";
    KitOrderTestType["CHLAMYDIA_URINE"] = "chlamydia trachomatis - urine";
    KitOrderTestType["GONORRHEA_ANAL"] = "neisseria gonorrhoeae - anal";
    KitOrderTestType["GONORRHEA_ORAL"] = "neisseria gonorrhoeae - oral";
    KitOrderTestType["GONORRHEA_URINE"] = "neisseria gonorrhoeae - urine";
})(exports.KitOrderTestType || (exports.KitOrderTestType = {}));
exports.KitOrderStatus = void 0;
(function (KitOrderStatus) {
    KitOrderStatus["NO_ORDER"] = "no_order";
    KitOrderStatus["ONSITE_PURCHASE"] = "onsite_purchase";
    KitOrderStatus["NOT_SHIPPED"] = "not_shipped";
    KitOrderStatus["SHIPPED_TO_HOME"] = "shipped_to_home";
    KitOrderStatus["SHIPPED_TO_HOME_FAILED"] = "shipped_to_home_failed";
    KitOrderStatus["DELIVERED_TO_HOME"] = "delivered_to_home";
    KitOrderStatus["DELIVERED_TO_HOME_ACTIVATED"] = "delivered_to_home_activated";
    KitOrderStatus["COLLECTED_ONSITE_ACTIVATED"] = "collected_onsite_activated";
    KitOrderStatus["SHIPPED_TO_LAB"] = "shipped_to_lab";
    KitOrderStatus["USPS_LOST_PACKAGE"] = "usps_lost_package";
    KitOrderStatus["USPS_LOST_PACKAGE_NEW_KIT_SHIPPED"] = "usps_lost_package_new_kit_shipped";
    KitOrderStatus["AT_LAB_SEQUENCING"] = "at_lab_sequencing";
    KitOrderStatus["AT_LAB_SEQUENCING_KNOWN_DELAY"] = "at_lab_sequencing_known_delay";
    KitOrderStatus["AT_LAB_SEQUENCING_UNKNOWN_DELAY"] = "at_lab_sequencing_unknown_delay";
    KitOrderStatus["AT_LAB_NOT_ACTIVATED"] = "at_lab_not_activated";
    KitOrderStatus["AT_LAB_DATA_REUSE"] = "at_lab_data_reuse";
    KitOrderStatus["PENDING_EXTERNAL_PHYSICIAN"] = "pending_external_physician";
    KitOrderStatus["PENDING_GC_SESSION"] = "pending_gc_session";
    KitOrderStatus["RELEASED_NOT_OPENED"] = "released_not_opened";
    KitOrderStatus["RELEASED_AND_OPENED"] = "released_opened";
    KitOrderStatus["RERELEASED_NOT_OPENED"] = "rereleased_not_opened";
    KitOrderStatus["RERELEASED_AND_OPENED"] = "rereleased_opened";
    KitOrderStatus["WISDOM_ORDER"] = "wisdom_order";
    KitOrderStatus["CANCELED_ORDER"] = "canceled";
})(exports.KitOrderStatus || (exports.KitOrderStatus = {}));
const ReleasedReportStates = [
    exports.KitOrderStatus.RELEASED_NOT_OPENED,
    exports.KitOrderStatus.RELEASED_AND_OPENED,
    exports.KitOrderStatus.RERELEASED_NOT_OPENED,
    exports.KitOrderStatus.RERELEASED_AND_OPENED,
];
const CANCER_TEST_TYPES = [
    exports.KitOrderTestType.HEREDITARY_30,
    exports.KitOrderTestType.HEREDITARY_25,
    exports.KitOrderTestType.HEREDITARY_41,
    exports.KitOrderTestType.BREAST_OVARIAN_19,
    exports.KitOrderTestType.WISDOM_9,
    exports.KitOrderTestType.BRCA_1_2,
    exports.KitOrderTestType.HEREDITARY_7,
    exports.KitOrderTestType.PMS_2,
];
const GENETIC_TEST_TYPES = [
    ...CANCER_TEST_TYPES,
    exports.KitOrderTestType.FH_5,
    exports.KitOrderTestType.FH_3,
    exports.KitOrderTestType.CARDIO_30,
    exports.KitOrderTestType.WES,
    exports.KitOrderTestType.WGS,
    exports.KitOrderTestType.LCWGS,
    exports.KitOrderTestType.PGX_V1,
    exports.KitOrderTestType.PGX_V3,
    exports.KitOrderTestType.METABOLISM_4,
    exports.KitOrderTestType.ACMG_59,
    exports.KitOrderTestType.HDR_59,
    exports.KitOrderTestType.AOU_HDR_V1,
    exports.KitOrderTestType.AOU_PGX_V1,
];
const COVID_TEST_TYPES = [
    exports.KitOrderTestType.COVID_19,
    exports.KitOrderTestType.COVID_19_ANTIGEN,
];
const ESSENTIAL_CARE_TEST_TYPES = [exports.KitOrderTestType.ESSENTIAL_CARE_KIT];
const STI_TEST_TYPES = [
    exports.KitOrderTestType.CHLAMYDIA_ANAL,
    exports.KitOrderTestType.CHLAMYDIA_ORAL,
    exports.KitOrderTestType.CHLAMYDIA_URINE,
    exports.KitOrderTestType.GONORRHEA_ANAL,
    exports.KitOrderTestType.GONORRHEA_ORAL,
    exports.KitOrderTestType.GONORRHEA_URINE,
];

/**
 * Return all roles that the given user account represents.
 *
 * Roles form the basis of which content a user is able to view and interact with.
 * Permission enforcement occurs at the API level, but we can identify which applications
 * a user should be able to interact with by inspecting their user object.
 *
 * Any given user will be expected to have at least one role:
 * At the very least, a user who has not had a Color test will have `UserRole.NO_TEST`.
 * (And users who *have* had a test will have at least a `COVID_*` role and/or `GENETICS`)
 *
 * Users may have several separate roles!
 * For example, providers and Color admins may still get Color tests for themselves.
 */
function getRoles(user) {
    const userIsNonDependentProxy = user.is_proxy && !user.is_dependent;
    const hasCovidTest = user.test_types.some((testType) => COVID_TEST_TYPES.includes(testType)) ||
        user.has_user_reported_test_results;
    const hasCovidServices = hasCovidTest || user.has_vaccination_status;
    const hasStiTest = user.test_types.some((testType) => STI_TEST_TYPES.includes(testType));
    const userHasEssentialCareTest = lodash.intersection(user.test_types, ESSENTIAL_CARE_TEST_TYPES).length > 0;
    // For every role, should the user be considered to have that role?
    // (By using a mapping here, we guarantee that every UserRole is handled)
    // If future developers add a new UserRole, TypeScript will warn that this is incomplete
    const roleConditions = {
        [exports.UserRole.USER_WITH_ACCOUNT]: !user.is_proxy,
        [exports.UserRole.NO_TEST]: !user.test_types.length,
        [exports.UserRole.COVID_NON_DEPENDENT_PROXY]: hasCovidServices && userIsNonDependentProxy,
        /**
         * FIXME: This relies on a temporary property that will be removed.
         * See https://getcolor.atlassian.net/browse/ANTI-286
         */
        [exports.UserRole.COVID_FULL_USER_OR_DEPENDENT]: hasCovidServices && !userIsNonDependentProxy,
        [exports.UserRole.ESSENTIAL_CARE_USER]: userHasEssentialCareTest,
        [exports.UserRole.CARE_FULL_USER_OR_DEPENDENT]: userHasEssentialCareTest || user.deprecated_has_been_consulted_for_paxlovid,
        [exports.UserRole.STI_TEST_USER]: hasStiTest,
        [exports.UserRole.COVID_SITE_MANAGER]: user.is_covid_site_manager,
        [exports.UserRole.GENETICS]: 
        // By default, we should assume somebody does not (yet) have the GENETICS role, unless they buy a kit.
        // Users without tests are not genetics users.
        user.test_types.some((testType) => GENETIC_TEST_TYPES.includes(testType)),
        [exports.UserRole.PROVIDER]: user.is_provider,
        [exports.UserRole.COLOR_EMPLOYEE]: user.is_color_employee,
        [exports.UserRole.DASHBOARD_VIEWER]: user.is_dashboard_viewer,
        [exports.UserRole.ACCESS_MANAGER]: user.is_access_manager,
        [exports.UserRole.SUPPORT_STAFF]: user.is_support_staff,
        [exports.UserRole.SUPPORT_ADMIN]: user.is_support_admin,
        [exports.UserRole.SAMPLE_REVIEWER]: user.is_sample_reviewer,
        [exports.UserRole.ORDERING_PHYSICIAN]: user.is_ordering_physician,
        [exports.UserRole.GENETIC_COUNSELOR]: user.is_genetic_counselor,
        [exports.UserRole.EXTERNAL_CLASSIFICATION_REVIEWER]: user.is_external_classification_reviewer,
        [exports.UserRole.VARIANT_REVIEWER]: user.is_variant_reviewer,
        [exports.UserRole.VARIANT_REVIEWER_MANAGER]: user.is_variant_reviewer_manager,
        [exports.UserRole.GENETICS_BOARD_MEMBER]: user.is_genetics_board_member,
        [exports.UserRole.PATHOLOGIST]: user.is_pathologist,
        [exports.UserRole.COLLECTION_SITE_ADMIN]: user.collection_site_permissions?.length > 0 ||
            user.roles?.some((role) => role.scope_content_type === 'collection-site' ||
                role.role_type === exports.ScopedRoleType.VACCINATION_PLATFORM_SUPER_ADMIN),
        [exports.UserRole.FULFILLMENT_STAFF]: user.is_fulfillment_staff,
        // TODO: VAX-4858 This "getRoles()" function relies primarily on the Group model
        // but these two rely on the Role model. We need a larger refactor to handle consistently.
        // Minimum: extract this into a util function for hasScopedRole().
        [exports.UserRole.CONTACT_MANAGER]: user.roles?.some((role) => role.role_type === exports.ScopedRoleType.CONTACT_MANAGER),
        [exports.UserRole.ELIGIBILITY_DATA_MANAGER]: user.roles?.some((role) => role.role_type === exports.ScopedRoleType.ELIGIBILITY_DATA_MANAGER),
        [exports.UserRole.VACCINATION_PLATFORM_SUPER_ADMIN]: user.roles?.some((role) => role.role_type === exports.ScopedRoleType.VACCINATION_PLATFORM_SUPER_ADMIN),
        [exports.UserRole.VACCINATION_PLATFORM_STAFF_MANAGER]: user.roles?.some((role) => role.role_type === exports.ScopedRoleType.VACCINATION_PLATFORM_STAFF_MANAGER),
        [exports.UserRole.VACCINATION_PLATFORM_SITE_MANAGER]: user.roles?.some((role) => role.role_type === exports.ScopedRoleType.VACCINATION_PLATFORM_SITE_MANAGER),
        [exports.UserRole.VACCINATION_PLATFORM_SCRIBE]: user.roles?.some((role) => role.role_type === exports.ScopedRoleType.VACCINATION_PLATFORM_SCRIBE),
        [exports.UserRole.VACCINATION_PLATFORM_SITE_STAFF]: user.roles?.some((role) => role.role_type === exports.ScopedRoleType.VACCINATION_PLATFORM_SITE_STAFF),
        [exports.UserRole.VACCINATION_PLATFORM_VACCINATING_CLINICIAN]: user.roles?.some((role) => role.role_type === exports.ScopedRoleType.VACCINATION_PLATFORM_VACCINATING_CLINICIAN),
        [exports.UserRole.VACCINATION_PLATFORM_SITE_INVENTORY_MANAGER]: user.roles?.some((role) => role.role_type === exports.ScopedRoleType.VACCINATION_PLATFORM_SITE_INVENTORY_MANAGER),
        [exports.UserRole.VACCINATION_PLATFORM_BULK_INVENTORY_MANAGER]: user.roles?.some((role) => role.role_type === exports.ScopedRoleType.VACCINATION_PLATFORM_BULK_INVENTORY_MANAGER),
    };
    return Object.values(exports.UserRole).filter((role) => roleConditions[role]);
}

function getFullName(user) {
    return `${user.first_name} ${user.last_name}`;
}
function hasRole(user, role) {
    const userRoles = getRoles(user);
    return userRoles.includes(role);
}
function hasAnyRoles(user, roles) {
    const userRoles = getRoles(user);
    return roles.some((role) => userRoles.includes(role));
}

function hasPermissions(user, permissions) {
    return permissions.every((permission) => Boolean(user.permissions[permission]));
}
function isUserAuthorized(currentUser, authProps) {
    const { allowedRoles = [], requiredPermissions = [], signedOutUserIsAllowed = false } = authProps;
    if (currentUser) {
        const userHasAllowedRoles = allowedRoles.some((role) => hasRole(currentUser, role) ||
            currentUser.dependents.some((dependent) => hasRole(dependent, role)));
        const userHasPermissions = hasPermissions(currentUser, requiredPermissions);
        if (allowedRoles.length > 0 && requiredPermissions.length > 0) {
            throw new Error('Both roles and permissions are specified.  You likely only want one set.');
        }
        else if (allowedRoles.length > 0) {
            return userHasAllowedRoles;
        }
        else if (requiredPermissions.length > 0) {
            return userHasPermissions;
        }
        return true;
    }
    return signedOutUserIsAllowed;
}

function useAuthorization(props) {
    const { hasInitializedUser, currentUser } = useAuthContext();
    const { allowedRoles, requiredPermissions, signedOutUserIsAllowed } = props;
    if (hasInitializedUser) {
        const userIsAuthorized = isUserAuthorized(currentUser, {
            allowedRoles,
            requiredPermissions,
            signedOutUserIsAllowed,
        });
        return userIsAuthorized ? exports.PermissionType.ALLOWED : exports.PermissionType.NOT_ALLOWED;
    }
    return exports.PermissionType.UNKNOWN;
}

const COLOR_DATE_FORMAT = `PP`; // E.g. Apr 20, 2020
const COLOR_LONG_DATE_FORMAT = 'PPPP'; // E.g. Monday, April 20th, 2020
const COLOR_TIME_FORMAT = 'p'; // E.g. 4:20 PM.
const COLOR_DATETIME_FORMAT = `${COLOR_DATE_FORMAT}, ${COLOR_TIME_FORMAT}`; // E.g. Apr 20, 2020, 4:20 PM
const COLOR_TIMEZONE_FORMAT = 'zzz'; // E.g. Monday, April 20th, 2020 at 4:20 PM EDT
const COLOR_TIME_WITH_TIMEZONE_FORMAT = `${COLOR_TIME_FORMAT} ${COLOR_TIMEZONE_FORMAT}`; // E.g. 4:20 PM EDT
const COLOR_DATETIME_WITH_TIMEZONE_FORMAT = `${COLOR_DATE_FORMAT}, ${COLOR_TIME_FORMAT} ${COLOR_TIMEZONE_FORMAT}`; // E.g. Apr 20, 2020, 4:20 PM EDT
const COLOR_LONG_DATETIME_WITH_TIMEZONE_FORMAT = `PPPPp ${COLOR_TIMEZONE_FORMAT}`; // E.g. Monday, April 20th, 2020 at 4:20 PM EDT

const VALID_DATETIME_FORMATS = [
    COLOR_DATE_FORMAT,
    COLOR_LONG_DATE_FORMAT,
    COLOR_TIME_FORMAT,
    COLOR_DATETIME_FORMAT,
    COLOR_TIMEZONE_FORMAT,
    COLOR_DATETIME_WITH_TIMEZONE_FORMAT,
    COLOR_LONG_DATETIME_WITH_TIMEZONE_FORMAT,
    COLOR_TIME_WITH_TIMEZONE_FORMAT,
];
class DateTimeFormatError extends Error {
    constructor(dateFormat) {
        super(`Unexpected date time format ${dateFormat}`);
    }
}
function getZonedDateTimeFromDateTime(dateTime, timeZone) {
    let dateObj = lodash.isString(dateTime) ? dateFns.parseISO(dateTime) : dateTime;
    if (timeZone) {
        dateObj = dateFnsTz.utcToZonedTime(dateTime, timeZone);
    }
    return dateObj;
}
/**
 * Formats a date according to the given format.
 * @param dateTime - The date to format. If string, will parse it to a date object
 */
function formatDateTimeWithFormat(dateTime, dateFormat, options) {
    if (!VALID_DATETIME_FORMATS.includes(dateFormat)) {
        throw new DateTimeFormatError(dateFormat);
    }
    return dateFnsTz.format(getZonedDateTimeFromDateTime(dateTime, options?.timeZone), dateFormat, options);
}
/**
 * Return a formatted date string e.g. "Apr 20, 2020"
 */
function formatDate(date, options) {
    return formatDateTimeWithFormat(date, COLOR_DATE_FORMAT, options);
}
function formatLongDate(date, options) {
    return formatDateTimeWithFormat(date, COLOR_LONG_DATE_FORMAT, options);
}
function formatDateTime(date, options) {
    return formatDateTimeWithFormat(date, COLOR_DATETIME_FORMAT, options);
}
function formatTime(date, options) {
    return formatDateTimeWithFormat(date, COLOR_TIME_FORMAT, options);
}
function formatTimeZone(date, options) {
    return formatDateTimeWithFormat(date, COLOR_TIMEZONE_FORMAT, options);
}
function formatTimeWithTimeZone(date, options) {
    return formatDateTimeWithFormat(date, COLOR_TIME_WITH_TIMEZONE_FORMAT, options);
}
function formatDateTimeWithTimeZone(date, options) {
    return formatDateTimeWithFormat(date, COLOR_DATETIME_WITH_TIMEZONE_FORMAT, options);
}
function formatLongDateTimeWithTimeZone(date, options) {
    return formatDateTimeWithFormat(date, COLOR_LONG_DATETIME_WITH_TIMEZONE_FORMAT, options);
}
/**
 * Return a formatted short date string e.g. "Apr 20"
 */
function formatShortDate(date, options) {
    const zonedTime = getZonedDateTimeFromDateTime(date, options?.timeZone);
    return zonedTime.toLocaleDateString(options?.locale, { month: 'short', day: 'numeric' });
}
/**
 * Return a formatted date string without year e.g. "April 20"
 */
function formatDateWithoutYear(date, options) {
    const zonedTime = getZonedDateTimeFromDateTime(date, options?.timeZone);
    return zonedTime.toLocaleDateString(options?.locale, { month: 'long', day: 'numeric' });
}
/**
 * Return a formatted date string with year e.g. "April 20, 2020"
 */
function formatDateWithMonthAndYear(date, options) {
    const zonedTime = getZonedDateTimeFromDateTime(date, options?.timeZone);
    return zonedTime.toLocaleDateString(options?.locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
}
function formatDateRange(dateRange) {
    return `${formatShortDate(dateRange.start)} - ${formatShortDate(dateRange.end)}`;
}
/**
 * Return a formatted, localized, short time string or date string:
 * - If date is today, return time string e.g. "3:32 PM"
 * - If date is before today, return date string with 2 digit year, e.g. "4/17/23"
 * - If date is after today, return date string with 4 digit year, e.g. "4/17/2042"
 */
function formatShortDateTime(dateTime, options) {
    const zonedDateTime = getZonedDateTimeFromDateTime(dateTime, options?.timeZone);
    if (dateFns.isToday(zonedDateTime)) {
        return zonedDateTime.toLocaleTimeString(options?.locale, {
            hour: 'numeric',
            minute: '2-digit',
        });
    }
    return dateTime.toLocaleDateString(options?.locale, {
        month: 'numeric',
        day: 'numeric',
        year: dateFns.isFuture(zonedDateTime) ? 'numeric' : '2-digit',
    });
}

function getDateFromTimeString(date, timeString, timeZone) {
    let newDate;
    if (/:..:/.test(timeString)) {
        newDate = dateFns.parse(timeString, 'HH:mm:ss', date);
    }
    else {
        newDate = dateFns.parse(timeString, 'HH:mm', date);
    }
    if (!dateFns.isValid(newDate)) {
        throw new Error(`Failed to parse '${timeString}' into a time.`);
    }
    if (timeZone) {
        return dateFnsTz.zonedTimeToUtc(newDate, timeZone);
    }
    return newDate;
}

/**
 * @fileoverview
 *
 * These are common utilities for operations to/from/on Temporal objects.
 * They are used in the implementation of our isoDateString and isoDateFields
 * utilties but are not intended to be exported for broader use.
 *
 */
const getPlainDateFrom = polyfill.Temporal.PlainDate.from;
const getCurrentPlainDate = () => {
    return polyfill.Temporal.Now.plainDateISO();
};
const getPlainDateOrNullFrom = (item) => {
    try {
        return getPlainDateFrom(item, { overflow: 'reject' });
    }
    catch {
        return null;
    }
};
const getPlainDateOrNullFromDate = (date) => {
    try {
        return polyfill.toTemporalInstant.apply(date).toZonedDateTimeISO(polyfill.Temporal.Now.timeZone()).toPlainDate();
    }
    catch {
        return null;
    }
};
const getZonedDateTimeOrNullFromIsoDateTimeString = (dateTimeString) => {
    try {
        return polyfill.Temporal.ZonedDateTime.from(`${dateTimeString}[${polyfill.Temporal.Now.timeZone()}]`, {
            overflow: 'reject',
            offset: 'use',
        });
    }
    catch {
        return null;
    }
};
const getZonedDateTimeOrNullFromIsoDateString = (dateString, options) => {
    try {
        return getPlainDateFrom(dateString).toZonedDateTime({
            timeZone: options?.timeZone ?? polyfill.Temporal.Now.timeZone(),
            plainTime: options?.plainTime,
        });
    }
    catch {
        return null;
    }
};
const isPlainDateAfter = (date, dateToCompare) => {
    return polyfill.Temporal.PlainDate.compare(date, dateToCompare) > 0;
};
const isPlainDateBefore = (date, dateToCompare) => {
    return polyfill.Temporal.PlainDate.compare(date, dateToCompare) < 0;
};

/**
 * Returns the age calculated in whole years for given date string,
 * or null if the date or input is invalid.
 */
const getAgeInYearsFromBirthdayIsoDateString = (birthdayIsoString) => {
    const birthdayPlainDate = getPlainDateOrNullFrom(birthdayIsoString);
    if (!birthdayPlainDate) {
        throw new Error(`Cannot calculate age from invalid ISO date, ${birthdayIsoString}`);
    }
    const age = getCurrentPlainDate().since(birthdayPlainDate, {
        largestUnit: 'year',
    }).years;
    return age;
};
/**
 * Returns the age calculated in whole years for given date string,
 * or null if the date or input is invalid.
 */
const getAgeInMonthsFromBirthdayIsoDateString = (birthdayIsoString) => {
    const birthdayPlainDate = getPlainDateOrNullFrom(birthdayIsoString);
    if (!birthdayPlainDate) {
        throw new Error(`Cannot calculate age from invalid ISO date, ${birthdayIsoString}`);
    }
    const age = getCurrentPlainDate().since(birthdayPlainDate, {
        largestUnit: 'month',
    }).months;
    return age;
};
/**
 * Returns true if the birthdate has reached the given age.
 */
const isBirthdayIsoDateStringAtLeastNYearsOld = (birthday, minimumAgeInYears) => {
    return getAgeInYearsFromBirthdayIsoDateString(birthday) >= minimumAgeInYears;
};
/**
 * Returns true if the birthdate has reached adult age
 */
function isBirthdayIsoDateStringAdultAge(birthday) {
    return getAgeInYearsFromBirthdayIsoDateString(birthday) >= ADULT_MINIMUM_AGE;
}

/**
 * Returns the long date format (e.g. January 1, 2000) of
 * the ISO date string in the given locale. If locale is not
 * specified, it will use the locale set in the document's
 * lang attribute, or the browser's default language.
 */
function formatLongIsoDateString(date, locale = document.documentElement.lang) {
    const plainDate = getPlainDateOrNullFrom(date);
    if (!plainDate) {
        throw new Error(`Cannot format an invalid date, ${date}`);
    }
    // Empty locale string is converted to undefined and falls back to browser locale.
    let formattedDate = plainDate.toLocaleString(locale || undefined, {
        dateStyle: 'long',
    });
    // Ensure formatting doesn't change for specific locales.
    // toLocaleString formatting changed in node v20.12.1
    if (locale === 'am') {
        const monthMapping = [
            'ጃንዩወሪ',
            'ፌብሩወሪ',
            'ማርች',
            'ኤፕሪል',
            'ግንቦት',
            'ሰኔ',
            'ሐምሌ',
            'ነሐሴ',
            'መስከረም',
            'ጥቅምት',
            'ሕዳር',
            'ታህሳስ',
        ];
        formattedDate = `${plainDate.day} ${monthMapping[plainDate.month - 1]} ${plainDate.year}`;
    }
    return formattedDate;
}
/**
 * Returns the short date format ("1/2/06") of
 * the ISO date string in the given locale. If locale is not
 * specified, it will use the locale set in the document's
 * lang attribute, or the browser's default language.
 */
function formatShortIsoDateString(date, locale = document.documentElement.lang) {
    const plainDate = getPlainDateOrNullFrom(date);
    if (!plainDate) {
        throw new Error(`Cannot format an invalid date, ${date}`);
    }
    let formattedDate = plainDate.toLocaleString(locale || undefined, {
        dateStyle: 'short',
    });
    // Ensure formatting doesn't change for specific locales.
    // toLocaleString formatting changed in node v20.12.1
    if (locale === 'vi') {
        const dateParts = formattedDate.split('/');
        formattedDate = `${dateParts[0].padStart(2, '0')}/${dateParts[1].padStart(2, '0')}/${plainDate.year}`;
    }
    // Empty locale string is converted to undefined and falls back to browser locale.
    return formattedDate;
}
/**
 * Returns a custom date format for use in tables
 * ("Wed 22") of the ISO date string in the given locale. If locale is not
 * specified, it will use the locale set in the document's
 * lang attribute, or the browser's default language.
 */
function formatIsoDateStringForTable(date, locale = document.documentElement.lang) {
    const plainDate = getPlainDateOrNullFrom(date);
    if (!plainDate) {
        throw new Error(`Cannot format an invalid date, ${date}`);
    }
    const shortWeekdayString = plainDate.toLocaleString(locale || undefined, {
        weekday: 'short',
    });
    const numericDay = plainDate.toLocaleString(locale || undefined, {
        day: 'numeric',
    });
    // Empty locale string is converted to undefined and falls back to browser locale.
    return `${shortWeekdayString} ${numericDay}`;
}

const US_DATE_STRING_LENGTH = 10;
/**
 * Parses a string as an ISO date ('YYYY-MM-DD') and returns an
 * object with its respective fields {year, month, day}, or null if not a valid date string.
 */
const getIsoDateFieldsFromIsoDateString = (isoString) => {
    const plainDate = getPlainDateOrNullFrom(isoString);
    if (plainDate) {
        return {
            year: plainDate.year,
            month: plainDate.month,
            day: plainDate.day,
        };
    }
    return null;
};
/**
 * Receives an object with {year, month, day} fields and returns the ISO date
 * string or null if invalid.
 */
const getIsoDateStringFromIsoDateFields = (isoDateFields) => {
    const plainDate = getPlainDateOrNullFrom(isoDateFields);
    if (plainDate) {
        return plainDate.toString();
    }
    return null;
};
/**
 * Parses a string as an ISO date ('YYYY-MM-DD') and returns a Date or null if invalid.
 */
const getDateFromIsoDateString = (isoString) => {
    const zonedDateTime = getZonedDateTimeOrNullFromIsoDateString(isoString);
    if (zonedDateTime) {
        return new Date(zonedDateTime.epochMilliseconds);
    }
    return null;
};
/**
 * Receives a Date and returns the ISO date string or null if invalid.
 */
const getIsoDateStringFromDate = (date) => {
    const plainDate = getPlainDateOrNullFromDate(date);
    if (plainDate) {
        return plainDate.toString();
    }
    return null;
};
/**
 * Receives an ISO 8601 long date time string e.g. "2023-02-22T11:25:32.585709-08:00"
 * and returns the short ISO date string "2023-02-22" or null if invalid.
 */
const getIsoDateStringFromIsoLongDateTimeString = (dateTimeString) => {
    const zonedDateTime = getZonedDateTimeOrNullFromIsoDateTimeString(dateTimeString);
    if (zonedDateTime) {
        return zonedDateTime.toPlainDate().toString();
    }
    return null;
};
/** Returns true if string is a valid date, returns false for invalid dates or invalid input. */
const isIsoDateStringValid = (isoString) => {
    return Boolean(getPlainDateOrNullFrom(isoString));
};
/** Returns true if object represents a valid date, returns false for invalid dates or invalid input. */
const isIsoDateFieldsValid = (isoDateFields) => {
    return Boolean(getPlainDateOrNullFrom(isoDateFields));
};
/** Returns the ISO date string that represents today's date. */
const getIsoDateStringForToday = () => {
    return getCurrentPlainDate().toString();
};
/**
 * Returns the ISO date string that represents the date `years` , `months` , and `days` prior to today
 */
function getIsoDateStringBeforeToday(interval) {
    return getCurrentPlainDate().subtract(interval).toString();
}
/**
 * Returns the ISO date string that represents the date `years` , `months` , and `days` after today
 */
function getIsoDateStringAfterToday(interval) {
    return getCurrentPlainDate().add(interval).toString();
}
/**
 * Adds the specified interval to the given date string and returns the result as a date string.
 * Throws an error if the date is invalid.
 */
function addToIsoDateString(date, interval) {
    const plainDate = getPlainDateOrNullFrom(date);
    if (!plainDate) {
        throw new Error(`Cannot add to invalid ISO date, ${date}`);
    }
    return plainDate.add(interval).toString();
}
/**
 * Subtracts the specified interval from the given date string and returns the result as a date string.
 * Throws an error if the date is invalid.
 */
function subtractFromIsoDateString(date, interval) {
    const plainDate = getPlainDateOrNullFrom(date);
    if (!plainDate) {
        throw new Error(`Cannot subtract from invalid ISO date, ${date}`);
    }
    return plainDate.subtract(interval).toString();
}
/**
 * Returns true if dateString is after dateToCompare, or false if same or before.
 * Throws an error if either date is an invalid IsoDateString.
 */
const isIsoDateStringAfter = (date, dateToCompare) => {
    const plainDate = getPlainDateOrNullFrom(date);
    const plainDateToCompare = getPlainDateOrNullFrom(dateToCompare);
    if (!plainDate || !plainDateToCompare) {
        throw new Error('isIsoDateAfter requires two valid IsoDates to compare');
    }
    return isPlainDateAfter(plainDate, plainDateToCompare);
};
/**
 * Returns true if dateString is before dateToCompare, or false if same, or after.
 * Throws an error if either date is an invalid IsoDateString.
 */
const isIsoDateStringBefore = (date, dateToCompare) => {
    const plainDate = getPlainDateOrNullFrom(date);
    const plainDateToCompare = getPlainDateOrNullFrom(dateToCompare);
    if (!plainDate || !plainDateToCompare) {
        throw new Error('isIsoDateBefore requires two valid IsoDates to compare');
    }
    return isPlainDateBefore(plainDate, plainDateToCompare);
};
function getIsoDateStringFromUsDateString(dateString) {
    if (dateString.length !== US_DATE_STRING_LENGTH) {
        return null;
    }
    const [month, day, year] = dateString.split('/');
    const isoDateString = `${year}-${month}-${day}`;
    return isIsoDateStringValid(isoDateString) ? isoDateString : null;
}
function getUsDateStringFromIsoDateString(dateString) {
    if (!isIsoDateStringValid(dateString)) {
        return null;
    }
    const [year, month, day] = dateString.split('-');
    return `${month}/${day}/${year}`;
}
/** Gets the ISO datetime string with timezone offset for the start time of the isoDateString date. */
const getStartOfDayFromIsoDateString = (isoString) => {
    const zonedDateTime = getZonedDateTimeOrNullFromIsoDateString(isoString);
    if (!zonedDateTime) {
        throw new Error(`Cannot get start of day from invalid iso date string, ${isoString}`);
    }
    return zonedDateTime.startOfDay().toString({ timeZoneName: 'never' });
};
/** Gets the ISO datetime string with timezone offset for the end time of the isoDateString date. */
const getEndOfDayFromIsoDateString = (isoString) => {
    const zonedDateTime = getZonedDateTimeOrNullFromIsoDateString(isoString, {
        plainTime: '23:59:59.999',
    });
    if (!zonedDateTime) {
        throw new Error(`Cannot get start of day from invalid iso date string, ${isoString}`);
    }
    return zonedDateTime.toString({ timeZoneName: 'never' });
};

/**
 * Converts start and end date IsoDateStrings to a validated IIsoDateStringDateRange.
 * Returns a date range that ranges from the start date, to the end date, inclusive,
 * or throws an error if dates are invalid or the end date occurs before the start date.
 * Use with `getStartOfDayFromIsoDateString()` and `getEndOfDayFromIsoDateString()` to
 * get ISO datetime strings with timezone offset representing the start of the start date
 * and end of the end date.
 */
function toIsoDateStringDateRange(startDateString, endDateString) {
    if (!isIsoDateStringValid(startDateString) || !isIsoDateStringValid(endDateString)) {
        throw new Error(`Cannot create date range with invalid dates. Received (${startDateString}, ${endDateString})`);
    }
    if (isIsoDateStringAfter(startDateString, endDateString)) {
        throw new Error(`Date range is invalid, ${startDateString} must be before ${endDateString}`);
    }
    return {
        start: startDateString,
        end: endDateString,
    };
}
function formatIsoDateStringDateRange(dateRange) {
    return `${formatShortIsoDateString(dateRange.start)} - ${formatShortIsoDateString(dateRange.end)}`;
}
/**
 * Return array of formatted days in dateRange including last day.
 * E.g. ['Tue 20', 'Wed 21', 'Thu 22']
 */
function getFormattedDaysFromIsoDateStringDateRange(dateRange) {
    const { start: rangeStart, end: rangeEnd } = dateRange;
    if (isIsoDateStringAfter(rangeStart, rangeEnd)) {
        throw new Error(`Date range is invalid, ${rangeStart} must be before ${rangeEnd}`);
    }
    const days = [];
    let day = rangeStart;
    while (!isIsoDateStringAfter(day, rangeEnd)) {
        days.push(formatIsoDateStringForTable(day));
        day = addToIsoDateString(day, { days: 1 });
    }
    return days;
}

function getHoursInMilliseconds(hours) {
    return hours * 3600 * 1000;
}

const ONE_SECOND_IN_MILLISECONDS = 1000;
const ONE_MINUTE_IN_MILLISECONDS = 60 * ONE_SECOND_IN_MILLISECONDS;
const ONE_HOUR_IN_MILLISECONDS = 60 * ONE_MINUTE_IN_MILLISECONDS;
const ONE_DAY_IN_MILLISECONDS = 24 * ONE_HOUR_IN_MILLISECONDS;
const ONE_WEEK_IN_MILLISECONDS = 7 * ONE_DAY_IN_MILLISECONDS;

/**
 *
 * @param delimitedValues whitespace delimited values
 * @returns array of undelimited strings
 */
function extractDelimitedValues(delimitedValues) {
    return lodash.uniq(delimitedValues.split(/\s{1,}/).filter((email) => email.length));
}
/**
 *
 * @param email
 * @returns email is valid
 */
function isEmailValid(email) {
    return Yup__namespace.string().email('Email valid').isValidSync(email);
}
/**
 *
 * @param delimitedEmails whitespace delimited emails
 * @returns error message describing invalid emails or null
 */
function getInvalidEmailErrorMessage(delimitedEmails) {
    const emails = extractDelimitedValues(delimitedEmails);
    const invalidEmails = emails.filter((email) => {
        return !isEmailValid(email);
    });
    const errorCount = invalidEmails.length;
    if (!errorCount) {
        return null;
    }
    let errorMessage = `'${invalidEmails[0]}' is not a valid email`;
    if (errorCount > 1) {
        errorMessage += `, along with ${errorCount - 1} ${pluralize__default["default"]('other', errorCount - 1)}`;
    }
    return `${errorMessage}.`;
}

/**
 * Frontend representation of ethnicity values used across the application.
 * This is a combination of PatientProfileEthnicity and NewPatientProfileEthnicity
 * from monoweb/django_apps/ordering_physicians/constants.py
 */
exports.Ethnicity = void 0;
(function (Ethnicity) {
    // From PatientProfileEthnicity
    Ethnicity["AFRICAN_AMERICAN_BLACK"] = "African American / Black";
    Ethnicity["ASIAN"] = "Asian";
    Ethnicity["CAMBODIAN"] = "Cambodian";
    Ethnicity["CHINESE"] = "Chinese";
    Ethnicity["FILIPINO"] = "Filipino";
    Ethnicity["INDIAN"] = "Asian Indian";
    Ethnicity["JAPANESE"] = "Japanese";
    Ethnicity["KOREAN"] = "Korean";
    Ethnicity["LAOTIAN"] = "Laotian";
    Ethnicity["VIETNAMESE"] = "Vietnamese";
    Ethnicity["LATINO"] = "Latino/a";
    Ethnicity["NATIVE_AMERICAN"] = "Native American";
    Ethnicity["MIDDLE_EASTERN"] = "Middle Eastern";
    Ethnicity["NORTH_AFRICAN"] = "North African";
    Ethnicity["NHOP"] = "Native Hawaiian or Other Pacific Islander (NHOP)";
    Ethnicity["GUAMANIAN"] = "Guamanian";
    Ethnicity["HAWAIIAN"] = "Hawaiian";
    Ethnicity["SAMOAN"] = "Samoan";
    Ethnicity["WHITE"] = "White";
    Ethnicity["MULTIETHNIC"] = "Multiethnic";
    Ethnicity["OTHER"] = "Other";
    // From NewPatientProfileEthnicity
    Ethnicity["AMERICAN_INDIAN_OR_ALASKA_NATIVE"] = "American Indian or Alaska Native";
    Ethnicity["INDIAN_ONLY"] = "Indian";
    Ethnicity["ASIAN_PREFER_NOT_TO_SAY"] = "Asian (prefer not to say)";
    Ethnicity["BLACK_OR_AFRICAN_AMERICAN"] = "Black or African American";
    Ethnicity["OTHER_ASIAN"] = "Other Asian";
    Ethnicity["MIDDLE_EASTERN_OR_NORTH_AFRICAN"] = "Middle Eastern or North African";
    Ethnicity["MEXICAN_MEXICAN_AMERICAN_CHICANO"] = "Mexican, Mexican-American, or Chicano/a";
    Ethnicity["CUBAN"] = "Cuban";
    Ethnicity["PUERTO_RICAN"] = "Puerto Rican";
    Ethnicity["OTHER_HISPANIC_OR_LATINO"] = "Other Hispanic or Latino/a";
    Ethnicity["HISPANIC_OR_LATINO_PREFER_NOT_TO_SAY"] = "Hispanic or Latino/a (prefer not to say)";
    Ethnicity["OTHER_PACIFIC_ISLANDER"] = "Other Pacific Islander";
    Ethnicity["PACIFIC_ISLANDER_PREFER_NOT_TO_SAY"] = "Pacific Islander (prefer not to say)";
    Ethnicity["OTHER_NOT_LISTED"] = "Other (not listed)";
    Ethnicity["I_DO_NOT_KNOW"] = "I don\u2019t know";
    Ethnicity["PREFER_NOT_TO_ANSWER"] = "Prefer not to answer";
})(exports.Ethnicity || (exports.Ethnicity = {}));

/**
 * This will soon be deprecated in favor of the new GenderIdentity enum.
 */
exports.GENDER_IDENTITIES = void 0;
(function (GENDER_IDENTITIES) {
    GENDER_IDENTITIES["FEMALE"] = "F";
    GENDER_IDENTITIES["MALE"] = "M";
    GENDER_IDENTITIES["NON_BINARY"] = "non-binary";
    GENDER_IDENTITIES["SELF_DESCRIBED"] = "self-described";
    GENDER_IDENTITIES["PREFER_NOT_TO_RESPOND"] = "prefer not to respond";
    GENDER_IDENTITIES["TRANS_MALE"] = "trans-male";
    GENDER_IDENTITIES["TRANS_FEMALE"] = "trans-female";
    GENDER_IDENTITIES["NOT_LISTED"] = "not-listed";
})(exports.GENDER_IDENTITIES || (exports.GENDER_IDENTITIES = {}));

const US_STATES = [
    { abbreviation: 'AL', fullName: 'Alabama' },
    { abbreviation: 'AK', fullName: 'Alaska' },
    { abbreviation: 'AS', fullName: 'American Samoa' },
    { abbreviation: 'AZ', fullName: 'Arizona' },
    { abbreviation: 'AR', fullName: 'Arkansas' },
    { abbreviation: 'CA', fullName: 'California' },
    { abbreviation: 'CO', fullName: 'Colorado' },
    { abbreviation: 'CT', fullName: 'Connecticut' },
    { abbreviation: 'DE', fullName: 'Delaware' },
    { abbreviation: 'DC', fullName: 'District of Columbia' },
    { abbreviation: 'FL', fullName: 'Florida' },
    { abbreviation: 'GA', fullName: 'Georgia' },
    { abbreviation: 'GU', fullName: 'Guam' },
    { abbreviation: 'HI', fullName: 'Hawaii' },
    { abbreviation: 'ID', fullName: 'Idaho' },
    { abbreviation: 'IL', fullName: 'Illinois' },
    { abbreviation: 'IN', fullName: 'Indiana' },
    { abbreviation: 'IA', fullName: 'Iowa' },
    { abbreviation: 'KS', fullName: 'Kansas' },
    { abbreviation: 'KY', fullName: 'Kentucky' },
    { abbreviation: 'LA', fullName: 'Louisiana' },
    { abbreviation: 'ME', fullName: 'Maine' },
    { abbreviation: 'MD', fullName: 'Maryland' },
    { abbreviation: 'MA', fullName: 'Massachusetts' },
    { abbreviation: 'MI', fullName: 'Michigan' },
    { abbreviation: 'MN', fullName: 'Minnesota' },
    { abbreviation: 'MS', fullName: 'Mississippi' },
    { abbreviation: 'MO', fullName: 'Missouri' },
    { abbreviation: 'MT', fullName: 'Montana' },
    { abbreviation: 'NE', fullName: 'Nebraska' },
    { abbreviation: 'NV', fullName: 'Nevada' },
    { abbreviation: 'NH', fullName: 'New Hampshire' },
    { abbreviation: 'NJ', fullName: 'New Jersey' },
    { abbreviation: 'NM', fullName: 'New Mexico' },
    { abbreviation: 'NY', fullName: 'New York' },
    { abbreviation: 'NC', fullName: 'North Carolina' },
    { abbreviation: 'ND', fullName: 'North Dakota' },
    { abbreviation: 'MP', fullName: 'Northern Mariana Islands' },
    { abbreviation: 'OH', fullName: 'Ohio' },
    { abbreviation: 'OK', fullName: 'Oklahoma' },
    { abbreviation: 'OR', fullName: 'Oregon' },
    { abbreviation: 'PA', fullName: 'Pennsylvania' },
    { abbreviation: 'PR', fullName: 'Puerto Rico' },
    { abbreviation: 'RI', fullName: 'Rhode Island' },
    { abbreviation: 'SC', fullName: 'South Carolina' },
    { abbreviation: 'SD', fullName: 'South Dakota' },
    { abbreviation: 'TN', fullName: 'Tennessee' },
    { abbreviation: 'TX', fullName: 'Texas' },
    { abbreviation: 'VI', fullName: 'U.S. Virgin Islands' },
    { abbreviation: 'UT', fullName: 'Utah' },
    { abbreviation: 'VT', fullName: 'Vermont' },
    { abbreviation: 'VA', fullName: 'Virginia' },
    { abbreviation: 'WA', fullName: 'Washington' },
    { abbreviation: 'WV', fullName: 'West Virginia' },
    { abbreviation: 'WI', fullName: 'Wisconsin' },
    { abbreviation: 'WY', fullName: 'Wyoming' },
    /**
     * Areas that have 2-letter codes but are deliberately omitted because they are
     * outside the US: Federated States of Micronesia, Marshall Islands, and Palau.
     * Areas that are not states but are deliberately included because they are
     * part of the US: American Samoa, District of Columbia, Guam, Northern
     * Mariana Islands, Puerto Rico, Virgin Islands (U.S.).
     */
];
const US_TERRITORIES = ['AS', 'GU', 'MP', 'PR', 'VI'];

// *** DO NOT EDIT THIS OBJECT MANUALLY ***
// It is generated in Python using geographical_area.generate().
//
// To re-generate, edit monoweb.django_apps.users.geographical_area, then run:
//
//     $ python -m monoweb.django_apps.users.geographical_area
//
const GEOGRAPHICAL_AREAS = {
    AF: {
        name: `Afghanistan`,
        phonePrefix: `+93`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 10900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    AL: {
        name: `Albania`,
        phonePrefix: `+355`,
        phoneMask: ``,
        daysToDeliver: `9`,
        shippingChargeCents: 10900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    DZ: {
        name: `Algeria`,
        phonePrefix: `+213`,
        phoneMask: ``,
        daysToDeliver: `11`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    AS: {
        name: `American Samoa`,
        phonePrefix: `+1`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 11600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `City`,
        cityWidth: 55,
        stateMaxlen: 2,
        stateLabel: `State`,
        stateWidth: 20,
        postalCodeMaxlen: ``,
        postalCodeLabel: `Zip Code`,
        postalCodeWidth: 25,
        postalCodeMask: `99999`,
        addressFieldOrder: [[`city`, `state`, `postalCode`]],
        addressOptionalFields: [],
        flagFilename: `US.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    AD: {
        name: `Andorra`,
        phonePrefix: `+376`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 6900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    AO: {
        name: `Angola`,
        phonePrefix: `+244`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    AI: {
        name: `Anguilla`,
        phonePrefix: `+1`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Town`,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 8,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 100,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`], [`postalCode`]],
        addressOptionalFields: [],
        flagFilename: `GB.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    AQ: {
        name: `Antarctica`,
        phonePrefix: ``,
        phoneMask: ``,
        daysToDeliver: ``,
        shippingChargeCents: ``,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    AG: {
        name: `Antigua and Barbuda`,
        phonePrefix: `+1`,
        phoneMask: `(999) 999-9999`,
        daysToDeliver: `5`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    AR: {
        name: `Argentina`,
        phonePrefix: `+54`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    AM: {
        name: `Armenia`,
        phonePrefix: `+374`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 9000,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    AW: {
        name: `Aruba`,
        phonePrefix: `+297`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: `NL.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    AU: {
        name: `Australia`,
        phonePrefix: `+61`,
        phoneMask: ``,
        daysToDeliver: `12`,
        shippingChargeCents: 7900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Suburb`,
        cityWidth: 45,
        stateMaxlen: 3,
        stateLabel: `State Code`,
        stateWidth: 30,
        postalCodeMaxlen: 6,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 25,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`, `state`, `postalCode`]],
        addressOptionalFields: [],
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    AT: {
        name: `Austria`,
        phonePrefix: `+43`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9300,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    AZ: {
        name: `Azerbaijan`,
        phonePrefix: `+994`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 10700,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BS: {
        name: `Bahamas`,
        phonePrefix: `+1`,
        phoneMask: `(999) 999-9999`,
        daysToDeliver: `4`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BH: {
        name: `Bahrain`,
        phonePrefix: `+973`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 9800,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BD: {
        name: `Bangladesh`,
        phonePrefix: `+880`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 7900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BB: {
        name: `Barbados`,
        phonePrefix: `+1`,
        phoneMask: `(999) 999-9999`,
        daysToDeliver: `4`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BY: {
        name: `Belarus`,
        phonePrefix: `+375`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 10700,
        ourGovtOk: false,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BE: {
        name: `Belgium`,
        phonePrefix: `+32`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BZ: {
        name: `Belize`,
        phonePrefix: `+501`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BJ: {
        name: `Benin`,
        phonePrefix: `+229`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BM: {
        name: `Bermuda`,
        phonePrefix: `+1`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Town`,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 8,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 100,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`], [`postalCode`]],
        addressOptionalFields: [],
        flagFilename: `GB.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BT: {
        name: `Bhutan`,
        phonePrefix: `+975`,
        phoneMask: ``,
        daysToDeliver: `10`,
        shippingChargeCents: 9500,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BO: {
        name: `Bolivia`,
        phonePrefix: `+591`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 8100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BQ: {
        name: `Bonaire, Sint Eustatius, and Saba`,
        phonePrefix: `+599`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: `NL.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BA: {
        name: `Bosnia and Herzegovina`,
        phonePrefix: `+387`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 10900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BW: {
        name: `Botswana`,
        phonePrefix: `+267`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BV: {
        name: `Bouvet Island`,
        phonePrefix: ``,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9300,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: `NO.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BR: {
        name: `Brazil`,
        phonePrefix: `+55`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 8100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `City`,
        cityWidth: 80,
        stateMaxlen: 2,
        stateLabel: `State`,
        stateWidth: 20,
        postalCodeMaxlen: 9,
        postalCodeLabel: ``,
        postalCodeWidth: 100,
        postalCodeMask: `99999-999`,
        addressFieldOrder: [[`city`, `state`], [`postalCode`], [`taxId`]],
        addressOptionalFields: [],
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: true,
        taxIdMaxlen: 18,
        taxIdLabel: `Tax ID number (CPF)`,
        taxIdWidth: 100,
        taxIdMask: `999.999.999-99`,
    },
    IO: {
        name: `British Indian Ocean Territory`,
        phonePrefix: `+246`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: `Town`,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 8,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 100,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`], [`postalCode`]],
        addressOptionalFields: [],
        flagFilename: `GB.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BN: {
        name: `Brunei Darussalam`,
        phonePrefix: `+673`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 10200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BG: {
        name: `Bulgaria`,
        phonePrefix: `+359`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 10900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BF: {
        name: `Burkina Faso`,
        phonePrefix: `+226`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BI: {
        name: `Burundi`,
        phonePrefix: `+257`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 11400,
        ourGovtOk: false,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    CV: {
        name: `Cabo Verde`,
        phonePrefix: `+238`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 11400,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    KH: {
        name: `Cambodia`,
        phonePrefix: `+855`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 10200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    CM: {
        name: `Cameroon`,
        phonePrefix: `+237`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    CA: {
        name: `Canada`,
        phonePrefix: `+1`,
        phoneMask: `(999) 999-9999`,
        daysToDeliver: `3`,
        shippingChargeCents: 6800,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `City`,
        cityWidth: 45,
        stateMaxlen: 2,
        stateLabel: `Province`,
        stateWidth: 25,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: `A9A 9A9`,
        addressFieldOrder: [[`city`, `state`, `postalCode`]],
        addressOptionalFields: [],
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: true,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    KY: {
        name: `Cayman Islands`,
        phonePrefix: `+1`,
        phoneMask: ``,
        daysToDeliver: `3`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Town`,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 8,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 100,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`], [`postalCode`]],
        addressOptionalFields: [],
        flagFilename: `GB.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    CF: {
        name: `Central African Republic`,
        phonePrefix: `+236`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 11400,
        ourGovtOk: false,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    TD: {
        name: `Chad`,
        phonePrefix: `+235`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 11400,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    CL: {
        name: `Chile`,
        phonePrefix: `+56`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    CN: {
        name: `China`,
        phonePrefix: `+86`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 5500,
        ourGovtOk: ``,
        theirGovtOk: false,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    CX: {
        name: `Christmas Island`,
        phonePrefix: `+61`,
        phoneMask: ``,
        daysToDeliver: ``,
        shippingChargeCents: ``,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    CC: {
        name: `Cocos (Keeling) Islands`,
        phonePrefix: `+61`,
        phoneMask: ``,
        daysToDeliver: ``,
        shippingChargeCents: ``,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    CO: {
        name: `Colombia`,
        phonePrefix: `+57`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    KM: {
        name: `Comoros`,
        phonePrefix: `+269`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 11400,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    CG: {
        name: `Congo`,
        phonePrefix: `+242`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    CD: {
        name: `Congo (DRC)`,
        phonePrefix: `+243`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 11400,
        ourGovtOk: false,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    CK: {
        name: `Cook Islands`,
        phonePrefix: `+682`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 9500,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Island`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 4,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`, `postalCode`]],
        addressOptionalFields: [],
        flagFilename: `NZ.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    CR: {
        name: `Costa Rica`,
        phonePrefix: `+506`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    HR: {
        name: `Croatia`,
        phonePrefix: `+385`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 10900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    CU: {
        name: `Cuba`,
        phonePrefix: `+53`,
        phoneMask: ``,
        daysToDeliver: ``,
        shippingChargeCents: ``,
        ourGovtOk: false,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    CW: {
        name: `Curaçao`,
        phonePrefix: `+599`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: `NL.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    CY: {
        name: `Cyprus`,
        phonePrefix: `+357`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 9300,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    CZ: {
        name: `Czechia`,
        phonePrefix: `+420`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 10900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    CI: {
        name: `Côte d'Ivoire`,
        phonePrefix: `+225`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 11400,
        ourGovtOk: false,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    DK: {
        name: `Denmark`,
        phonePrefix: `+45`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9300,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    DJ: {
        name: `Djibouti`,
        phonePrefix: `+253`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 11400,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    DM: {
        name: `Dominica`,
        phonePrefix: `+1`,
        phoneMask: `(999) 999-9999`,
        daysToDeliver: `6`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    DO: {
        name: `Dominican Republic`,
        phonePrefix: `+1`,
        phoneMask: `(999) 999-9999`,
        daysToDeliver: `4`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    EC: {
        name: `Ecuador`,
        phonePrefix: `+593`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    EG: {
        name: `Egypt`,
        phonePrefix: `+20`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 8100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    SV: {
        name: `El Salvador`,
        phonePrefix: `+503`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    GQ: {
        name: `Equatorial Guinea`,
        phonePrefix: `+240`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 11400,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    ER: {
        name: `Eritrea`,
        phonePrefix: `+291`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 11400,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    EE: {
        name: `Estonia`,
        phonePrefix: `+372`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 10900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    SZ: {
        name: `Eswatini`,
        phonePrefix: `+268`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 9300,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    ET: {
        name: `Ethiopia`,
        phonePrefix: `+251`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 11400,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    FK: {
        name: `Falkland Islands (Malvinas)`,
        phonePrefix: `+500`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 7200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Town`,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 8,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 100,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`], [`postalCode`]],
        addressOptionalFields: [],
        flagFilename: `GB.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    FO: {
        name: `Faroe Islands`,
        phonePrefix: `+298`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 6900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: `DK.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    FJ: {
        name: `Fiji`,
        phonePrefix: `+679`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 10200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    FI: {
        name: `Finland`,
        phonePrefix: `+358`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9300,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Settlement`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 5,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`postalCode`, `city`]],
        addressOptionalFields: [],
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    FR: {
        name: `France`,
        phonePrefix: `+33`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 6100,
        ourGovtOk: ``,
        theirGovtOk: false,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Town Name and Sorting Code`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 5,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`postalCode`, `city`]],
        addressOptionalFields: [],
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    GF: {
        name: `French Guiana`,
        phonePrefix: `+594`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 7200,
        ourGovtOk: ``,
        theirGovtOk: false,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Town Name and Sorting Code`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 5,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`postalCode`, `city`]],
        addressOptionalFields: [],
        flagFilename: `FR.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    PF: {
        name: `French Polynesia`,
        phonePrefix: `+689`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 10200,
        ourGovtOk: ``,
        theirGovtOk: false,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: `Town Name and Sorting Code`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 5,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`postalCode`, `city`]],
        addressOptionalFields: [],
        flagFilename: `FR.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    TF: {
        name: `French Southern Territories`,
        phonePrefix: ``,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 6100,
        ourGovtOk: ``,
        theirGovtOk: false,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: `Town Name and Sorting Code`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 5,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`postalCode`, `city`]],
        addressOptionalFields: [],
        flagFilename: `FR.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    GA: {
        name: `Gabon`,
        phonePrefix: `+241`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    GM: {
        name: `Gambia`,
        phonePrefix: `+220`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    GE: {
        name: `Georgia`,
        phonePrefix: `+995`,
        phoneMask: ``,
        daysToDeliver: `8`,
        shippingChargeCents: 10700,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    DE: {
        name: `Germany`,
        phonePrefix: `+49`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8200,
        ourGovtOk: ``,
        theirGovtOk: false,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Settlement`,
        cityWidth: 80,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 5,
        postalCodeLabel: ``,
        postalCodeWidth: 20,
        postalCodeMask: ``,
        addressFieldOrder: [[`postalCode`, `city`]],
        addressOptionalFields: [],
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    GH: {
        name: `Ghana`,
        phonePrefix: `+233`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    GI: {
        name: `Gibraltar`,
        phonePrefix: `+350`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 6900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Town`,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 8,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 100,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`], [`postalCode`]],
        addressOptionalFields: [],
        flagFilename: `GB.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    GR: {
        name: `Greece`,
        phonePrefix: `+30`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9300,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    GL: {
        name: `Greenland`,
        phonePrefix: `+299`,
        phoneMask: ``,
        daysToDeliver: `8`,
        shippingChargeCents: 6900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: `DK.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    GD: {
        name: `Grenada`,
        phonePrefix: `+1`,
        phoneMask: `(999) 999-9999`,
        daysToDeliver: `5`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    GP: {
        name: `Guadeloupe`,
        phonePrefix: `+590`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 6300,
        ourGovtOk: ``,
        theirGovtOk: false,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Town Name and Sorting Code`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 5,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`postalCode`, `city`]],
        addressOptionalFields: [],
        flagFilename: `FR.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    GU: {
        name: `Guam`,
        phonePrefix: `+1`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `City`,
        cityWidth: 55,
        stateMaxlen: 2,
        stateLabel: `State`,
        stateWidth: 20,
        postalCodeMaxlen: ``,
        postalCodeLabel: `Zip Code`,
        postalCodeWidth: 25,
        postalCodeMask: `99999`,
        addressFieldOrder: [[`city`, `state`, `postalCode`]],
        addressOptionalFields: [],
        flagFilename: `US.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    GT: {
        name: `Guatemala`,
        phonePrefix: `+502`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    GG: {
        name: `Guernsey`,
        phonePrefix: `+44`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 6900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Town`,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 8,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 100,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`], [`postalCode`]],
        addressOptionalFields: [],
        flagFilename: `GB.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    GN: {
        name: `Guinea`,
        phonePrefix: `+224`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    GW: {
        name: `Guinea Bissau`,
        phonePrefix: `+245`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 11400,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    GY: {
        name: `Guyana`,
        phonePrefix: `+592`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 8100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    HT: {
        name: `Haiti`,
        phonePrefix: `+509`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    HM: {
        name: `Heard Island and McDonald Islands`,
        phonePrefix: ``,
        phoneMask: ``,
        daysToDeliver: `12`,
        shippingChargeCents: 7900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: `Suburb`,
        cityWidth: 45,
        stateMaxlen: 3,
        stateLabel: `State Code`,
        stateWidth: 30,
        postalCodeMaxlen: 6,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 25,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`, `state`, `postalCode`]],
        addressOptionalFields: [],
        flagFilename: `AU.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    VA: {
        name: `Holy See (Vatican City State)`,
        phonePrefix: `+379`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 6100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    HN: {
        name: `Honduras`,
        phonePrefix: `+504`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    HK: {
        name: `Hong Kong`,
        phonePrefix: `+852`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 7100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Village, Town, or District`,
        cityWidth: ``,
        stateMaxlen: 15,
        stateLabel: `Part of Hong Kong`,
        stateWidth: 40,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: 0,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`], [`state`]],
        addressOptionalFields: [],
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    HU: {
        name: `Hungary`,
        phonePrefix: `+36`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 10900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    IS: {
        name: `Iceland`,
        phonePrefix: `+354`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9300,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    IN: {
        name: `India`,
        phonePrefix: `+91`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 5800,
        ourGovtOk: ``,
        theirGovtOk: false,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    ID: {
        name: `Indonesia`,
        phonePrefix: `+62`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 7900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    IR: {
        name: `Iran`,
        phonePrefix: `+98`,
        phoneMask: ``,
        daysToDeliver: ``,
        shippingChargeCents: ``,
        ourGovtOk: false,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    IQ: {
        name: `Iraq`,
        phonePrefix: `+964`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 9000,
        ourGovtOk: false,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    IE: {
        name: `Ireland`,
        phonePrefix: `+353`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Postal Town`,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 8,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`], [`postalCode`]],
        addressOptionalFields: [],
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    IM: {
        name: `Isle of Man`,
        phonePrefix: `+44`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: `Town`,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 8,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 100,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`], [`postalCode`]],
        addressOptionalFields: [],
        flagFilename: `GB.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    IL: {
        name: `Israel`,
        phonePrefix: `+972`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9800,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `City`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 7,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`postalCode`, `city`]],
        addressOptionalFields: [],
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    IT: {
        name: `Italy`,
        phonePrefix: `+39`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Town`,
        cityWidth: 45,
        stateMaxlen: 2,
        stateLabel: `Province`,
        stateWidth: 25,
        postalCodeMaxlen: 5,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`postalCode`, `city`, `state`]],
        addressOptionalFields: [],
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    JM: {
        name: `Jamaica`,
        phonePrefix: `+1`,
        phoneMask: `(999) 999-9999`,
        daysToDeliver: `4`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    JP: {
        name: `Japan`,
        phonePrefix: `+81`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8300,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    JE: {
        name: `Jersey`,
        phonePrefix: `+44`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 6900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Town`,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 8,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 100,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`], [`postalCode`]],
        addressOptionalFields: [],
        flagFilename: `GB.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    JO: {
        name: `Jordan`,
        phonePrefix: `+962`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 9800,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    KZ: {
        name: `Kazakhstan`,
        phonePrefix: `+7`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 10900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    KE: {
        name: `Kenya`,
        phonePrefix: `+254`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 11400,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    KI: {
        name: `Kiribati`,
        phonePrefix: `+686`,
        phoneMask: ``,
        daysToDeliver: `8`,
        shippingChargeCents: 10200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    XK: {
        name: `Kosovo`,
        phonePrefix: `+383`,
        phoneMask: ``,
        daysToDeliver: ``,
        shippingChargeCents: ``,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    KW: {
        name: `Kuwait`,
        phonePrefix: `+965`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 9800,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    KG: {
        name: `Kyrgyzstan`,
        phonePrefix: `+996`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 10700,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    LA: {
        name: `Laos`,
        phonePrefix: `+856`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 10200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    LV: {
        name: `Latvia`,
        phonePrefix: `+371`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 10900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    LB: {
        name: `Lebanon`,
        phonePrefix: `+961`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 9000,
        ourGovtOk: false,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    LS: {
        name: `Lesotho`,
        phonePrefix: `+266`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 11400,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    LR: {
        name: `Liberia`,
        phonePrefix: `+231`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    LY: {
        name: `Libya`,
        phonePrefix: `+218`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 11400,
        ourGovtOk: false,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    LI: {
        name: `Liechtenstein`,
        phonePrefix: `+423`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 6900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    LT: {
        name: `Lithuania`,
        phonePrefix: `+370`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 10900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    LU: {
        name: `Luxembourg`,
        phonePrefix: `+352`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MO: {
        name: `Macau`,
        phonePrefix: `+853`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 5800,
        ourGovtOk: ``,
        theirGovtOk: false,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: `CN.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MG: {
        name: `Madagascar`,
        phonePrefix: `+261`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MW: {
        name: `Malawi`,
        phonePrefix: `+265`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MY: {
        name: `Malaysia`,
        phonePrefix: `+60`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 7900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MV: {
        name: `Maldives`,
        phonePrefix: `+960`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 10200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    ML: {
        name: `Mali`,
        phonePrefix: `+223`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MT: {
        name: `Malta`,
        phonePrefix: `+356`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 9300,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MH: {
        name: `Marshall Islands`,
        phonePrefix: `+692`,
        phoneMask: ``,
        daysToDeliver: ``,
        shippingChargeCents: ``,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MQ: {
        name: `Martinique`,
        phonePrefix: `+596`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 6300,
        ourGovtOk: ``,
        theirGovtOk: false,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Town Name and Sorting Code`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 5,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`postalCode`, `city`]],
        addressOptionalFields: [],
        flagFilename: `FR.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MR: {
        name: `Mauritania`,
        phonePrefix: `+222`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 11400,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MU: {
        name: `Mauritius`,
        phonePrefix: `+230`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    YT: {
        name: `Mayotte`,
        phonePrefix: `+262`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 11400,
        ourGovtOk: ``,
        theirGovtOk: false,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Town Name and Sorting Code`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 5,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`postalCode`, `city`]],
        addressOptionalFields: [],
        flagFilename: `FR.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MX: {
        name: `Mexico`,
        phonePrefix: `+52`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 4500,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Settlement`,
        cityWidth: 50,
        stateMaxlen: 5,
        stateLabel: `State`,
        stateWidth: 20,
        postalCodeMaxlen: 5,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: `99999`,
        addressFieldOrder: [[`postalCode`, `city`, `state`]],
        addressOptionalFields: [],
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    FM: {
        name: `Micronesia`,
        phonePrefix: `+691`,
        phoneMask: ``,
        daysToDeliver: ``,
        shippingChargeCents: ``,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MD: {
        name: `Moldova`,
        phonePrefix: `+373`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 10700,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MC: {
        name: `Monaco`,
        phonePrefix: `+377`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 6100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MN: {
        name: `Mongolia`,
        phonePrefix: `+976`,
        phoneMask: ``,
        daysToDeliver: `9`,
        shippingChargeCents: 10200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    ME: {
        name: `Montenegro`,
        phonePrefix: `+382`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 10900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MS: {
        name: `Montserrat`,
        phonePrefix: `+1`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Town`,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 8,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 100,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`], [`postalCode`]],
        addressOptionalFields: [],
        flagFilename: `GB.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MA: {
        name: `Morocco`,
        phonePrefix: `+212`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MZ: {
        name: `Mozambique`,
        phonePrefix: `+258`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MM: {
        name: `Myanmar`,
        phonePrefix: `+95`,
        phoneMask: ``,
        daysToDeliver: ``,
        shippingChargeCents: ``,
        ourGovtOk: false,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    NA: {
        name: `Namibia`,
        phonePrefix: `+264`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    NR: {
        name: `Nauru`,
        phonePrefix: `+674`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 10200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    NP: {
        name: `Nepal`,
        phonePrefix: `+977`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 10200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    NL: {
        name: `Netherlands`,
        phonePrefix: `+31`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    NC: {
        name: `New Caledonia`,
        phonePrefix: `+687`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 9500,
        ourGovtOk: ``,
        theirGovtOk: false,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Town Name and Sorting Code`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 5,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`postalCode`, `city`]],
        addressOptionalFields: [],
        flagFilename: `FR.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    NZ: {
        name: `New Zealand`,
        phonePrefix: `+64`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 7900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Settlement`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 4,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`, `postalCode`]],
        addressOptionalFields: [],
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    NI: {
        name: `Nicaragua`,
        phonePrefix: `+505`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    NE: {
        name: `Niger`,
        phonePrefix: `+227`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 11400,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    NG: {
        name: `Nigeria`,
        phonePrefix: `+234`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    NU: {
        name: `Niue`,
        phonePrefix: `+683`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 10200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Settlement`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 4,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`, `postalCode`]],
        addressOptionalFields: [],
        flagFilename: `NZ.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    NF: {
        name: `Norfolk Island`,
        phonePrefix: `+672`,
        phoneMask: ``,
        daysToDeliver: `12`,
        shippingChargeCents: 7900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: `Suburb`,
        cityWidth: 45,
        stateMaxlen: 3,
        stateLabel: `State Code`,
        stateWidth: 30,
        postalCodeMaxlen: 6,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 25,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`, `state`, `postalCode`]],
        addressOptionalFields: [],
        flagFilename: `AU.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    KP: {
        name: `North Korea`,
        phonePrefix: `+850`,
        phoneMask: ``,
        daysToDeliver: ``,
        shippingChargeCents: ``,
        ourGovtOk: false,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MK: {
        name: `North Macedonia`,
        phonePrefix: `+389`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 7900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MP: {
        name: `Northern Mariana Islands`,
        phonePrefix: `+1`,
        phoneMask: ``,
        daysToDeliver: `2-6`,
        shippingChargeCents: 995,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: `City`,
        cityWidth: 55,
        stateMaxlen: 2,
        stateLabel: `State`,
        stateWidth: 20,
        postalCodeMaxlen: ``,
        postalCodeLabel: `Zip Code`,
        postalCodeWidth: 25,
        postalCodeMask: `99999`,
        addressFieldOrder: [[`city`, `state`, `postalCode`]],
        addressOptionalFields: [],
        flagFilename: `US.png`,
        outboundShipperName: `USPS`,
        outboundServiceName: `First-class Mail`,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    NO: {
        name: `Norway`,
        phonePrefix: `+47`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9300,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    OM: {
        name: `Oman`,
        phonePrefix: `+968`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 9800,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    PK: {
        name: `Pakistan`,
        phonePrefix: `+92`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 9800,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    PW: {
        name: `Palau`,
        phonePrefix: `+680`,
        phoneMask: ``,
        daysToDeliver: ``,
        shippingChargeCents: ``,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    PS: {
        name: `Palestine`,
        phonePrefix: `+970`,
        phoneMask: ``,
        daysToDeliver: ``,
        shippingChargeCents: ``,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    PA: {
        name: `Panama`,
        phonePrefix: `+507`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    PG: {
        name: `Papua New Guinea`,
        phonePrefix: `+675`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 10200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    PY: {
        name: `Paraguay`,
        phonePrefix: `+595`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 8100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    PE: {
        name: `Peru`,
        phonePrefix: `+51`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 8100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    PH: {
        name: `Philippines`,
        phonePrefix: `+63`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 7900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    PN: {
        name: `Pitcairn`,
        phonePrefix: `+64`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: `Town`,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 8,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 100,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`], [`postalCode`]],
        addressOptionalFields: [],
        flagFilename: `GB.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    PL: {
        name: `Poland`,
        phonePrefix: `+48`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 10900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    PT: {
        name: `Portugal`,
        phonePrefix: `+351`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    PR: {
        name: `Puerto Rico`,
        phonePrefix: `+1`,
        phoneMask: ``,
        daysToDeliver: `2-6`,
        shippingChargeCents: 995,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `City`,
        cityWidth: 55,
        stateMaxlen: 2,
        stateLabel: `State`,
        stateWidth: 20,
        postalCodeMaxlen: ``,
        postalCodeLabel: `Zip Code`,
        postalCodeWidth: 25,
        postalCodeMask: `99999`,
        addressFieldOrder: [[`city`, `state`, `postalCode`]],
        addressOptionalFields: [],
        flagFilename: `US.png`,
        outboundShipperName: `USPS`,
        outboundServiceName: `First-class Mail`,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    QA: {
        name: `Qatar`,
        phonePrefix: `+974`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 9800,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    RO: {
        name: `Romania`,
        phonePrefix: `+40`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 10900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    RU: {
        name: `Russian Federation`,
        phonePrefix: `+7`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 10700,
        ourGovtOk: ``,
        theirGovtOk: false,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    RW: {
        name: `Rwanda`,
        phonePrefix: `+250`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 11400,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    RE: {
        name: `Réunion`,
        phonePrefix: `+262`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 11400,
        ourGovtOk: ``,
        theirGovtOk: false,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Town Name and Sorting Code`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 5,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`postalCode`, `city`]],
        addressOptionalFields: [],
        flagFilename: `FR.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    BL: {
        name: `Saint Barthélemy`,
        phonePrefix: `+590`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: false,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: `Town Name and Sorting Code`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 5,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`postalCode`, `city`]],
        addressOptionalFields: [],
        flagFilename: `FR.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    SH: {
        name: `Saint Helena, Ascension and Tristan da Cunha`,
        phonePrefix: `+290`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: `Town`,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 8,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 100,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`], [`postalCode`]],
        addressOptionalFields: [],
        flagFilename: `GB.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    KN: {
        name: `Saint Kitts and Nevis`,
        phonePrefix: `+1`,
        phoneMask: `(999) 999-9999`,
        daysToDeliver: `5`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    LC: {
        name: `Saint Lucia`,
        phonePrefix: `+1`,
        phoneMask: `(999) 999-9999`,
        daysToDeliver: `5`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    MF: {
        name: `Saint Martin (French part)`,
        phonePrefix: `+590`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 6100,
        ourGovtOk: ``,
        theirGovtOk: false,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: `Town Name and Sorting Code`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 5,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`postalCode`, `city`]],
        addressOptionalFields: [],
        flagFilename: `FR.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    PM: {
        name: `Saint Pierre and Miquelon`,
        phonePrefix: `+508`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 6100,
        ourGovtOk: ``,
        theirGovtOk: false,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: `Town Name and Sorting Code`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 5,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`postalCode`, `city`]],
        addressOptionalFields: [],
        flagFilename: `FR.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    VC: {
        name: `Saint Vincent and the Grenadines`,
        phonePrefix: `+1`,
        phoneMask: `(999) 999-9999`,
        daysToDeliver: `5`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    WS: {
        name: `Samoa`,
        phonePrefix: `+685`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 10200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    SM: {
        name: `San Marino`,
        phonePrefix: `+378`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 6100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    ST: {
        name: `Sao Tome and Principe`,
        phonePrefix: `+239`,
        phoneMask: ``,
        daysToDeliver: `8`,
        shippingChargeCents: 11400,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    SA: {
        name: `Saudi Arabia`,
        phonePrefix: `+966`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9000,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    SN: {
        name: `Senegal`,
        phonePrefix: `+221`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    RS: {
        name: `Serbia`,
        phonePrefix: `+381`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 10900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    SC: {
        name: `Seychelles`,
        phonePrefix: `+248`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    SL: {
        name: `Sierra Leone`,
        phonePrefix: `+232`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 11400,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    SG: {
        name: `Singapore`,
        phonePrefix: `+65`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 7100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `City`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 6,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`, `postalCode`]],
        addressOptionalFields: [],
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    SX: {
        name: `Sint Maarten (Dutch part)`,
        phonePrefix: `+1`,
        phoneMask: `(999) 999-9999`,
        daysToDeliver: `4`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: `NL.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    SK: {
        name: `Slovakia`,
        phonePrefix: `+421`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 10900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    SI: {
        name: `Slovenia`,
        phonePrefix: `+386`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 10900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    SB: {
        name: `Solomon Islands`,
        phonePrefix: `+677`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 10200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    SO: {
        name: `Somalia`,
        phonePrefix: `+252`,
        phoneMask: ``,
        daysToDeliver: ``,
        shippingChargeCents: ``,
        ourGovtOk: false,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    ZA: {
        name: `South Africa`,
        phonePrefix: `+27`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    GS: {
        name: `South Georgia and the South Sandwich Islands`,
        phonePrefix: `+500`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: `Town`,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 8,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 100,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`], [`postalCode`]],
        addressOptionalFields: [],
        flagFilename: `GB.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    KR: {
        name: `South Korea`,
        phonePrefix: `+82`,
        phoneMask: ``,
        daysToDeliver: `8`,
        shippingChargeCents: 7800,
        ourGovtOk: ``,
        theirGovtOk: false,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    SS: {
        name: `South Sudan`,
        phonePrefix: `+211`,
        phoneMask: ``,
        daysToDeliver: ``,
        shippingChargeCents: ``,
        ourGovtOk: false,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    ES: {
        name: `Spain`,
        phonePrefix: `+34`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 8200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Town`,
        cityWidth: 40,
        stateMaxlen: 30,
        stateLabel: `Province`,
        stateWidth: 30,
        postalCodeMaxlen: 5,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`postalCode`, `city`, `state`]],
        addressOptionalFields: [`state`],
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    LK: {
        name: `Sri Lanka`,
        phonePrefix: `+94`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 7900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    SD: {
        name: `Sudan`,
        phonePrefix: `+249`,
        phoneMask: ``,
        daysToDeliver: ``,
        shippingChargeCents: ``,
        ourGovtOk: false,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    SR: {
        name: `Suriname`,
        phonePrefix: `+597`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 8100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    SJ: {
        name: `Svalbard and Jan Mayen`,
        phonePrefix: `+47`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9300,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: `NO.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    SE: {
        name: `Sweden`,
        phonePrefix: `+46`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9300,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    CH: {
        name: `Switzerland`,
        phonePrefix: `+41`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9300,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    SY: {
        name: `Syria`,
        phonePrefix: `+963`,
        phoneMask: ``,
        daysToDeliver: ``,
        shippingChargeCents: ``,
        ourGovtOk: false,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    TW: {
        name: `Taiwan`,
        phonePrefix: `+886`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 7100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    TJ: {
        name: `Tajikistan`,
        phonePrefix: `+992`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 10700,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    TZ: {
        name: `Tanzania`,
        phonePrefix: `+255`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    TH: {
        name: `Thailand`,
        phonePrefix: `+66`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 7900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    TL: {
        name: `Timor-Leste`,
        phonePrefix: `+670`,
        phoneMask: ``,
        daysToDeliver: `10`,
        shippingChargeCents: 9500,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    TG: {
        name: `Togo`,
        phonePrefix: `+228`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    TK: {
        name: `Tokelau`,
        phonePrefix: `+690`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 7900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: `Settlement`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 4,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`, `postalCode`]],
        addressOptionalFields: [],
        flagFilename: `NZ.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    TO: {
        name: `Tonga`,
        phonePrefix: `+676`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 10200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    TT: {
        name: `Trinidad and Tobago`,
        phonePrefix: `+1`,
        phoneMask: `(999) 999-9999`,
        daysToDeliver: `4`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    TN: {
        name: `Tunisia`,
        phonePrefix: `+216`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 11400,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    TM: {
        name: `Turkmenistan`,
        phonePrefix: `+993`,
        phoneMask: ``,
        daysToDeliver: ``,
        shippingChargeCents: ``,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    TC: {
        name: `Turks and Caicos Islands`,
        phonePrefix: `+1`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Town`,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 8,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 100,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`], [`postalCode`]],
        addressOptionalFields: [],
        flagFilename: `GB.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    TV: {
        name: `Tuvalu`,
        phonePrefix: `+688`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 10200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    TR: {
        name: `Türkiye`,
        phonePrefix: `+90`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9800,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    UG: {
        name: `Uganda`,
        phonePrefix: `+256`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    UA: {
        name: `Ukraine`,
        phonePrefix: `+380`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 10900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    AE: {
        name: `United Arab Emirates`,
        phonePrefix: `+971`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9800,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    GB: {
        name: `United Kingdom`,
        phonePrefix: `+44`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Town`,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 8,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 100,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`], [`postalCode`]],
        addressOptionalFields: [],
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    US: {
        name: `United States`,
        phonePrefix: `+1`,
        phoneMask: `(999) 999-9999`,
        daysToDeliver: `2-6`,
        shippingChargeCents: 995,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `City`,
        cityWidth: 55,
        stateMaxlen: 2,
        stateLabel: `State`,
        stateWidth: 20,
        postalCodeMaxlen: ``,
        postalCodeLabel: `Zip Code`,
        postalCodeWidth: 25,
        postalCodeMask: `99999`,
        addressFieldOrder: [[`city`, `state`, `postalCode`]],
        addressOptionalFields: [],
        flagFilename: ``,
        outboundShipperName: `USPS`,
        outboundServiceName: `First-class Mail`,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    UM: {
        name: `United States Minor Outlying Islands`,
        phonePrefix: ``,
        phoneMask: ``,
        daysToDeliver: `2-6`,
        shippingChargeCents: 995,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: `City`,
        cityWidth: 55,
        stateMaxlen: 2,
        stateLabel: `State`,
        stateWidth: 20,
        postalCodeMaxlen: ``,
        postalCodeLabel: `Zip Code`,
        postalCodeWidth: 25,
        postalCodeMask: `99999`,
        addressFieldOrder: [[`city`, `state`, `postalCode`]],
        addressOptionalFields: [],
        flagFilename: `US.png`,
        outboundShipperName: `USPS`,
        outboundServiceName: `First-class Mail`,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    UY: {
        name: `Uruguay`,
        phonePrefix: `+598`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 8100,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    UZ: {
        name: `Uzbekistan`,
        phonePrefix: `+998`,
        phoneMask: ``,
        daysToDeliver: `7`,
        shippingChargeCents: 10700,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    VU: {
        name: `Vanuatu`,
        phonePrefix: `+678`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 9500,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    VE: {
        name: `Venezuela`,
        phonePrefix: `+58`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 7200,
        ourGovtOk: false,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    VN: {
        name: `Viet Nam`,
        phonePrefix: `+84`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 7900,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    VG: {
        name: `Virgin Islands, British`,
        phonePrefix: `+1`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 6600,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `Town`,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 8,
        postalCodeLabel: `Postcode`,
        postalCodeWidth: 100,
        postalCodeMask: ``,
        addressFieldOrder: [[`city`], [`postalCode`]],
        addressOptionalFields: [],
        flagFilename: `GB.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    VI: {
        name: `Virgin Islands, U.S.`,
        phonePrefix: `+1`,
        phoneMask: ``,
        daysToDeliver: `2-6`,
        shippingChargeCents: 995,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: `City`,
        cityWidth: 55,
        stateMaxlen: 2,
        stateLabel: `State`,
        stateWidth: 20,
        postalCodeMaxlen: ``,
        postalCodeLabel: `Zip Code`,
        postalCodeWidth: 25,
        postalCodeMask: `99999`,
        addressFieldOrder: [[`city`, `state`, `postalCode`]],
        addressOptionalFields: [],
        flagFilename: `US.png`,
        outboundShipperName: `USPS`,
        outboundServiceName: `First-class Mail`,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    WF: {
        name: `Wallis and Futuna`,
        phonePrefix: `+681`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 6100,
        ourGovtOk: ``,
        theirGovtOk: false,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: `Town Name and Sorting Code`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 5,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`postalCode`, `city`]],
        addressOptionalFields: [],
        flagFilename: `FR.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    EH: {
        name: `Western Sahara`,
        phonePrefix: ``,
        phoneMask: ``,
        daysToDeliver: ``,
        shippingChargeCents: ``,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    YE: {
        name: `Yemen`,
        phonePrefix: `+967`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 9000,
        ourGovtOk: false,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    ZM: {
        name: `Zambia`,
        phonePrefix: `+260`,
        phoneMask: ``,
        daysToDeliver: `6`,
        shippingChargeCents: 12200,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    ZW: {
        name: `Zimbabwe`,
        phonePrefix: `+263`,
        phoneMask: ``,
        daysToDeliver: `5`,
        shippingChargeCents: 11400,
        ourGovtOk: false,
        theirGovtOk: ``,
        carrierOk: ``,
        cityMaxlen: ``,
        cityLabel: ``,
        cityWidth: ``,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: ``,
        postalCodeMaxlen: ``,
        postalCodeLabel: ``,
        postalCodeWidth: ``,
        postalCodeMask: ``,
        addressFieldOrder: ``,
        addressOptionalFields: ``,
        flagFilename: ``,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
    AX: {
        name: `Åland Islands`,
        phonePrefix: `+358`,
        phoneMask: ``,
        daysToDeliver: `4`,
        shippingChargeCents: 9300,
        ourGovtOk: ``,
        theirGovtOk: ``,
        carrierOk: false,
        cityMaxlen: ``,
        cityLabel: `Settlement`,
        cityWidth: 70,
        stateMaxlen: ``,
        stateLabel: ``,
        stateWidth: 0,
        postalCodeMaxlen: 5,
        postalCodeLabel: ``,
        postalCodeWidth: 30,
        postalCodeMask: ``,
        addressFieldOrder: [[`postalCode`, `city`]],
        addressOptionalFields: [],
        flagFilename: `FI.png`,
        outboundShipperName: ``,
        outboundServiceName: ``,
        deliveredDutyPaid: ``,
        taxIdMaxlen: ``,
        taxIdLabel: ``,
        taxIdWidth: ``,
        taxIdMask: ``,
    },
};
const defaultAddressFieldOrder = [[`city`], [`state`, `postalCode`]];
const defaultAddressOptionalFields = [`state`, `postalCode`];
const getName = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.name || null;
};
const getPhonePrefix = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.phonePrefix || null;
};
const getPhoneMask = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.phoneMask || null;
};
const getDaysToDeliver = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.daysToDeliver || null;
};
const getShippingChargeCents = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.shippingChargeCents || null;
};
const getOurGovtOk = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.ourGovtOk || true;
};
const getTheirGovtOk = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.theirGovtOk || true;
};
const getCarrierOk = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.carrierOk || true;
};
const getCityMaxlen = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.cityMaxlen || 80;
};
const getCityLabel = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.cityLabel || `City, Town, or Settlement`;
};
const getCityWidth = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.cityWidth || 100;
};
const getStateMaxlen = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.stateMaxlen || 50;
};
const getStateLabel = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.stateLabel || `State, Province, or Region`;
};
const getStateWidth = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.stateWidth || 60;
};
const getPostalCodeMaxlen = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.postalCodeMaxlen || 10;
};
const getPostalCodeLabel = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.postalCodeLabel || `Postal Code`;
};
const getPostalCodeWidth = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.postalCodeWidth || 40;
};
const getAddressFieldOrder = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.addressFieldOrder || defaultAddressFieldOrder;
};
const getAddressOptionalFields = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.addressOptionalFields || defaultAddressOptionalFields;
};
const getFlagFilename = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.flagFilename || `${countryCode}.png`;
};
const getOutboundShipperName = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.outboundShipperName || `DHL`;
};
const getOutboundServiceName = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.outboundServiceName || `Express Worldwide`;
};
const getTaxIdMaxlen = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.taxIdMaxlen || null;
};
const getTaxIdWidth = (countryCode) => {
    return GEOGRAPHICAL_AREAS[countryCode]?.taxIdWidth || null;
};
const getFieldWidth = (countryCode, field) => {
    if (field === 'city') {
        return getCityWidth(countryCode);
    }
    if (field === 'state') {
        return getStateWidth(countryCode);
    }
    if (field === 'postalCode') {
        return getPostalCodeWidth(countryCode);
    }
    if (field === 'taxId') {
        return getTaxIdWidth(countryCode);
    }
    return undefined;
};
const isCountryShippable = (countryCode) => {
    return getOurGovtOk(countryCode) && getTheirGovtOk(countryCode) && getCarrierOk(countryCode);
};
const hasAddressFieldForCountry = (countryCode, fieldName) => {
    const fieldOrder = getAddressFieldOrder(countryCode);
    // fieldOrder is a nested array of the address fields for this country, so
    // we need to flatten them.
    const flattenedFields = [...fieldOrder];
    return flattenedFields.indexOf(fieldName) !== -1;
};
const isRequiredFieldForCountryAddress = (countryCode, fieldName) => {
    const optionalFields = getAddressOptionalFields(countryCode);
    return optionalFields.indexOf(fieldName) === -1;
};
const ALL_COUNTRIES = Object.keys(GEOGRAPHICAL_AREAS)
    .filter((countryCode) => {
    return getOurGovtOk(countryCode) && getCarrierOk(countryCode);
})
    .sort((a, b) => {
    return getName(a).localeCompare(getName(b));
});
const PHONE_COUNTRIES = Object.keys(GEOGRAPHICAL_AREAS)
    .filter((countryCode) => {
    return getPhonePrefix(countryCode);
})
    .sort((a, b) => {
    return getName(a).localeCompare(getName(b));
});

/**
 * Navigates to a url with a hard refresh.
 * Do not use this for React routes. Consider adding your route to `ANGULAR_EXACT_PATH_MATCHES`
 * and manage all path changes via `react-router` path changes.
 * `ANGULAR_EXACT_PATH_MATCHES` will automatically reload the page when visiting Angular paths
 * and as you convert to React, you can simply remove your path from that, reducing other refactoring.
 *
 * @param url - The url to navigate to.
 */
function navigateAndRefreshBrowser(url) {
    window.location.assign(url);
}
/**
 * Open url in a new tab, while protecting from security risks related to `referrer`
 *
 * See https://getcolor.atlassian.net/browse/ENG-584
 * https://www.jitbit.com/alexblog/256-targetblank---the-most-underestimated-vulnerability-ever/
 * https://mathiasbynens.github.io/rel-noopener
 * See lint rule react/jsx-no-target-blank
 */
function openNewBrowserTab(url) {
    window.open(url, '_blank', 'noopener,noreferrer');
}
/**
 * Scroll an element into view. Accounts for legacy browsers that do not support
 * `scrollIntoView`.
 *
 * @param element The element to scroll into view.
 * @param options The options to pass to `scrollIntoView` if it is called.
 */
function scrollIntoView(element, options) {
    const doesScrollIntoViewExist = Boolean(element.scrollIntoView);
    /**
     * Some legacy browsers do not support `scrollIntoView`.
     * Base `focus` options on browser support.
     */
    element.focus?.({ preventScroll: doesScrollIntoViewExist });
    if (doesScrollIntoViewExist) {
        element.scrollIntoView(options);
    }
}

/**
 * Redirects a user while preserving the `next` param (or placing the current path in the `next` param)
 *
 * Most commonly used with authentication (ie: if a user isn't signed in and attempts to navigate to a
 * path that requires authentication, we'll redirect them to a sign in page and place the path they originally
 * navigated to in the `next` param).
 */
const RedirectWithNextParam = (props) => {
    const { redirectPath } = props;
    const { search } = reactRouterDom.useLocation();
    const newSearchQuery = toQueryString({
        next: getSafeNextQueryParam(search) ?? getCurrentPath(),
    });
    return (jsxRuntime.jsx(reactRouterDom.Redirect, { to: {
            pathname: redirectPath,
            search: newSearchQuery,
        } }));
};

const PASSWORD_MIN_LENGTH = 8;
const PASSWORD_BETTER_LENGTH = 10;
/*
 * Returns an object based on password strength:
 * {
 *    scaledScore: Integer 0, 1, 2, 3, 4
 *    hasMinLength: boolean
 *    hasMixedCase: boolean
 *    hasNonAlphas: boolean
 * }
 */
const getPasswordStrength = (password = '') => {
    const hasMinLength = password.length >= PASSWORD_MIN_LENGTH;
    const hasBetterLength = password.length >= PASSWORD_BETTER_LENGTH;
    const minLengthScore = hasMinLength ? 1 : 0;
    const betterLengthScore = hasBetterLength ? 1 : 0;
    const hasNonAlphas = Boolean(password.match(/[^a-zA-Z]/));
    const hasMixedCase = Boolean(password.match(/[a-z]/)) && Boolean(password.match(/[A-Z]/));
    const nonAlphaScore = hasNonAlphas ? 1 : 0;
    const mixedCaseScore = hasMixedCase ? 1 : 0;
    const intermediateScore = 8 * minLengthScore + 4 * nonAlphaScore + 2 * mixedCaseScore + betterLengthScore;
    let scaledScore = 0;
    if (intermediateScore >= 15) {
        // Meets all rules. (Max score is 15)
        scaledScore = 4;
    }
    else if (intermediateScore >= 14) {
        // Has minimum length and non alphas and mixed case
        scaledScore = 3;
    }
    else if (intermediateScore >= 12) {
        // Has minimum or better length and non alphas.
        scaledScore = 2;
    }
    else if (intermediateScore >= 8) {
        // Has minimum length only.
        scaledScore = 1;
    }
    return {
        hasMinLength,
        hasMixedCase,
        hasNonAlphas,
        scaledScore,
    };
};

const E164_REGEX = /^\+(1|2(?:0|1[12368]|2\d|3\d|4\d|5[0-8]|6\d|7|9[01789])|3(?:[0-4]|5\d|6|7[0-8]|8[0125679]|9)|4(?:0|1|2[013]|[3-9])|5(?:0\d|[1-8]|9\d)|6(?:[0-6]|7[023456789]|8[012356789]|9[012])|7|8(?:0[08]|1|2|4|5[02356]|6|7[08]|8[012368])|9(?:[0-4]|5|6[0-8]|7[012345679]|8|9[234568]))(\d+)(?:;ext=(\d+))?$/;
// Handle E.164-formatted telephone numbers. PhoneNumberFields will
// return their values in this (very constrained) format. We can match it
// with a single regex and save a lot of guesswork.
const getFormattedE164Number = (e164Match) => {
    const [, country, number, extension] = e164Match;
    let formattedNumber;
    if (country === '1' && number.length === 10) {
        // Format +12015555555 => (201) 555-5555
        formattedNumber = `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`;
    }
    else {
        // Format +441212345678 => +44 1212345678
        formattedNumber = `+${country} ${number}`;
    }
    if (extension) {
        formattedNumber += ` ext. ${extension}`;
    }
    return formattedNumber;
};
/**
 * Converts a telephone number integer value into
 * (xxx) xxx-xxxx or +xx xxxxxxx
 *
 * @param telephoneNumber - The telephone number to format. Accepts string or object types.
 */
const formatPhoneNumber = (telephoneNumber) => {
    if (!telephoneNumber) {
        return '';
    }
    let number;
    let extension;
    let formattedNumber;
    // Handle telephoneNumber objects, generated by clr-phone-input in some cases
    // when a field is represented with a PhoneNumberField on the back-end.
    // eslint-disable-next-line
    if (isInstanceOfIPhoneNumber(telephoneNumber)) {
        number = telephoneNumber.national_number;
        if (!number) {
            return '';
        }
        const prefix = getPhonePrefix(telephoneNumber.country);
        extension = telephoneNumber.extension;
        formattedNumber = prefix + number;
        if (extension) {
            formattedNumber += `;ext=${extension}`;
        }
    }
    else {
        formattedNumber = telephoneNumber;
    }
    const e164Match = E164_REGEX.exec(formattedNumber);
    if (e164Match) {
        return getFormattedE164Number(e164Match);
    }
    // Clean +-() characters from the input
    const value = formattedNumber
        .toString()
        .trim()
        // eslint-disable-next-line no-useless-escape
        .replace(/[\+\-()\s]/g, '');
    // If there's anything other than numbers left in the input, return the
    // original value directly.
    if (value.match(/[^0-9]/)) {
        return formattedNumber;
    }
    let city;
    switch (value.length) {
        // Assumes US/Canada +1 telephone numbers
        // To handle more cases up to 15 digits, refer to https://en.wikipedia.org/wiki/List_of_country_calling_codes
        case 10: // PPP#######
            city = value.slice(0, 3);
            number = value.slice(3);
            break;
        case 11: // CPPP#######
            city = value.slice(1, 4);
            number = value.slice(4);
            break;
        default:
            return formattedNumber;
    }
    number = `${number.slice(0, 3)}-${number.slice(3)}`;
    const formattedNumberWithCity = `(${city}) ${number}`.trim();
    if (extension) {
        return `${formattedNumberWithCity} ext. ${extension}`;
    }
    return formattedNumberWithCity;
};
/**
 * FIXME: Short-term replacement for default PhoneNumber constructor as
 * we migrate from models to interfaces. We should review how it's used
 * and determine if this is really needed or if components should be
 * adjusted to handle optionally present phone numbers.
 */
function getDefaultPhoneNumber() {
    return {
        country: 'US',
        national_number: '',
        extension: '',
    };
}
/**
 * This utility function is needed to check types before serializing `IPhoneNumber`
 * to string.
 */
function isInstanceOfIPhoneNumber(object) {
    return typeof object === 'object' && 'country' in object && 'national_number' in object;
}
function parsePhoneNumber(phoneNumber) {
    let formattedPhoneNumber = typeof phoneNumber === 'string' ? phoneNumber.trim() : '';
    // default to US country code if none provided
    if (formattedPhoneNumber && !formattedPhoneNumber.startsWith('+')) {
        formattedPhoneNumber = `+1${formattedPhoneNumber}`;
    }
    let phoneCountry = 'US';
    let phonePrefix = '';
    let phoneNatlNumber = '';
    let phoneExtension = '';
    // guess US for +1 country codes - default parser picks first alphabetical match on country code
    const countryIsUS = formattedPhoneNumber.startsWith('+1');
    const matched = E164_REGEX.exec(formattedPhoneNumber);
    if (matched) {
        [, phonePrefix, phoneNatlNumber, phoneExtension] = matched;
        const matchedCountryPrefix = `+${phonePrefix}`;
        phoneCountry =
            lodash.first(ALL_COUNTRIES.filter((country) => getPhonePrefix(country) === matchedCountryPrefix)) || 'US';
    }
    if (countryIsUS) {
        phoneCountry = 'US';
    }
    return {
        country: phoneCountry,
        national_number: phoneNatlNumber,
        extension: phoneExtension,
    };
}
function formatAsE164(phoneNumber) {
    return `${getPhonePrefix(phoneNumber.country)}${phoneNumber.national_number}${phoneNumber.extension ? `;ext=${phoneNumber.extension}` : ''}`;
}
const MASK_DEFINITIONS = {
    '9': /\d/,
};
/**
 * Converts mask definitions from `ui-mask` style used in python formatting to `text-mask` style
 * used in react-text-mask formatting.
 *
 * For example:
 *
 * `uiMaskToTextMask('(999) 999-9999')` returns
 * `["(", /\d/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]`
 */
function uiMaskToTextMask(uiMask) {
    return Array.from(uiMask).map((c) => MASK_DEFINITIONS[c] ?? c);
}
/**
 * Format phone number with optional country mask.
 * For example: Great Britain number would be formatted as `+44 02071838750`
 * @param phoneNumber object
 * @returns formatted phone number
 */
function formatPhoneNumberWithMask(phoneNumber) {
    const countryPhoneMask = getPhoneMask(phoneNumber.country);
    const mask = countryPhoneMask ? uiMaskToTextMask(countryPhoneMask) : undefined;
    const prefix = getPhonePrefix(phoneNumber.country);
    const maskedContent = mask
        ? reactTextMask.conformToMask(phoneNumber.national_number, mask).conformedValue
        : phoneNumber.national_number;
    if (!prefix) {
        return maskedContent;
    }
    return `${prefix} ${maskedContent}`;
}

function PhoneNumberFactory(extraProps) {
    return {
        country: 'US',
        national_number: '9876543210',
        ...extraProps,
    };
}

const RETRY_OPTIONS = {
    // retries means N tries after the first time, for a total of N + 1 attempts
    retries: 4,
    minTimeout: 200,
};
async function retry(resolver, options = {}) {
    return asyncRetry__default["default"](resolver, { ...RETRY_OPTIONS, ...options });
}

// The "sex assigned at birth" and "gender identity" values defined in this file, and the UI components
/**
 * Sex Assigned at Birth values that are sent to and received from the server.
 */
exports.SexAssignedAtBirth = void 0;
(function (SexAssignedAtBirth) {
    SexAssignedAtBirth["FEMALE"] = "F";
    SexAssignedAtBirth["MALE"] = "M";
})(exports.SexAssignedAtBirth || (exports.SexAssignedAtBirth = {}));
/**
 * Gender Identity values that are sent to and received from the server.
 * They currently match the display values, but are not guaranteed to match in the future.
 */
exports.GenderIdentity = void 0;
(function (GenderIdentity) {
    GenderIdentity["WOMAN"] = "Female/woman";
    GenderIdentity["MAN"] = "Male/man";
    GenderIdentity["TRANS_WOMAN"] = "Transgender female/woman";
    GenderIdentity["TRANS_MAN"] = "Transgender male/man";
    GenderIdentity["NONBINARY_GENDERQUEER"] = "Nonbinary, genderqueer, or not exclusively female or male";
    GenderIdentity["ANOTHER_GENDER"] = "Another gender";
    GenderIdentity["DO_NOT_KNOW"] = "Don't know";
    GenderIdentity["PREFER_NOT_TO_SAY"] = "Prefer not to say";
})(exports.GenderIdentity || (exports.GenderIdentity = {}));
exports.GenderIdentityDataSharingRequirement = void 0;
(function (GenderIdentityDataSharingRequirement) {
    GenderIdentityDataSharingRequirement[GenderIdentityDataSharingRequirement["SENT_TO_EXTERNAL_EMR"] = 0] = "SENT_TO_EXTERNAL_EMR";
    GenderIdentityDataSharingRequirement[GenderIdentityDataSharingRequirement["SENT_TO_STATE_FEDERAL_DASHBOARD"] = 1] = "SENT_TO_STATE_FEDERAL_DASHBOARD";
    GenderIdentityDataSharingRequirement[GenderIdentityDataSharingRequirement["SHARED_WITH_CLINICIAN_WHEN_APPROPRIATE"] = 2] = "SHARED_WITH_CLINICIAN_WHEN_APPROPRIATE";
})(exports.GenderIdentityDataSharingRequirement || (exports.GenderIdentityDataSharingRequirement = {}));
const SEX_ASSIGNED_AT_BIRTH_FIELD_NAME = 'sex';
const GENDER_IDENTITY_FIELD_NAME = 'genderIdentity';
const ANOTHER_GENDER_FIELD_NAME = 'selfDescribedGenderIdentity';
const SEXUAL_ORIENTATION_FIELD_NAME = 'sexualOrientation';
const NOT_LISTED_FIELD_NAME = 'selfDescribedSexualOrientation';
const GENDER_IDENTITY_CAMEL_CASE_FIELD_NAMES = {
    genderIdentityFieldName: GENDER_IDENTITY_FIELD_NAME,
    anotherGenderFieldName: ANOTHER_GENDER_FIELD_NAME,
};
/**
 * Sexual Orientation Identity values that are sent to and received from the server.
 * They currently match the display values, but are not guaranteed to match in the future.
 */
exports.SexualOrientationIdentity = void 0;
(function (SexualOrientationIdentity) {
    SexualOrientationIdentity["LESBIAN_OR_GAY"] = "Lesbian or gay";
    SexualOrientationIdentity["STRAIGHT_OR_HETEROSEXUAL"] = "Straight or heterosexual";
    SexualOrientationIdentity["BISEXUAL"] = "Bisexual";
    SexualOrientationIdentity["QUEER"] = "Queer";
    SexualOrientationIdentity["ASEXUAL"] = "Asexual";
    SexualOrientationIdentity["PANSEXUAL"] = "Pansexual";
    SexualOrientationIdentity["DO_NOT_KNOW"] = "Don't know";
    SexualOrientationIdentity["PREFER_NOT_TO_SAY"] = "Prefer not to say";
    SexualOrientationIdentity["NOT_LISTED"] = "Not Listed";
})(exports.SexualOrientationIdentity || (exports.SexualOrientationIdentity = {}));
/**
 * Default field names for Sex Assigned at Birth, Gender Identity, and Another Gender
 * fields. Used in Sex and Gender utilities and UI components.
 */
const SEX_AND_GENDER_IDENTITY_CAMEL_CASE_FIELD_NAMES = {
    sexAssignedAtBirthFieldName: SEX_ASSIGNED_AT_BIRTH_FIELD_NAME,
    ...GENDER_IDENTITY_CAMEL_CASE_FIELD_NAMES,
};
const GENDER_IDENTITY_SNAKE_CASE_FIELD_NAMES = {
    genderIdentityFieldName: lodash.snakeCase(GENDER_IDENTITY_FIELD_NAME),
    anotherGenderFieldName: lodash.snakeCase(ANOTHER_GENDER_FIELD_NAME),
};
const SEX_AND_GENDER_IDENTITY_SNAKE_CASE_FIELD_NAMES = {
    sexAssignedAtBirthFieldName: lodash.snakeCase(SEX_ASSIGNED_AT_BIRTH_FIELD_NAME),
    ...GENDER_IDENTITY_SNAKE_CASE_FIELD_NAMES,
};
const SEXUAL_ORIENTATION_CAMEL_CASE_FIELD_NAMES = {
    sexualOrientationFieldName: SEXUAL_ORIENTATION_FIELD_NAME,
    notListedFieldName: NOT_LISTED_FIELD_NAME,
};
const SEXUAL_ORIENTATION_SNAKE_CASE_FIELD_NAMES = {
    sexualOrientationFieldName: lodash.snakeCase(SEXUAL_ORIENTATION_FIELD_NAME),
    notListedFieldName: lodash.snakeCase(NOT_LISTED_FIELD_NAME),
};

/**
 * A strongly typed version of `key in obj` that returns a boolean.
 *
 * This is useful for checking if a key is in an object and preserving the type of the key.
 * `key in obj` will require a follow up cast to use the key as a `keyof T`, where as this
 * function will preserve the type and allow for immediate use without any casting
 *
 * @param key - The key to check for in the object.
 * @param obj - The object to check the key against.
 * @returns Boolean representing whether the key is in the object.
 */
function isObjKey(key, obj) {
    return key in obj;
}

/**
 * Enum representing the different Practitioner groups we've set up in Canvas, each
 * with their own set of practitioners. Note that this naming must remain consistent
 * with the Django Groups naming set up in Canvas (both in development and production
 * environments).
 * Keep in sync with the GroupType enum in Backend:
 * - src/django_apps/preventive_care/consults/canvas/client/constants.py
 * */
exports.GroupType = void 0;
(function (GroupType) {
    GroupType["CARE_ADVOCATE"] = "Care Advocates";
    GroupType["TELEPREP_ENROLLMENT_WORKERS"] = "CDPH TelePrEP/PEP Enrollment Workers";
    GroupType["TELEPREP_PHYSICIANS"] = "CDPH TelePrEP/PEP Clinicians";
    GroupType["LAB_ORDER_REQUEST_REVIEWERS"] = "Lab Order Request Reviewers";
    GroupType["CANCER_BETA_CLINICIANS"] = "Cancer Beta Clinicians";
    GroupType["CANCER_CARDIO_SCREENING_PILOT_CLINICIANS"] = "Cancer-Cardio Screening Pilot Clinicians";
    GroupType["COOK_COUNTY_STI_CLINICIANS"] = "Cook County STI Clinicians";
    GroupType["MEDOPS"] = "MedOps";
    GroupType["LAB_RESULTS"] = "Lab Results";
    GroupType["REFERRAL_COORDINATION"] = "Referral Coordination";
    GroupType["GENETIC_COUNSELORS"] = "Genetic Counselors";
    GroupType["COVID"] = "COVID-19";
    GroupType["MEDOPS_TELEPREP"] = "MedOps TelePrEP";
    GroupType["RISK_REVIEW_EXPERTS"] = "Risk Review Experts";
    GroupType["CANCER_CONNECT_LEADERS"] = "Cancer Connect Leaders";
    GroupType["CANCER_SURVIVORSHIP_CLINICIANS"] = "Cancer Survivorship Clinicians";
    GroupType["IMAGE_ORDER_REQUEST_REVIEWERS"] = "Image Order Request Reviewers";
    GroupType["IMAGE_RESULTS"] = "Image Results";
    GroupType["IN_TREATMENT_CANCER_CLINICIANS"] = "In-treatment Cancer Clinicians";
    GroupType["ONCOLOGY_NURSES"] = "Oncology Nurses";
    GroupType["CLINICAL_CARE_TEAM"] = "Clinical Care Team";
    GroupType["REGISTERED_DIETITIANS"] = "Registered Dietitians";
    GroupType["CANCER_PREVENTION_SERVICES_CLINICIANS"] = "Clinicians - Cancer Prevention Services";
    GroupType["CANCER_SURVIVORSHIP_SERVICES_CLINICIANS"] = "Clinicians - Cancer Survivorship Services";
    GroupType["CANCER_ACTIVE_TREATMENT_SERVICES_CLINICIANS"] = "Clinicians - Cancer Active Treatment Services";
    GroupType["CANCER_RISK_EXPERTS"] = "Cancer Risk Experts";
    GroupType["REFERRAL_COORDINATORS"] = "Referral Coordinators";
})(exports.GroupType || (exports.GroupType = {}));

exports.ADULT_MINIMUM_AGE = ADULT_MINIMUM_AGE;
exports.ALL_COUNTRIES = ALL_COUNTRIES;
exports.ALL_LOCALES = ALL_LOCALES;
exports.ALL_USER_ROLES = ALL_USER_ROLES;
exports.ANOTHER_GENDER_FIELD_NAME = ANOTHER_GENDER_FIELD_NAME;
exports.AddressFactory = AddressFactory;
exports.ApiClient = ApiClient;
exports.ApiError = ApiError;
exports.AuthProvider = AuthProvider;
exports.CANCER_TEST_TYPES = CANCER_TEST_TYPES;
exports.COLOR_ISO_639_CODE_BY_LOCALE = COLOR_ISO_639_CODE_BY_LOCALE;
exports.COVID_TEST_TYPES = COVID_TEST_TYPES;
exports.CookiesProvider = CookiesProvider;
exports.DATE_FNS_LOCALES = DATE_FNS_LOCALES;
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
exports.DJANGO_TO_FRONTEND_LOCALES = DJANGO_TO_FRONTEND_LOCALES;
exports.ESSENTIAL_CARE_TEST_TYPES = ESSENTIAL_CARE_TEST_TYPES;
exports.FRONTEND_TO_DJANGO_LOCALES = FRONTEND_TO_DJANGO_LOCALES;
exports.FakeLaunchDarklyFlagContextProvider = FakeLaunchDarklyFlagContextProvider;
exports.FeatureFlagProviderHoc = FeatureFlagProviderHoc;
exports.GENDER_IDENTITY_CAMEL_CASE_FIELD_NAMES = GENDER_IDENTITY_CAMEL_CASE_FIELD_NAMES;
exports.GENDER_IDENTITY_FIELD_NAME = GENDER_IDENTITY_FIELD_NAME;
exports.GENDER_IDENTITY_SNAKE_CASE_FIELD_NAMES = GENDER_IDENTITY_SNAKE_CASE_FIELD_NAMES;
exports.GENETICS_USER_ROLES = GENETICS_USER_ROLES;
exports.GENETIC_TEST_TYPES = GENETIC_TEST_TYPES;
exports.INDEPENDENT_MINOR_MINIMUM_AGE = INDEPENDENT_MINOR_MINIMUM_AGE;
exports.LOCALE_DISPLAY_NAMES = LOCALE_DISPLAY_NAMES;
exports.LOCALE_ENGLISH_NAMES = LOCALE_ENGLISH_NAMES;
exports.MOMENT_LOCALE_NAMES = MOMENT_LOCALE_NAMES;
exports.ONE_DAY_IN_MILLISECONDS = ONE_DAY_IN_MILLISECONDS;
exports.ONE_HOUR_IN_MILLISECONDS = ONE_HOUR_IN_MILLISECONDS;
exports.ONE_MINUTE_IN_MILLISECONDS = ONE_MINUTE_IN_MILLISECONDS;
exports.ONE_SECOND_IN_MILLISECONDS = ONE_SECOND_IN_MILLISECONDS;
exports.ONE_WEEK_IN_MILLISECONDS = ONE_WEEK_IN_MILLISECONDS;
exports.PASSWORD_MIN_LENGTH = PASSWORD_MIN_LENGTH;
exports.PHONE_COUNTRIES = PHONE_COUNTRIES;
exports.PREFERRED_LOCALE_COOKIE_NAME = PREFERRED_LOCALE_COOKIE_NAME;
exports.PhoneNumberFactory = PhoneNumberFactory;
exports.RIGHT_TO_LEFT_LOCALES = RIGHT_TO_LEFT_LOCALES;
exports.RedirectWithNextParam = RedirectWithNextParam;
exports.ReferrerProvider = ReferrerProvider;
exports.ReleasedReportStates = ReleasedReportStates;
exports.SEXUAL_ORIENTATION_CAMEL_CASE_FIELD_NAMES = SEXUAL_ORIENTATION_CAMEL_CASE_FIELD_NAMES;
exports.SEXUAL_ORIENTATION_SNAKE_CASE_FIELD_NAMES = SEXUAL_ORIENTATION_SNAKE_CASE_FIELD_NAMES;
exports.SEX_AND_GENDER_IDENTITY_CAMEL_CASE_FIELD_NAMES = SEX_AND_GENDER_IDENTITY_CAMEL_CASE_FIELD_NAMES;
exports.SEX_AND_GENDER_IDENTITY_SNAKE_CASE_FIELD_NAMES = SEX_AND_GENDER_IDENTITY_SNAKE_CASE_FIELD_NAMES;
exports.SEX_ASSIGNED_AT_BIRTH_FIELD_NAME = SEX_ASSIGNED_AT_BIRTH_FIELD_NAME;
exports.SHORT_LOCALE_DISPLAY_NAMES = SHORT_LOCALE_DISPLAY_NAMES;
exports.STI_TEST_TYPES = STI_TEST_TYPES;
exports.US_STATES = US_STATES;
exports.US_TERRITORIES = US_TERRITORIES;
exports.addToIsoDateString = addToIsoDateString;
exports.appendQueryParams = appendQueryParams;
exports.calculateAge = calculateAge;
exports.clearBrowserStorage = clearBrowserStorage;
exports.convertObjectKeysToCamelCase = convertObjectKeysToCamelCase;
exports.convertObjectKeysToSnakeCase = convertObjectKeysToSnakeCase;
exports.createAddressFromPartialValues = createAddressFromPartialValues;
exports.createFakeReactQueryClient = createFakeReactQueryClient;
exports.extractDelimitedValues = extractDelimitedValues;
exports.formatAsE164 = formatAsE164;
exports.formatDate = formatDate;
exports.formatDateRange = formatDateRange;
exports.formatDateTime = formatDateTime;
exports.formatDateTimeWithTimeZone = formatDateTimeWithTimeZone;
exports.formatDateWithMonthAndYear = formatDateWithMonthAndYear;
exports.formatDateWithoutYear = formatDateWithoutYear;
exports.formatIsoDateStringDateRange = formatIsoDateStringDateRange;
exports.formatIsoDateStringForTable = formatIsoDateStringForTable;
exports.formatLongDate = formatLongDate;
exports.formatLongDateTimeWithTimeZone = formatLongDateTimeWithTimeZone;
exports.formatLongIsoDateString = formatLongIsoDateString;
exports.formatPhoneNumber = formatPhoneNumber;
exports.formatPhoneNumberWithMask = formatPhoneNumberWithMask;
exports.formatShortDate = formatShortDate;
exports.formatShortDateTime = formatShortDateTime;
exports.formatShortIsoDateString = formatShortIsoDateString;
exports.formatTime = formatTime;
exports.formatTimeWithTimeZone = formatTimeWithTimeZone;
exports.formatTimeZone = formatTimeZone;
exports.getAddressFieldOrder = getAddressFieldOrder;
exports.getAgeInMonthsFromBirthdayIsoDateString = getAgeInMonthsFromBirthdayIsoDateString;
exports.getAgeInYearsFromBirthdayIsoDateString = getAgeInYearsFromBirthdayIsoDateString;
exports.getCarrierOk = getCarrierOk;
exports.getCityLabel = getCityLabel;
exports.getCityMaxlen = getCityMaxlen;
exports.getCityWidth = getCityWidth;
exports.getCsrfCookieName = getCsrfCookieName;
exports.getCurrentLocaleFromCookies = getCurrentLocaleFromCookies;
exports.getCurrentPath = getCurrentPath;
exports.getDateFromIsoDateString = getDateFromIsoDateString;
exports.getDateFromTimeString = getDateFromTimeString;
exports.getDaysToDeliver = getDaysToDeliver;
exports.getDefaultPhoneNumber = getDefaultPhoneNumber;
exports.getEndOfDayFromIsoDateString = getEndOfDayFromIsoDateString;
exports.getEnvironment = getEnvironment;
exports.getEnvironmentOrDefault = getEnvironmentOrDefault;
exports.getError = getError;
exports.getFieldWidth = getFieldWidth;
exports.getFlagFilename = getFlagFilename;
exports.getFormattedDaysFromIsoDateStringDateRange = getFormattedDaysFromIsoDateStringDateRange;
exports.getFullName = getFullName;
exports.getHoursInMilliseconds = getHoursInMilliseconds;
exports.getInstrumentedApp = getInstrumentedApp;
exports.getInvalidEmailErrorMessage = getInvalidEmailErrorMessage;
exports.getIsoDateFieldsFromIsoDateString = getIsoDateFieldsFromIsoDateString;
exports.getIsoDateStringAfterToday = getIsoDateStringAfterToday;
exports.getIsoDateStringBeforeToday = getIsoDateStringBeforeToday;
exports.getIsoDateStringForToday = getIsoDateStringForToday;
exports.getIsoDateStringFromDate = getIsoDateStringFromDate;
exports.getIsoDateStringFromIsoDateFields = getIsoDateStringFromIsoDateFields;
exports.getIsoDateStringFromIsoLongDateTimeString = getIsoDateStringFromIsoLongDateTimeString;
exports.getIsoDateStringFromUsDateString = getIsoDateStringFromUsDateString;
exports.getLatestSentryEventId = getLatestSentryEventId;
exports.getMarketingUrl = getMarketingUrl;
exports.getName = getName;
exports.getNextSearchString = getNextSearchString;
exports.getOurGovtOk = getOurGovtOk;
exports.getOutboundServiceName = getOutboundServiceName;
exports.getOutboundShipperName = getOutboundShipperName;
exports.getPasswordStrength = getPasswordStrength;
exports.getPhoneMask = getPhoneMask;
exports.getPhonePrefix = getPhonePrefix;
exports.getPostalCodeLabel = getPostalCodeLabel;
exports.getPostalCodeMaxlen = getPostalCodeMaxlen;
exports.getPostalCodeWidth = getPostalCodeWidth;
exports.getQueryParam = getQueryParam;
exports.getQueryParams = getQueryParams;
exports.getRoles = getRoles;
exports.getSafeNextQueryParam = getSafeNextQueryParam;
exports.getSafeUrl = getSafeUrl;
exports.getSafeVerifyEmailNextUrlQueryParam = getSafeVerifyEmailNextUrlQueryParam;
exports.getShippingChargeCents = getShippingChargeCents;
exports.getStartOfDayFromIsoDateString = getStartOfDayFromIsoDateString;
exports.getStateLabel = getStateLabel;
exports.getStateMaxlen = getStateMaxlen;
exports.getStateWidth = getStateWidth;
exports.getTaxIdMaxlen = getTaxIdMaxlen;
exports.getTheirGovtOk = getTheirGovtOk;
exports.getUsDateStringFromIsoDateString = getUsDateStringFromIsoDateString;
exports.getValidLocale = getValidLocale;
exports.hasAddressFieldForCountry = hasAddressFieldForCountry;
exports.hasAnyRoles = hasAnyRoles;
exports.hasMinimumAge = hasMinimumAge;
exports.hasRole = hasRole;
exports.identifyAnalyticsUser = identifyAnalyticsUser;
exports.initMonitoring = initMonitoring;
exports.isAdult = isAdult;
exports.isBirthdayIsoDateStringAdultAge = isBirthdayIsoDateStringAdultAge;
exports.isBirthdayIsoDateStringAtLeastNYearsOld = isBirthdayIsoDateStringAtLeastNYearsOld;
exports.isCountryShippable = isCountryShippable;
exports.isDefined = isDefined;
exports.isEmailValid = isEmailValid;
exports.isEnvironmentCypressTest = isEnvironmentCypressTest;
exports.isEnvironmentLocal = isEnvironmentLocal;
exports.isEnvironmentLocalAndDevelopment = isEnvironmentLocalAndDevelopment;
exports.isEnvironmentProduction = isEnvironmentProduction;
exports.isEnvironmentStaging = isEnvironmentStaging;
exports.isEnvironmentTesting = isEnvironmentTesting;
exports.isInstanceOfIPhoneNumber = isInstanceOfIPhoneNumber;
exports.isIsoDateFieldsValid = isIsoDateFieldsValid;
exports.isIsoDateStringAfter = isIsoDateStringAfter;
exports.isIsoDateStringBefore = isIsoDateStringBefore;
exports.isIsoDateStringValid = isIsoDateStringValid;
exports.isObjKey = isObjKey;
exports.isRequiredFieldForCountryAddress = isRequiredFieldForCountryAddress;
exports.isUserAuthorized = isUserAuthorized;
exports.logAnalyticsPageView = logAnalyticsPageView;
exports.loggerUtils = loggerUtils;
exports.mergeQueryParam = mergeQueryParam;
exports.mergeQueryParams = mergeQueryParams;
exports.navigateAndRefreshBrowser = navigateAndRefreshBrowser;
exports.openNewBrowserTab = openNewBrowserTab;
exports.parsePhoneNumber = parsePhoneNumber;
exports.reactQueryClient = reactQueryClient;
exports.resetAnalyticsUser = resetAnalyticsUser;
exports.retry = retry;
exports.scrollIntoView = scrollIntoView;
exports.setMockPreferredLocale = setMockPreferredLocale;
exports.sortLocales = sortLocales;
exports.stripQueryParam = stripQueryParam;
exports.subtractFromIsoDateString = subtractFromIsoDateString;
exports.toIsoDateStringDateRange = toIsoDateStringDateRange;
exports.toQueryString = toQueryString;
exports.trackAnalyticsEvent = trackAnalyticsEvent;
exports.trimTrailingSlash = trimTrailingSlash;
exports.useAnalytics = useAnalytics;
exports.useAuthContext = useAuthContext;
exports.useAuthorization = useAuthorization;
exports.useCookiesContext = useCookiesContext;
exports.useDateFnsLocale = useDateFnsLocale;
exports.useIdentifyAnalyticsUser = useIdentifyAnalyticsUser;
exports.useLaunchDarklyUpdater = useLaunchDarklyUpdater;
exports.useLocalStorageState = useLocalStorageState;
exports.useLogPageViewUsingUniqueId = useLogPageViewUsingUniqueId;
exports.usePreferredLocale = usePreferredLocale;
exports.useQueryParamLocale = useQueryParamLocale;
exports.useReferrerContext = useReferrerContext;
exports.useSessionStorageReducer = useSessionStorageReducer;
exports.useSessionStorageState = useSessionStorageState;
exports.useUrlQueryParam = useUrlQueryParam;
exports.useUrlQueryParams = useUrlQueryParams;
exports.withDefaultProps = withDefaultProps;
//# sourceMappingURL=index.js.map
